import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Timestamp: any;
};

export type AddExternalUserInput = {
  email: Scalars['String'];
  sendEmail: Scalars['Boolean'];
};

export type AddUserInput = {
  companyRoleIDs?: InputMaybe<Array<Scalars['Int']>>;
  email: Scalars['String'];
  roleId: Scalars['Int'];
  sendEmail: Scalars['Boolean'];
};

export type AllowedIp = {
  __typename?: 'AllowedIp';
  description: Scalars['String'];
  id: Scalars['Int'];
  ip: Scalars['String'];
};

export type AllowedIpInput = {
  description: Scalars['String'];
  ip: Scalars['String'];
};

export type AllowedIpsResponse = {
  __typename?: 'AllowedIpsResponse';
  allowedIps: Maybe<Array<AllowedIp>>;
  isIpRestricted: Scalars['Boolean'];
};

export type Application = {
  __typename?: 'Application';
  applicationSteps: Array<ApplicationStep>;
  canceledRoomIds: Array<Scalars['Int']>;
  comment: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creatorId: Scalars['Int'];
  id: Scalars['Int'];
  isWaitingYourConfirmation: Scalars['Boolean'];
  notifiedUserEmails: Array<Scalars['String']>;
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']>;
  status: Scalars['String'];
  title: Scalars['String'];
  workflowId: Scalars['Int'];
};

export type ApplicationInput = {
  applicationSteps: Array<ApplicationStepInput>;
  comment?: InputMaybe<Scalars['String']>;
  notifiedUserEmails: Array<Scalars['String']>;
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']>;
  title: Scalars['String'];
  type: ApplicationType;
  workflowId: Scalars['Int'];
};

export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  application: Application;
};

export enum ApplicationStatus {
  ApprovalCanceled = 'approvalCanceled',
  Approved = 'approved',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Reviewing = 'reviewing',
  Waiting = 'waiting'
}

export type ApplicationStep = {
  __typename?: 'ApplicationStep';
  applicationStepConfirmations: Array<ApplicationStepConfirmation>;
  dueDate: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  multiApproverCondition: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stepNumber: Scalars['Int'];
};

export type ApplicationStepConfirmation = {
  __typename?: 'ApplicationStepConfirmation';
  comment: Maybe<Scalars['String']>;
  confirmedAt: Maybe<Scalars['String']>;
  confirmerId: Scalars['Int'];
  id: Scalars['Int'];
  isProxy: Scalars['Boolean'];
  status: Scalars['String'];
};

export type ApplicationStepConfirmationInput = {
  confirmerId: Scalars['Int'];
};

export type ApplicationStepInput = {
  confirmations: Array<ApplicationStepConfirmationInput>;
  dueDate: Scalars['String'];
  stepNumber: Scalars['Int'];
};

export enum ApplicationType {
  Order = 'order',
  Publish = 'publish'
}

export type ApplicationsResponse = {
  __typename?: 'ApplicationsResponse';
  applications: Array<Application>;
};

export type Asset = {
  __typename?: 'Asset';
  category: Scalars['String'];
  data: AssetData;
  externalLink: Scalars['String'];
  fileSize: Scalars['Int'];
  id: Scalars['Int'];
  meta: AssetMeta;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type AssetData = {
  __typename?: 'AssetData';
  thumbUrl: Scalars['String'];
  url: Scalars['String'];
};

export type AssetMeta = {
  __typename?: 'AssetMeta';
  UploadedWorksUserBy: Scalars['Int'];
  fileName: Maybe<Scalars['String']>;
  uploadedAt: Scalars['Int'];
};

export type AssetMetaInput = {
  fileName?: InputMaybe<Scalars['String']>;
  uploadedAt: Scalars['Int'];
};

export type AssignProjectInput = {
  id: Scalars['String'];
  roleId: Scalars['Int'];
};

export type AssignUserInput = {
  id: Scalars['Int'];
  isExternal: Scalars['Boolean'];
};

export type AssignUserProjectsInput = {
  isExternal: Scalars['Boolean'];
  projects: Array<InputMaybe<AssignProjectInput>>;
  sendAssignEmail: Scalars['Boolean'];
};

export type AssignUsersProjectsInput = {
  projectIds: Array<Scalars['String']>;
  roleId: Scalars['Int'];
  sendAssignEmail: Scalars['Boolean'];
  users: Array<AssignUserInput>;
};

export type AssignedProject = {
  __typename?: 'AssignedProject';
  adminUrl: Scalars['String'];
  assignedAt: Scalars['String'];
  id: Scalars['String'];
  isDeleting: Scalars['Boolean'];
  isWorksManaged: Scalars['Boolean'];
  presentationUrl: Scalars['String'];
  role: CompassRole;
  status: ProjectStatus;
  title: Scalars['String'];
};

export type AssingedUser = {
  __typename?: 'AssingedUser';
  assignedAt: Scalars['String'];
  companyRoles: Array<CompanyRole>;
  email: Scalars['String'];
  id: Scalars['Int'];
  isExternal: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  role: CompassRole;
};

export type AttributeMapping = {
  __typename?: 'AttributeMapping';
  department: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name: Maybe<Scalars['String']>;
};

export type AttributeMappingInput = {
  department?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  session: Session;
};

export type BulkUpdateRoomInput = {
  adminMemo?: InputMaybe<Scalars['String']>;
  floor: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  isSelectEnabled: Scalars['Boolean'];
  memo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  registrationDueDatetime?: InputMaybe<Scalars['String']>;
  roomTypeId: Scalars['Int'];
  selectMasters: Array<RoomSelectMasterInput>;
  wingId: Scalars['Int'];
};

export type BulkUpdateRoomsInput = {
  rooms: Array<BulkUpdateRoomInput>;
};

export type BulkUpdateSelectMastersInput = {
  selectMasters: Array<SelectMasterInput>;
};

export type BulkUpdateUserCancelDetailsInput = {
  userCancelDetails: Array<UserCancelDetailInput>;
};

export type BulkUpdateUserStageDetailsInput = {
  userStageDetails: Array<UserStageDetailInput>;
};

export type BulkUpdateWingsInput = {
  wings: Array<WingInput>;
};

export type CancelApplicationInput = {
  applicationId: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
};

export type CancelSelectAgreementInput = {
  roomIds: Array<Scalars['Int']>;
};

export type CheckLoginSettingPayload = {
  __typename?: 'CheckLoginSettingPayload';
  idpAuthURL: Maybe<Scalars['String']>;
  isIDPassEnabled: Scalars['Boolean'];
  isSAMLEnabled: Scalars['Boolean'];
  isSuperAdmin: Scalars['Boolean'];
};

export type CommonAssetInput = {
  externalLink?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  meta: AssetMetaInput;
  name?: InputMaybe<Scalars['String']>;
  priority: Scalars['Int'];
};

export type CommonPageInput = {
  annotation?: InputMaybe<Scalars['String']>;
  meta: PageMeta;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type CommonPageResponse = {
  __typename?: 'CommonPageResponse';
  annotation: Maybe<Scalars['String']>;
  assets: Array<Asset>;
  id: Scalars['Int'];
  meta: PageMetaResponse;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type CommonPagesResponse = {
  __typename?: 'CommonPagesResponse';
  commonPages: Array<CommonPageResponse>;
};

export type CompanyPolicy = {
  __typename?: 'CompanyPolicy';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  id: Scalars['Int'];
  isIDPassEnabled: Scalars['Boolean'];
  isSAMLEnabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CompanyRole = {
  __typename?: 'CompanyRole';
  id: Scalars['Int'];
  name: Scalars['String'];
  policyIds: Array<Scalars['Int']>;
  users: Array<UserIndex>;
};

export type CompanyRoleInput = {
  name: Scalars['String'];
  policyIds?: InputMaybe<Array<Scalars['Int']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CompanyRolesResponse = {
  __typename?: 'CompanyRolesResponse';
  roles: Maybe<Array<CompanyRole>>;
};

export type CompassRole = {
  __typename?: 'CompassRole';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type CompassUserInput = {
  compassRoleId: Scalars['Int'];
  isExternal: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export type ContractorHistoryActor = {
  __typename?: 'ContractorHistoryActor';
  companyRoleNames: Maybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  type: ContractorHistoryActorType;
};

export enum ContractorHistoryActorType {
  IamUser = 'iamUser',
  WorksUser = 'worksUser'
}

export type CreateApplicationPayload = {
  __typename?: 'CreateApplicationPayload';
  appliedRoomIds: Array<Scalars['Int']>;
};

export type CreateRoomsCsvHeaderMapping = {
  floorColumn: Scalars['String'];
  roomNameColumn: Scalars['String'];
  roomTypeNameColumn: Scalars['String'];
  selectDisabledColumn: Scalars['String'];
  wingNameColumn: Scalars['String'];
};

export type CreateRoomsCsvInput = {
  autoGenerateFloor: Scalars['Boolean'];
  autoGenerateWing: Scalars['Boolean'];
  csvData: Scalars['String'];
  csvHeaderMapping: CreateRoomsCsvHeaderMapping;
};

export type CreateRoomsCsvPayload = {
  __typename?: 'CreateRoomsCSVPayload';
  errorMessage: Scalars['String'];
  rooms: Array<CreatedRoom>;
};

export type CreatedRoom = {
  __typename?: 'CreatedRoom';
  floor: Scalars['String'];
  message: Scalars['String'];
  result: Scalars['String'];
  roomName: Scalars['String'];
  roomTypeName: Scalars['String'];
  selectDisabled: Scalars['Boolean'];
  wingName: Scalars['String'];
};

export type Creator = {
  __typename?: 'Creator';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum CustomError {
  NotFoundRoomToApply = 'notFoundRoomToApply'
}

export type CustomerProject = {
  __typename?: 'CustomerProject';
  createdAt: Scalars['String'];
  currentSignInAt: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inviterName: Maybe<Scalars['String']>;
  isRoomIamUser: Scalars['Boolean'];
  projectCustomerName: Maybe<Scalars['String']>;
  roomNames: Array<Maybe<Scalars['String']>>;
  title: Scalars['String'];
};

export type CustomerProjectsResponse = {
  __typename?: 'CustomerProjectsResponse';
  customerProjects: Array<CustomerProject>;
};

export type Details = {
  __typename?: 'Details';
  idpSignout: Scalars['String'];
  metadataFile: Maybe<Scalars['String']>;
  metadataFileName: Maybe<Scalars['String']>;
  metadataURL: Maybe<Scalars['String']>;
};

export type DiffRoom = {
  __typename?: 'DiffRoom';
  room: Room;
  type: DiffType;
};

export type DiffRoomsResponse = {
  __typename?: 'DiffRoomsResponse';
  rooms: Array<DiffRoom>;
};

export enum DiffType {
  Created = 'created',
  Deleted = 'deleted',
  Raw = 'raw',
  Updated = 'updated'
}

export type Editor = {
  __typename?: 'Editor';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EmailDomain = {
  __typename?: 'EmailDomain';
  allowedDomain: Scalars['String'];
  id: Scalars['Int'];
};

export type EmailDomainsResponse = {
  __typename?: 'EmailDomainsResponse';
  emailDomains: Array<Maybe<EmailDomain>>;
};

export type ExcludeRoomsFromOrderApplicationInput = {
  comment?: InputMaybe<Scalars['String']>;
  roomIds: Array<Scalars['Int']>;
};

export type ExcludeRoomsFromPublishApplicationInput = {
  comment?: InputMaybe<Scalars['String']>;
  roomIds: Array<Scalars['Int']>;
};

export type ExternalCompassUserInput = {
  userId: Scalars['Int'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projects: Maybe<Array<AssignedProject>>;
  updatedAt: Scalars['String'];
};

export type ExternalUserIndex = {
  __typename?: 'ExternalUserIndex';
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projectCount: Scalars['Int'];
};

export type ExternalUserResponse = {
  __typename?: 'ExternalUserResponse';
  user: ExternalUser;
};

export type ExternalUsersResponse = {
  __typename?: 'ExternalUsersResponse';
  pagination: Pagination;
  users: Maybe<Array<ExternalUserIndex>>;
};

export type ForceUpdatePasswordInput = {
  password: Scalars['String'];
  sendEmail: Scalars['Boolean'];
};

export type ForgetPasswordInput = {
  email: Scalars['String'];
};

export type GroupingRoom = {
  __typename?: 'GroupingRoom';
  groupingKey: Scalars['String'];
  id: Scalars['Int'];
};

export type GroupingRoomsResponse = {
  __typename?: 'GroupingRoomsResponse';
  rooms: Array<GroupingRoom>;
};

export type Identification = {
  __typename?: 'Identification';
  code: Maybe<Scalars['String']>;
  status: IdentificationStatus;
};

export enum IdentificationStatus {
  Approved = 'approved',
  Issued = 'issued',
  Waiting = 'waiting'
}

export enum ImportJobStatus {
  Failed = 'failed',
  PartFailed = 'part_failed',
  Processing = 'processing',
  Successful = 'successful'
}

export type ImportOptoutInput = {
  jobId: Scalars['String'];
  s3URL: Scalars['String'];
};

export type ImportOptoutJobPartFailedError = {
  __typename?: 'ImportOptoutJobPartFailedError';
  message: Scalars['String'];
  row: Scalars['Int'];
};

export type ImportOptoutJobResponse = {
  __typename?: 'ImportOptoutJobResponse';
  failedError: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
  partFailedAbnormalErrorCount: Maybe<Scalars['Int']>;
  partFailedError: Maybe<Array<ImportOptoutJobPartFailedError>>;
  partFailedNormalErrorCount: Maybe<Scalars['Int']>;
  partFailedTotalCount: Maybe<Scalars['Int']>;
  rowCount: Scalars['Int'];
  status: ImportJobStatus;
  updatedAt: Scalars['String'];
};

export type ImportRoomUsersInput = {
  jobId: Scalars['String'];
  s3URL: Scalars['String'];
};

export type ImportRoomUsersJobErrorDetail = {
  __typename?: 'ImportRoomUsersJobErrorDetail';
  line: Scalars['Int'];
  message: Scalars['String'];
};

export type ImportRoomUsersJobResponse = {
  __typename?: 'ImportRoomUsersJobResponse';
  errorDetails: Maybe<Array<ImportRoomUsersJobErrorDetail>>;
  errorMessage: Maybe<Scalars['String']>;
  errorReportS3Url: Maybe<Scalars['String']>;
  jobId: Scalars['String'];
  lineCount: Scalars['Int'];
  status: ImportJobStatus;
  updatedAt: Scalars['String'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LogoutInput = {
  refreshToken: Scalars['String'];
};

export type MainContent = {
  __typename?: 'MainContent';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MasterDataResponse = {
  __typename?: 'MasterDataResponse';
  companyPolicies: Maybe<Array<Maybe<CompanyPolicy>>>;
  worksRoles: Maybe<Array<Maybe<WorksRole>>>;
};

export type Meta = {
  __typename?: 'Meta';
  createdAt: Scalars['String'];
  createdBy: Editor;
  updatedAt: Scalars['String'];
  updatedBy: Editor;
};

export type Metadata = {
  metadataFile?: InputMaybe<Scalars['String']>;
  metadataFileName?: InputMaybe<Scalars['String']>;
  metadataURL?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExternalUser: Maybe<Scalars['Boolean']>;
  addUser: Maybe<Scalars['Boolean']>;
  assignUserProjects: Maybe<Scalars['Boolean']>;
  assignUsersProjects: Maybe<Scalars['Boolean']>;
  bulkUpdateRooms: Maybe<Scalars['Boolean']>;
  bulkUpdateSelectMasters: Maybe<Scalars['Boolean']>;
  bulkUpdateUserCancelDetails: UserCancelDetailsResponse;
  bulkUpdateUserStageDetails: UserStageDetailsResponse;
  bulkUpdateWings: Maybe<Scalars['Boolean']>;
  cancelApplication: Maybe<Scalars['Boolean']>;
  cancelSelectAgreement: Maybe<Scalars['Boolean']>;
  checkLoginSetting: CheckLoginSettingPayload;
  copySelectMaster: Maybe<Scalars['Boolean']>;
  createAllowedIp: Maybe<Scalars['Boolean']>;
  createApplication: CreateApplicationPayload;
  createCommonAsset: Maybe<Scalars['Boolean']>;
  createCommonPage: Maybe<Scalars['Boolean']>;
  createCompanyRole: Maybe<Scalars['Boolean']>;
  createProject: Maybe<Scalars['String']>;
  createRoomsCSV: Maybe<CreateRoomsCsvPayload>;
  createSAMLIdp: Maybe<Scalars['Boolean']>;
  createSelectMaster: Maybe<Scalars['Boolean']>;
  createWorkflow: Maybe<Scalars['Boolean']>;
  deleteAllowedIp: Maybe<Scalars['Boolean']>;
  deleteCommonAsset: Maybe<Scalars['Boolean']>;
  deleteCommonPage: Maybe<Scalars['Boolean']>;
  deleteCompanyRole: Maybe<Scalars['Boolean']>;
  deleteCustomer: Maybe<Scalars['Boolean']>;
  deleteProject: Maybe<Scalars['String']>;
  deleteRoom: Maybe<Scalars['Boolean']>;
  deleteSAMLIdp: Maybe<Scalars['Boolean']>;
  deleteSelectMaster: Maybe<Scalars['Boolean']>;
  deleteUser: Maybe<Scalars['Boolean']>;
  deleteWorkflow: Maybe<Scalars['Boolean']>;
  destroyRoomUser: Maybe<Scalars['Boolean']>;
  exchangeAuthCodeWithAccessToken: Maybe<AuthPayload>;
  excludeRoomsFromOrderApplication: Maybe<Scalars['Boolean']>;
  excludeRoomsFromPublishApplication: Maybe<Scalars['Boolean']>;
  forceUpdateExternalUserPassword: Maybe<Scalars['Boolean']>;
  forceUpdateUserPassword: Maybe<Scalars['Boolean']>;
  forgetPassword: Maybe<Scalars['Boolean']>;
  importOptout: Maybe<Scalars['Boolean']>;
  importRoomUsers: Maybe<Scalars['Boolean']>;
  login: Maybe<AuthPayload>;
  logout: Maybe<Scalars['Boolean']>;
  presignedURLOptoutImport: PresignedUrlPayload;
  presignedURLRoomUsersImport: PresignedUrlPayload;
  refreshAccessToken: Maybe<AuthPayload>;
  registerRoomUser: Maybe<Scalars['Boolean']>;
  registerSelects: Maybe<Scalars['Boolean']>;
  relateUsersToCompass: RelateUsersToCompassPayload;
  reorderCommonAssets: Maybe<Scalars['Boolean']>;
  reorderCommonPages: Maybe<Scalars['Boolean']>;
  sendSelectEmails: Maybe<Scalars['Boolean']>;
  sendTmpPassword: SendTmpPasswordPayload;
  setupCompany: SetupCompanyPayload;
  switchCompanyWorksCustomRole: Maybe<Scalars['Boolean']>;
  updateAllowedIp: Maybe<Scalars['Boolean']>;
  updateApplicationStepConfirmation: Maybe<Scalars['Boolean']>;
  updateCommonAsset: Maybe<Scalars['Boolean']>;
  updateCommonPage: Maybe<Scalars['Boolean']>;
  updateCompanyAuthMethod: Maybe<Scalars['Boolean']>;
  updateCompanyRole: Maybe<Scalars['Boolean']>;
  updateCompassRole: Maybe<Scalars['Boolean']>;
  updateExternalUserName: Maybe<Scalars['Boolean']>;
  updateImportOptoutJob: Maybe<Scalars['Boolean']>;
  updateInitPassword: Maybe<Scalars['Boolean']>;
  updateInternalUserName: Maybe<Scalars['Boolean']>;
  updateIpRestriction: Maybe<Scalars['Boolean']>;
  updatePassword: Maybe<Scalars['Boolean']>;
  updateProfileName: Maybe<Scalars['Boolean']>;
  updateProject: Maybe<Scalars['String']>;
  updateProjectShowCommonPage: Maybe<Scalars['Boolean']>;
  updateRoom: Maybe<Scalars['Boolean']>;
  updateRoomUserConfirmationCode: Maybe<Scalars['Boolean']>;
  updateRoomsPriority: Maybe<Scalars['Boolean']>;
  updateSAMLIdp: Maybe<Scalars['Boolean']>;
  updateSelectMaster: Maybe<Scalars['Boolean']>;
  updateSelectMasterPriorities: Maybe<Scalars['Boolean']>;
  updateUserCompanyRoles: Maybe<Scalars['Boolean']>;
  updateUserKeywords: Maybe<Scalars['Boolean']>;
  updateWorksRole: Maybe<Scalars['Boolean']>;
};


export type MutationAddExternalUserArgs = {
  params: AddExternalUserInput;
};


export type MutationAddUserArgs = {
  params: AddUserInput;
};


export type MutationAssignUserProjectsArgs = {
  params: AssignUserProjectsInput;
  userId: Scalars['Int'];
};


export type MutationAssignUsersProjectsArgs = {
  params: AssignUsersProjectsInput;
};


export type MutationBulkUpdateRoomsArgs = {
  params: BulkUpdateRoomsInput;
  projectId: Scalars['String'];
};


export type MutationBulkUpdateSelectMastersArgs = {
  params: BulkUpdateSelectMastersInput;
  projectId: Scalars['String'];
};


export type MutationBulkUpdateUserCancelDetailsArgs = {
  params: BulkUpdateUserCancelDetailsInput;
};


export type MutationBulkUpdateUserStageDetailsArgs = {
  params: BulkUpdateUserStageDetailsInput;
};


export type MutationBulkUpdateWingsArgs = {
  params: BulkUpdateWingsInput;
  projectId: Scalars['String'];
};


export type MutationCancelApplicationArgs = {
  params: CancelApplicationInput;
};


export type MutationCancelSelectAgreementArgs = {
  params: CancelSelectAgreementInput;
  projectId: Scalars['String'];
};


export type MutationCheckLoginSettingArgs = {
  email: Scalars['String'];
};


export type MutationCopySelectMasterArgs = {
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
};


export type MutationCreateAllowedIpArgs = {
  params: AllowedIpInput;
};


export type MutationCreateApplicationArgs = {
  params: ApplicationInput;
};


export type MutationCreateCommonAssetArgs = {
  commonPageId: Scalars['Int'];
  params: CommonAssetInput;
};


export type MutationCreateCommonPageArgs = {
  params: CommonPageInput;
};


export type MutationCreateCompanyRoleArgs = {
  params: CompanyRoleInput;
};


export type MutationCreateProjectArgs = {
  params: ProjectInput;
};


export type MutationCreateRoomsCsvArgs = {
  params: CreateRoomsCsvInput;
  projectId: Scalars['String'];
};


export type MutationCreateSamlIdpArgs = {
  companyId: Scalars['Int'];
  params: SamlIdpInput;
};


export type MutationCreateSelectMasterArgs = {
  params: SelectMasterInput;
  projectId: Scalars['String'];
};


export type MutationCreateWorkflowArgs = {
  params: WorkflowInput;
};


export type MutationDeleteAllowedIpArgs = {
  allowedIpId: Scalars['Int'];
};


export type MutationDeleteCommonAssetArgs = {
  commonAssetId: Scalars['Int'];
  commonPageId: Scalars['Int'];
};


export type MutationDeleteCommonPageArgs = {
  commonPageId: Scalars['Int'];
};


export type MutationDeleteCompanyRoleArgs = {
  roleId: Scalars['Int'];
};


export type MutationDeleteCustomerArgs = {
  email: Scalars['String'];
};


export type MutationDeleteProjectArgs = {
  projectId: Scalars['String'];
};


export type MutationDeleteRoomArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type MutationDeleteSamlIdpArgs = {
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
};


export type MutationDeleteSelectMasterArgs = {
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['Int'];
};


export type MutationDeleteWorkflowArgs = {
  workflowId: Scalars['Int'];
};


export type MutationDestroyRoomUserArgs = {
  iamUserId: Scalars['Int'];
  roomId: Scalars['Int'];
};


export type MutationExchangeAuthCodeWithAccessTokenArgs = {
  code: Scalars['String'];
};


export type MutationExcludeRoomsFromOrderApplicationArgs = {
  params: ExcludeRoomsFromOrderApplicationInput;
  projectId: Scalars['String'];
};


export type MutationExcludeRoomsFromPublishApplicationArgs = {
  params: ExcludeRoomsFromPublishApplicationInput;
  projectId: Scalars['String'];
};


export type MutationForceUpdateExternalUserPasswordArgs = {
  params: ForceUpdatePasswordInput;
  userId: Scalars['Int'];
};


export type MutationForceUpdateUserPasswordArgs = {
  params: ForceUpdatePasswordInput;
  userId: Scalars['Int'];
};


export type MutationForgetPasswordArgs = {
  params: ForgetPasswordInput;
};


export type MutationImportOptoutArgs = {
  params: ImportOptoutInput;
};


export type MutationImportRoomUsersArgs = {
  params: ImportRoomUsersInput;
};


export type MutationLoginArgs = {
  params: LoginInput;
};


export type MutationLogoutArgs = {
  params: LogoutInput;
};


export type MutationRefreshAccessTokenArgs = {
  params: RefreshAccessTokenInput;
};


export type MutationRegisterRoomUserArgs = {
  params: RegisterRoomUserInput;
};


export type MutationRegisterSelectsArgs = {
  params: RegisterSelectsInput;
  projectId: Scalars['String'];
};


export type MutationRelateUsersToCompassArgs = {
  params: RelateUsersToCompassInput;
};


export type MutationReorderCommonAssetsArgs = {
  commonPageId: Scalars['Int'];
  params: ReorderCommonAssetInput;
};


export type MutationReorderCommonPagesArgs = {
  params: ReorderCommonPageInput;
};


export type MutationSendSelectEmailsArgs = {
  params: SendSelectEmailsInput;
  projectId: Scalars['String'];
};


export type MutationSendTmpPasswordArgs = {
  params: SendTmpPasswordInput;
};


export type MutationSetupCompanyArgs = {
  params: SetupCompanyInput;
};


export type MutationSwitchCompanyWorksCustomRoleArgs = {
  apiKey: Scalars['String'];
  companyId: Scalars['Int'];
};


export type MutationUpdateAllowedIpArgs = {
  allowedIpId: Scalars['Int'];
  params: AllowedIpInput;
};


export type MutationUpdateApplicationStepConfirmationArgs = {
  params: UpdateApplicationStepConfirmationInput;
};


export type MutationUpdateCommonAssetArgs = {
  commonAssetId: Scalars['Int'];
  commonPageId: Scalars['Int'];
  params: CommonAssetInput;
};


export type MutationUpdateCommonPageArgs = {
  commonPageId: Scalars['Int'];
  params: CommonPageInput;
};


export type MutationUpdateCompanyAuthMethodArgs = {
  companyId: Scalars['Int'];
  params: UpdateCompanyAuthMethodInput;
};


export type MutationUpdateCompanyRoleArgs = {
  params: CompanyRoleInput;
  roleId: Scalars['Int'];
};


export type MutationUpdateCompassRoleArgs = {
  params: UpdateCompassRoleInput;
};


export type MutationUpdateExternalUserNameArgs = {
  name: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateImportOptoutJobArgs = {
  params: UpdateImportOptoutJobInput;
};


export type MutationUpdateInitPasswordArgs = {
  params: UpdateInitPasswordInput;
};


export type MutationUpdateInternalUserNameArgs = {
  name: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateIpRestrictionArgs = {
  params: UpdateIpRestrictionInput;
};


export type MutationUpdatePasswordArgs = {
  params: UpdatePasswordInput;
};


export type MutationUpdateProfileNameArgs = {
  name: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  params: ProjectInput;
  projectId: Scalars['String'];
};


export type MutationUpdateProjectShowCommonPageArgs = {
  params: ProjectShowCommonPageInput;
  projectId: Scalars['String'];
};


export type MutationUpdateRoomArgs = {
  params: RoomInput;
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type MutationUpdateRoomUserConfirmationCodeArgs = {
  params: UpdateRoomUserConfirmationCodeInput;
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type MutationUpdateRoomsPriorityArgs = {
  prioritizedRoomIds: Array<Scalars['Int']>;
  projectId: Scalars['String'];
};


export type MutationUpdateSamlIdpArgs = {
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
  params: SamlIdpInput;
};


export type MutationUpdateSelectMasterArgs = {
  params: SelectMasterInput;
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
};


export type MutationUpdateSelectMasterPrioritiesArgs = {
  projectId: Scalars['String'];
  selectMasterIds: Array<Scalars['Int']>;
};


export type MutationUpdateUserCompanyRolesArgs = {
  params: UpdateCompanyRolesInput;
  userId: Scalars['Int'];
};


export type MutationUpdateUserKeywordsArgs = {
  params: UpdateUserKeywordsInput;
  userId: Scalars['Int'];
};


export type MutationUpdateWorksRoleArgs = {
  params: UpdateWorksRoleInput;
};

export type MyReviewingConfirmation = {
  __typename?: 'MyReviewingConfirmation';
  applicationCreatedAt: Scalars['String'];
  applicationCreatorId: Scalars['Int'];
  applicationId: Scalars['Int'];
  applicationTitle: Scalars['String'];
  applicationType: ApplicationType;
  applicationWorkflowName: Scalars['String'];
  dueDate: Scalars['String'];
  id: Scalars['Int'];
  projectId: Scalars['String'];
  projectName: Scalars['String'];
};

export type MyReviewingConfirmationsResponse = {
  __typename?: 'MyReviewingConfirmationsResponse';
  confirmations: Array<MyReviewingConfirmation>;
};

export type OgpImageResponse = {
  __typename?: 'OgpImageResponse';
  url: Scalars['String'];
};

export type PageMeta = {
  designFormat: Scalars['String'];
  displayConsumer: Scalars['Boolean'];
  icon: Scalars['Int'];
  isPublic: Scalars['Boolean'];
};

export type PageMetaResponse = {
  __typename?: 'PageMetaResponse';
  designFormat: Scalars['String'];
  displayConsumer: Scalars['Boolean'];
  icon: Scalars['Int'];
  isPublic: Scalars['Boolean'];
};

export type Pagination = {
  __typename?: 'Pagination';
  current: Scalars['Int'];
  limitValue: Scalars['Int'];
  next: Scalars['Int'];
  pageCount: Scalars['Int'];
  previous: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PresignedUrlPayload = {
  __typename?: 'PresignedURLPayload';
  jobId: Scalars['String'];
  presignedURL: Scalars['String'];
  s3URL: Scalars['String'];
};

export type ProfileResponse = {
  __typename?: 'ProfileResponse';
  user: ProfileUser;
};

export type ProfileUser = {
  __typename?: 'ProfileUser';
  companyPolicies: Maybe<Array<CompanyPolicy>>;
  companyRoles: Maybe<Array<CompanyRole>>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  isResetPassword: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  policies: Maybe<Array<Scalars['String']>>;
  projects: Maybe<Array<AssignedProject>>;
  role: WorksRole;
  roleId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type Project = {
  __typename?: 'Project';
  address: Maybe<Scalars['String']>;
  adminUrl: Scalars['String'];
  applicationCount: Maybe<Scalars['Int']>;
  averagePriceRange: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  code: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  email: Maybe<Scalars['String']>;
  emailDisplayName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleting: Scalars['Boolean'];
  isWorksManaged: Scalars['Boolean'];
  mainContents: Maybe<Array<MainContent>>;
  planCount: Maybe<Scalars['Int']>;
  prefecture: Scalars['String'];
  presentationUrl: Scalars['String'];
  purchaserCount: Maybe<Scalars['Int']>;
  roomCount: Maybe<Scalars['Int']>;
  showCommonPage: Scalars['Boolean'];
  status: ProjectStatus;
  structureCount: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  totalPvCount: Scalars['Int'];
  totalSessionCount: Scalars['Int'];
  updatedAt: Scalars['String'];
  users: Maybe<Array<AssingedUser>>;
  zipcode: Maybe<Scalars['String']>;
};

export type ProjectCountHistory = {
  __typename?: 'ProjectCountHistory';
  activatedCount: Scalars['Int'];
  month: Scalars['String'];
};

export type ProjectIndex = {
  __typename?: 'ProjectIndex';
  adminUrl: Scalars['String'];
  applicationCount: Maybe<Scalars['Int']>;
  averagePriceRange: Maybe<Scalars['Int']>;
  code: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  creator: Creator;
  id: Scalars['String'];
  isDeleting: Scalars['Boolean'];
  isWorksManaged: Scalars['Boolean'];
  planCount: Maybe<Scalars['Int']>;
  prefecture: Scalars['String'];
  presentationUrl: Scalars['String'];
  purchaserCount: Maybe<Scalars['Int']>;
  roomCount: Maybe<Scalars['Int']>;
  status: ProjectStatus;
  structureCount: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ProjectInput = {
  address?: InputMaybe<Scalars['String']>;
  averagePriceRange?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  compassUsers?: InputMaybe<Array<CompassUserInput>>;
  email?: InputMaybe<Scalars['String']>;
  emailDisplayName?: InputMaybe<Scalars['String']>;
  planCount?: InputMaybe<Scalars['Int']>;
  prefecture: Scalars['String'];
  projectStatusName: Scalars['String'];
  roomCount?: InputMaybe<Scalars['Int']>;
  sendAssignEmail: Scalars['Boolean'];
  structureCount?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  zipcode?: InputMaybe<Scalars['String']>;
};

export type ProjectResponse = {
  __typename?: 'ProjectResponse';
  project: Project;
};

export type ProjectShowCommonPageInput = {
  showCommonPage: Scalars['Boolean'];
};

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  displayName: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type ProjectStatusesResponse = {
  __typename?: 'ProjectStatusesResponse';
  projectStatuses: Array<ProjectStatus>;
};

export type ProjectSummaryResponse = {
  __typename?: 'ProjectSummaryResponse';
  projectCountHistories: Maybe<Array<ProjectCountHistory>>;
};

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  pagination: Pagination;
  projects: Maybe<Array<ProjectIndex>>;
};

export type Query = {
  __typename?: 'Query';
  allRoomSelectRegistrations: RoomSelectRegistrationsResponse;
  allowedIps: AllowedIpsResponse;
  application: ApplicationResponse;
  applications: ApplicationsResponse;
  cachedRooms: RoomsResponse;
  commonPage: CommonPageResponse;
  commonPages: CommonPagesResponse;
  company: CompanyResponse;
  companyRoles: CompanyRolesResponse;
  compassRoles: CompassRolesResponse;
  customerProjects: CustomerProjectsResponse;
  diffRooms: DiffRoomsResponse;
  emailDomains: EmailDomainsResponse;
  externalUser: ExternalUserResponse;
  externalUsers: ExternalUsersResponse;
  groupingRooms: GroupingRoomsResponse;
  latestImportOptoutJob: ImportOptoutJobResponse;
  latestImportRoomUsersJob: ImportRoomUsersJobResponse;
  masterData: MasterDataResponse;
  myReviewingConfirmations: MyReviewingConfirmationsResponse;
  ogpImage: OgpImageResponse;
  profile: ProfileResponse;
  project: ProjectResponse;
  projectStatuses: ProjectStatusesResponse;
  projectSummary: ProjectSummaryResponse;
  projects: ProjectsResponse;
  roomApplicationStatus: RoomApplicationStatusResponse;
  roomSelectMasters: RoomSelectMastersResponse;
  roomSelectRegistrations: RoomSelectRegistrationsResponse;
  roomTypes: RoomTypesResponse;
  rooms: RoomsResponse;
  samlIdp: SamlIdpResponse;
  selectContractorHistories: SelectContractorHistoriesResponse;
  selectMasters: SelectMastersResponse;
  selectRegistrations: SelectRegistrationsResponse;
  selects: SelectsResponse;
  user: UserResponse;
  userCancelDetailUsageCheck: UserCancelDetailUsageCheckResponse;
  userCancelDetails: UserCancelDetailsResponse;
  userStageDetailUsageCheck: UserStageDetailUsageCheckResponse;
  userStageDetails: UserStageDetailsResponse;
  users: UsersResponse;
  wings: WingsResponse;
  workflows: WorkflowsResponse;
};


export type QueryAllRoomSelectRegistrationsArgs = {
  projectId: Scalars['String'];
};


export type QueryApplicationArgs = {
  id: Scalars['Int'];
};


export type QueryApplicationsArgs = {
  projectId: Scalars['String'];
};


export type QueryCachedRoomsArgs = {
  projectId: Scalars['String'];
};


export type QueryCommonPageArgs = {
  id: Scalars['Int'];
};


export type QueryCustomerProjectsArgs = {
  email: Scalars['String'];
};


export type QueryDiffRoomsArgs = {
  projectId: Scalars['String'];
};


export type QueryExternalUserArgs = {
  id: Scalars['Int'];
};


export type QueryGroupingRoomsArgs = {
  projectId: Scalars['String'];
};


export type QueryOgpImageArgs = {
  url: Scalars['String'];
};


export type QueryProjectArgs = {
  id: Scalars['String'];
};


export type QueryRoomApplicationStatusArgs = {
  params: InputMaybe<RoomApplicationStatusInput>;
};


export type QueryRoomSelectMastersArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type QueryRoomSelectRegistrationsArgs = {
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']>;
};


export type QueryRoomTypesArgs = {
  projectId: Scalars['String'];
};


export type QueryRoomsArgs = {
  projectId: Scalars['String'];
};


export type QuerySelectContractorHistoriesArgs = {
  roomId: Scalars['Int'];
};


export type QuerySelectMastersArgs = {
  projectId: Scalars['String'];
};


export type QuerySelectRegistrationsArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type QuerySelectsArgs = {
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUserCancelDetailUsageCheckArgs = {
  userCancelDetailId: Scalars['Int'];
};


export type QueryUserStageDetailUsageCheckArgs = {
  userStageDetailId: Scalars['Int'];
};


export type QueryWingsArgs = {
  projectId: Scalars['String'];
};

export type RefreshAccessTokenInput = {
  cognitoUsername: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type RegisterRoomUserInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  roomId: Scalars['Int'];
};

export type RegisterSelectsInput = {
  roomId: Scalars['Int'];
  selects: Array<SelectInput>;
};

export type RegisteredSelectOption = {
  __typename?: 'RegisteredSelectOption';
  child: Maybe<RegisteredSelectOptionChild>;
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RegisteredSelectOptionChild = {
  __typename?: 'RegisteredSelectOptionChild';
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RelateUsersToCompassFailedUser = {
  __typename?: 'RelateUsersToCompassFailedUser';
  email: Scalars['String'];
  message: Scalars['String'];
};

export type RelateUsersToCompassInput = {
  apiKey: Scalars['String'];
  usersInput: Array<UserInput>;
  worksCompanyId: Scalars['Int'];
  worksRoleName: Scalars['String'];
};

export type RelateUsersToCompassPayload = {
  __typename?: 'RelateUsersToCompassPayload';
  failedUsers: Maybe<Array<RelateUsersToCompassFailedUser>>;
  successUsers: Maybe<Array<RelateUsersToCompassSuccessUser>>;
};

export type RelateUsersToCompassSuccessUser = {
  __typename?: 'RelateUsersToCompassSuccessUser';
  email: Scalars['String'];
  tmpPassword: Scalars['String'];
};

export type ReorderCommonAssetInput = {
  commonAssetsPriorities: Array<Scalars['Int']>;
};

export type ReorderCommonPageInput = {
  commonPagesPriorities: Array<Scalars['Int']>;
};

export type Room = {
  __typename?: 'Room';
  adminMemo: Maybe<Scalars['String']>;
  confirmationCode: Maybe<Scalars['String']>;
  floor: Scalars['String'];
  id: Scalars['Int'];
  isEnableCancelOrderApplication: Scalars['Boolean'];
  isEnableCancelPublishApplication: Scalars['Boolean'];
  isEnableCancelSelectAgreement: Scalars['Boolean'];
  isEnableChangeToUnselectable: Scalars['Boolean'];
  isEnableExcludeRoomsFromOrderApplication: Scalars['Boolean'];
  isEnableExcludeRoomsFromPublishApplication: Scalars['Boolean'];
  isEnableOrderApplication: Scalars['Boolean'];
  isEnableProxySelectRegistration: Scalars['Boolean'];
  isEnablePublishApplication: Scalars['Boolean'];
  isEnableRoomUserDestroy: Scalars['Boolean'];
  isEnableRoomUserRegistration: Scalars['Boolean'];
  isEnableSelectEmailAgreementRequest: Scalars['Boolean'];
  isEnableSelectEmailInvitation: Scalars['Boolean'];
  isEnableUpdateConfirmationCode: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  isSelectEnabled: Scalars['Boolean'];
  memo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderApplicationCancelComment: Maybe<Scalars['String']>;
  orderApplicationCanceledAt: Maybe<Scalars['String']>;
  orderApplicationStatus: ApplicationStatus;
  priority: Scalars['Int'];
  publishApplicationStatus: ApplicationStatus;
  registrationDueDatetime: Scalars['String'];
  registrationStatus: SelectRegistrationStatus;
  roomTypeId: Maybe<Scalars['Int']>;
  roomTypeName: Maybe<Scalars['String']>;
  selectMasterIds: Array<Scalars['Int']>;
  source: RoomSourceType;
  user: Maybe<RoomUser>;
  wingId: Scalars['Int'];
  wingName: Scalars['String'];
};

export type RoomApplicationStatus = {
  __typename?: 'RoomApplicationStatus';
  orderApplicationStatus: ApplicationStatus;
  publishApplicationStatus: ApplicationStatus;
};

export type RoomApplicationStatusInput = {
  canceledOrderApplicationID?: InputMaybe<Scalars['Int']>;
  canceledPublishApplicationID?: InputMaybe<Scalars['Int']>;
  orderApplicationID?: InputMaybe<Scalars['Int']>;
  publishApplicationID?: InputMaybe<Scalars['Int']>;
  roomId: Scalars['Int'];
};

export type RoomApplicationStatusResponse = {
  __typename?: 'RoomApplicationStatusResponse';
  roomApplicationStatus: RoomApplicationStatus;
};

export type RoomInput = {
  adminMemo?: InputMaybe<Scalars['String']>;
  isSelectEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type RoomSelect = {
  __typename?: 'RoomSelect';
  id: Scalars['Int'];
  selects: Array<SelectRegistration>;
};

export type RoomSelectMaster = {
  __typename?: 'RoomSelectMaster';
  id: Scalars['Int'];
  selectOptionMasterIds: Array<Scalars['Int']>;
};

export type RoomSelectMasterInput = {
  id: Scalars['Int'];
  isDelete?: InputMaybe<Scalars['Boolean']>;
  selectOptionMasterIds: Array<Scalars['Int']>;
};

export type RoomSelectMastersResponse = {
  __typename?: 'RoomSelectMastersResponse';
  selectMasters: Array<RoomSelectMaster>;
};

export type RoomSelectRegistrationsResponse = {
  __typename?: 'RoomSelectRegistrationsResponse';
  rooms: Array<RoomSelect>;
};

export type RoomType = {
  __typename?: 'RoomType';
  compassRoomCount: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  worksRoomIds: Maybe<Array<Scalars['Int']>>;
};

export type RoomTypeInput = {
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type RoomTypesResponse = {
  __typename?: 'RoomTypesResponse';
  roomTypes: Array<RoomType>;
};

export type RoomUser = {
  __typename?: 'RoomUser';
  agreementRequestEmailSentTimes: Scalars['Int'];
  email: Scalars['String'];
  id: Scalars['Int'];
  identification: Identification;
  lastAgreementRequestEmailSentAt: Maybe<Scalars['String']>;
  lastSelectEmailSentAt: Maybe<Scalars['String']>;
  name: Scalars['String'];
  selectEmailSentTimes: Scalars['Int'];
};

export type RoomsResponse = {
  __typename?: 'RoomsResponse';
  rooms: Array<Room>;
};

export type SamlIdp = {
  __typename?: 'SAMLIdp';
  attributeMapping: AttributeMapping;
  id: Scalars['Int'];
  idpSignout: Scalars['Boolean'];
  metadataFile: Maybe<Scalars['String']>;
  metadataFileName: Maybe<Scalars['String']>;
  metadataURL: Maybe<Scalars['String']>;
};

export type SamlIdpInput = {
  attributeMapping: AttributeMappingInput;
  idpSignout: Scalars['Boolean'];
  metadata: Metadata;
};

export type SamlIdpResponse = {
  __typename?: 'SAMLIdpResponse';
  assertionConsumerServiceURL: Scalars['String'];
  samlIdp: Maybe<SamlIdp>;
  serviceProviderURN: Scalars['String'];
};

export type Select = {
  __typename?: 'Select';
  annotation: Scalars['String'];
  assignments: Maybe<SelectMasterAssignments>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  file: Maybe<SelectMasterFile>;
  id: Scalars['Int'];
  isPlanSelect: Scalars['Boolean'];
  modelRoomInfo: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  selectMasterId: Scalars['Int'];
  selectOptions: Array<SelectOption>;
};

export type SelectContractorHistoriesResponse = {
  __typename?: 'SelectContractorHistoriesResponse';
  histories: Array<SelectContractorHistory>;
};

export type SelectContractorHistory = {
  __typename?: 'SelectContractorHistory';
  action: Scalars['String'];
  actor: Maybe<ContractorHistoryActor>;
  timestamp: Scalars['String'];
};

export enum SelectEmailContent {
  AgreementRequest = 'agreementRequest',
  Invitation = 'invitation'
}

export type SelectInput = {
  id: Scalars['Int'];
  selectOptionIds: Array<Scalars['Int']>;
};

export type SelectMaster = {
  __typename?: 'SelectMaster';
  annotation: Maybe<Scalars['String']>;
  assignments: Maybe<SelectMasterAssignments>;
  description: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  file: Maybe<SelectMasterFile>;
  fileName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPlanSelect: Scalars['Boolean'];
  modelRoomInfo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  roomIds: Array<Scalars['Int']>;
  selectOptionMasters: Array<SelectOptionMaster>;
};

export type SelectMasterAssignments = {
  __typename?: 'SelectMasterAssignments';
  mainContents: Maybe<Array<Scalars['Int']>>;
};

export type SelectMasterAssignmentsInput = {
  mainContents: Array<Scalars['Int']>;
};

export type SelectMasterFile = {
  __typename?: 'SelectMasterFile';
  thumb: SelectMasterFileThumb;
  url: Scalars['String'];
};

export type SelectMasterFileThumb = {
  __typename?: 'SelectMasterFileThumb';
  url: Scalars['String'];
};

export type SelectMasterInput = {
  annotation?: InputMaybe<Scalars['String']>;
  assignments?: InputMaybe<SelectMasterAssignmentsInput>;
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  file?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  isPlanSelect: Scalars['Boolean'];
  isRemoveFile?: InputMaybe<Scalars['Boolean']>;
  modelRoomInfo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  selectOptionMasters: Array<SelectOptionMasterInput>;
};

export type SelectMastersResponse = {
  __typename?: 'SelectMastersResponse';
  selectMasters: Maybe<Array<SelectMaster>>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  annotation: Scalars['String'];
  children: Maybe<Array<SelectOption>>;
  file: Maybe<SelectMasterFile>;
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type SelectOptionMaster = {
  __typename?: 'SelectOptionMaster';
  annotation: Maybe<Scalars['String']>;
  children: Maybe<Array<SelectOptionMaster>>;
  file: Maybe<SelectMasterFile>;
  fileName: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPaid: Scalars['Boolean'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type SelectOptionMasterInput = {
  annotation?: InputMaybe<Scalars['String']>;
  children?: InputMaybe<Array<SelectOptionMasterInput>>;
  file?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isPaid: Scalars['Boolean'];
  isRemoveFile?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type SelectRegistration = {
  __typename?: 'SelectRegistration';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  registeredSelectOption: Maybe<RegisteredSelectOption>;
  selectMasterId: Scalars['Int'];
};

export enum SelectRegistrationStatus {
  Agreed = 'agreed',
  Registered = 'registered',
  Waiting = 'waiting'
}

export type SelectRegistrationsResponse = {
  __typename?: 'SelectRegistrationsResponse';
  selectRegistrations: Array<SelectRegistration>;
};

export type SelectsResponse = {
  __typename?: 'SelectsResponse';
  selects: Array<Select>;
};

export type SendTmpPasswordFailedUser = {
  __typename?: 'SendTmpPasswordFailedUser';
  email: Scalars['String'];
  message: Scalars['String'];
};

export type SendTmpPasswordInput = {
  apiKey: Scalars['String'];
  inviterName: Scalars['String'];
  users: Array<SendTmpPasswordUserInput>;
};

export type SendTmpPasswordPayload = {
  __typename?: 'SendTmpPasswordPayload';
  failedUsers: Maybe<Array<SendTmpPasswordFailedUser>>;
  successUserEmails: Maybe<Array<Scalars['String']>>;
};

export type SendTmpPasswordUserInput = {
  email: Scalars['String'];
  tmpPassword: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  accessToken: Scalars['String'];
  accessTokenExpiresAt: Scalars['String'];
  cognitoUsername: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpiresAt: Scalars['String'];
};

export type SetupCompanyInput = {
  apiKey: Scalars['String'];
  companyName: Scalars['String'];
  compassCompanyId: Scalars['Int'];
  userEmail: Scalars['String'];
  userName: Scalars['String'];
};

export type SetupCompanyPayload = {
  __typename?: 'SetupCompanyPayload';
  tmpPassword: Scalars['String'];
};

export type UpdateApplicationStepConfirmationInput = {
  applicationId: Scalars['Int'];
  applicationStepId: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
  isApproved: Scalars['Boolean'];
  isProxy: Scalars['Boolean'];
};

export type UpdateCompanyAuthMethodInput = {
  isIDPassEnabled: Scalars['Boolean'];
  isSAMLEnabled: Scalars['Boolean'];
};

export type UpdateCompanyRolesInput = {
  companyRoleIds: Array<Scalars['Int']>;
};

export type UpdateCompassRoleInput = {
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UpdateImportOptoutJobInput = {
  failedError: Scalars['String'];
  jobId: Scalars['String'];
  partFailedAbnormalErrorCount?: InputMaybe<Scalars['Int']>;
  partFailedError?: InputMaybe<Array<InputMaybe<UpdateImportOptoutJobPartFailedError>>>;
  partFailedNormalErrorCount?: InputMaybe<Scalars['Int']>;
  partFailedTotalCount?: InputMaybe<Scalars['Int']>;
  rowCount: Scalars['Int'];
  status: ImportJobStatus;
};

export type UpdateImportOptoutJobPartFailedError = {
  message: Scalars['String'];
  row: Scalars['Int'];
};

export type UpdateInitPasswordInput = {
  name: Scalars['String'];
  password: Scalars['String'];
};

export type UpdateIpRestrictionInput = {
  isIpRestricted: Scalars['Boolean'];
};

export type UpdatePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type UpdateRoomUserConfirmationCodeInput = {
  confirmationCode: Scalars['String'];
};

export type UpdateUserKeywordsInput = {
  keywords: Array<Scalars['String']>;
};

export type UpdateWorksRoleInput = {
  roleId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  companyRoles: Array<CompanyRole>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  isResetPassword: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projects: Maybe<Array<AssignedProject>>;
  role: WorksRole;
  roleId: Scalars['Int'];
  updatedAt: Scalars['String'];
};

export type UserCancelDetail = {
  __typename?: 'UserCancelDetail';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type UserCancelDetailInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type UserCancelDetailUsageCheckResponse = {
  __typename?: 'UserCancelDetailUsageCheckResponse';
  usageDetails: Array<UserCancelDetailUsageDetail>;
};

export type UserCancelDetailUsageDetail = {
  __typename?: 'UserCancelDetailUsageDetail';
  listingName: Scalars['String'];
  usedIn: Array<UserCancelDetailUsedIn>;
};

export enum UserCancelDetailUsedIn {
  AutoShare = 'auto_share',
  PurchaserCancel = 'purchaser_cancel',
  PurchaserSearch = 'purchaser_search'
}

export type UserCancelDetailValidationError = {
  __typename?: 'UserCancelDetailValidationError';
  id: Scalars['Int'];
  listingName: Scalars['String'];
  usedIn: Array<UserCancelDetailUsedIn>;
};

export type UserCancelDetailsResponse = {
  __typename?: 'UserCancelDetailsResponse';
  meta: Meta;
  userCancelDetails: Array<UserCancelDetail>;
};

export type UserIndex = {
  __typename?: 'UserIndex';
  companyRoles: Array<CompanyRole>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['Int'];
  isResetPassword: Scalars['Boolean'];
  keywords: Array<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  projectCount: Scalars['Int'];
  role: WorksRole;
  roleId: Scalars['Int'];
};

export type UserInput = {
  email: Scalars['String'];
  isInternal: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UserResponse = {
  __typename?: 'UserResponse';
  user: User;
};

export type UserStage = {
  __typename?: 'UserStage';
  id: Scalars['Int'];
  priority: Scalars['Int'];
  stage: Scalars['String'];
  userStageDetails: Array<UserStageDetail>;
};

export type UserStageDetail = {
  __typename?: 'UserStageDetail';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type UserStageDetailInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  userStageId?: InputMaybe<Scalars['Int']>;
};

export type UserStageDetailUsageCheckResponse = {
  __typename?: 'UserStageDetailUsageCheckResponse';
  usageDetails: Array<UserStageDetailUsageDetail>;
};

export type UserStageDetailUsageDetail = {
  __typename?: 'UserStageDetailUsageDetail';
  listingName: Scalars['String'];
  usedIn: Array<UserStageDetailUsedIn>;
};

export enum UserStageDetailUsedIn {
  AutoShare = 'auto_share',
  PurchaserSearch = 'purchaser_search',
  PurchaserStage = 'purchaser_stage'
}

export type UserStageDetailValidationError = {
  __typename?: 'UserStageDetailValidationError';
  id: Scalars['Int'];
  listingName: Scalars['String'];
  usedIn: Array<UserStageDetailUsedIn>;
};

export type UserStageDetailsResponse = {
  __typename?: 'UserStageDetailsResponse';
  meta: Meta;
  userStages: Array<UserStage>;
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  pagination: Pagination;
  users: Maybe<Array<UserIndex>>;
};

export type Wing = {
  __typename?: 'Wing';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
};

export type WingDetail = {
  __typename?: 'WingDetail';
  id: Scalars['Int'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  roomCount: Scalars['Int'];
  roomTypes: Array<RoomType>;
};

export type WingInput = {
  id?: InputMaybe<Scalars['Int']>;
  isDelete?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  roomTypes?: InputMaybe<Array<InputMaybe<RoomTypeInput>>>;
};

export type WingsResponse = {
  __typename?: 'WingsResponse';
  wings: Array<WingDetail>;
};

export type Workflow = {
  __typename?: 'Workflow';
  id: Scalars['Int'];
  name: Scalars['String'];
  notifiedUserEmailsAnnotation: Maybe<Scalars['String']>;
  type: Scalars['String'];
  workflowSteps: Array<WorkflowStep>;
};

export type WorkflowInput = {
  name: Scalars['String'];
  notifiedUserEmailsAnnotation?: InputMaybe<Scalars['String']>;
  type: WorkflowType;
  workflowSteps: Array<WorkflowStepInput>;
};

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  id: Scalars['Int'];
  isApproverAddable: Scalars['Boolean'];
  label: Scalars['String'];
  multiApproverCondition: Maybe<Scalars['String']>;
  primaryRoleIds: Array<Scalars['Int']>;
  secondaryRoleIds: Array<Scalars['Int']>;
  stepNumber: Scalars['Int'];
};

export type WorkflowStepInput = {
  IsApproverAddable: Scalars['Boolean'];
  label: Scalars['String'];
  multiApproverCondition?: InputMaybe<Scalars['String']>;
  primaryRoleIds: Array<Scalars['Int']>;
  secondaryRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  stepNumber: Scalars['Int'];
};

export enum WorkflowType {
  Order = 'order',
  Publish = 'publish'
}

export type WorkflowsResponse = {
  __typename?: 'WorkflowsResponse';
  workflows: Array<Workflow>;
};

export type WorksRole = {
  __typename?: 'WorksRole';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CompassRolesResponse = {
  __typename?: 'compassRolesResponse';
  compassRoles: Maybe<Array<CompassRole>>;
};

export enum RoomSourceType {
  Cached = 'cached',
  Diff = 'diff'
}

export type SendSelectEmailsInput = {
  content: SelectEmailContent;
  roomIds: Array<Scalars['Int']>;
};

export type AddExternalUserMutationVariables = Exact<{
  input: AddExternalUserInput;
}>;


export type AddExternalUserMutation = { __typename?: 'Mutation', addExternalUser: boolean | null };

export type AddUserMutationVariables = Exact<{
  input: AddUserInput;
}>;


export type AddUserMutation = { __typename?: 'Mutation', addUser: boolean | null };

export type AssignUserProjectsMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: AssignUserProjectsInput;
}>;


export type AssignUserProjectsMutation = { __typename?: 'Mutation', assignUserProjects: boolean | null };

export type AssignUsersProjectsMutationVariables = Exact<{
  input: AssignUsersProjectsInput;
}>;


export type AssignUsersProjectsMutation = { __typename?: 'Mutation', assignUsersProjects: boolean | null };

export type BulkUpdateRoomsMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: BulkUpdateRoomsInput;
}>;


export type BulkUpdateRoomsMutation = { __typename?: 'Mutation', bulkUpdateRooms: boolean | null };

export type BulkUpdateSelectMastersMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: BulkUpdateSelectMastersInput;
}>;


export type BulkUpdateSelectMastersMutation = { __typename?: 'Mutation', bulkUpdateSelectMasters: boolean | null };

export type BulkUpdateUserStageDetailsMutationVariables = Exact<{
  params: BulkUpdateUserStageDetailsInput;
}>;


export type BulkUpdateUserStageDetailsMutation = { __typename?: 'Mutation', bulkUpdateUserStageDetails: { __typename: 'UserStageDetailsResponse' } };

export type BulkUpdateWingsMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: BulkUpdateWingsInput;
}>;


export type BulkUpdateWingsMutation = { __typename?: 'Mutation', bulkUpdateWings: boolean | null };

export type BulkUpdateUserCancelDetailsMutationVariables = Exact<{
  params: BulkUpdateUserCancelDetailsInput;
}>;


export type BulkUpdateUserCancelDetailsMutation = { __typename?: 'Mutation', bulkUpdateUserCancelDetails: { __typename: 'UserCancelDetailsResponse' } };

export type CancelApplicationMutationVariables = Exact<{
  params: CancelApplicationInput;
}>;


export type CancelApplicationMutation = { __typename?: 'Mutation', cancelApplication: boolean | null };

export type CancelSelectAgreementMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: CancelSelectAgreementInput;
}>;


export type CancelSelectAgreementMutation = { __typename?: 'Mutation', cancelSelectAgreement: boolean | null };

export type CopySelectMasterMutationVariables = Exact<{
  projectId: Scalars['String'];
  selectMasterId: Scalars['Int'];
}>;


export type CopySelectMasterMutation = { __typename?: 'Mutation', copySelectMaster: boolean | null };

export type CreateAllowedIpMutationVariables = Exact<{
  input: AllowedIpInput;
}>;


export type CreateAllowedIpMutation = { __typename?: 'Mutation', createAllowedIp: boolean | null };

export type CreateApplicationMutationVariables = Exact<{
  input: ApplicationInput;
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication: { __typename?: 'CreateApplicationPayload', appliedRoomIds: Array<number> } };

export type CreateCommonContentAssetMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  params: CommonAssetInput;
}>;


export type CreateCommonContentAssetMutation = { __typename?: 'Mutation', createCommonAsset: boolean | null };

export type CreateCommonContentPageMutationVariables = Exact<{
  params: CommonPageInput;
}>;


export type CreateCommonContentPageMutation = { __typename?: 'Mutation', createCommonPage: boolean | null };

export type CreateCompanyRoleMutationVariables = Exact<{
  params: CompanyRoleInput;
}>;


export type CreateCompanyRoleMutation = { __typename?: 'Mutation', createCompanyRole: boolean | null };

export type CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCustomerEmailOptOutCsvPresignedUrlMutation = { __typename?: 'Mutation', presignedURLOptoutImport: { __typename?: 'PresignedURLPayload', presignedURL: string, jobId: string, s3URL: string } };

export type CreateProjectMutationVariables = Exact<{
  input: ProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: string | null };

export type CreateRoomUsersCsvPresignedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateRoomUsersCsvPresignedUrlMutation = { __typename?: 'Mutation', presignedURLRoomUsersImport: { __typename?: 'PresignedURLPayload', presignedURL: string, jobId: string, s3URL: string } };

export type CreateRoomsCsvMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: CreateRoomsCsvInput;
}>;


export type CreateRoomsCsvMutation = { __typename?: 'Mutation', createRoomsCSV: { __typename?: 'CreateRoomsCSVPayload', errorMessage: string, rooms: Array<{ __typename?: 'CreatedRoom', wingName: string, floor: string, roomName: string, roomTypeName: string, selectDisabled: boolean, result: string, message: string }> } | null };

export type CreateSamlIdpMutationVariables = Exact<{
  companyId: Scalars['Int'];
  params: SamlIdpInput;
}>;


export type CreateSamlIdpMutation = { __typename?: 'Mutation', createSAMLIdp: boolean | null };

export type CreateSelectMasterMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: SelectMasterInput;
}>;


export type CreateSelectMasterMutation = { __typename?: 'Mutation', createSelectMaster: boolean | null };

export type CreateWorkflowMutationVariables = Exact<{
  params: WorkflowInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: boolean | null };

export type DeleteAllowedIpMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type DeleteAllowedIpMutation = { __typename?: 'Mutation', deleteAllowedIp: boolean | null };

export type DeleteCommonContentAssetMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  commonAssetId: Scalars['Int'];
}>;


export type DeleteCommonContentAssetMutation = { __typename?: 'Mutation', deleteCommonAsset: boolean | null };

export type DeleteCommonContentPageMutationVariables = Exact<{
  CommonPageId: Scalars['Int'];
}>;


export type DeleteCommonContentPageMutation = { __typename?: 'Mutation', deleteCommonPage: boolean | null };

export type DeleteCompanyRoleMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type DeleteCompanyRoleMutation = { __typename?: 'Mutation', deleteCompanyRole: boolean | null };

export type DestroyRoomUserMutationVariables = Exact<{
  iamUserId: Scalars['Int'];
  roomId: Scalars['Int'];
}>;


export type DestroyRoomUserMutation = { __typename?: 'Mutation', destroyRoomUser: boolean | null };

export type DeleteCustomerMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: boolean | null };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: string | null };

export type DeleteSamlIdpMutationVariables = Exact<{
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
}>;


export type DeleteSamlIdpMutation = { __typename?: 'Mutation', deleteSAMLIdp: boolean | null };

export type DeleteUserMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean | null };

export type ExchangeAuthCodeWithAccessTokenMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ExchangeAuthCodeWithAccessTokenMutation = { __typename?: 'Mutation', exchangeAuthCodeWithAccessToken: { __typename?: 'AuthPayload', session: { __typename?: 'Session', accessToken: string, refreshToken: string, accessTokenExpiresAt: string, refreshTokenExpiresAt: string, cognitoUsername: string } } | null };

export type ExcludeRoomsFromOrderApplicationMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: ExcludeRoomsFromOrderApplicationInput;
}>;


export type ExcludeRoomsFromOrderApplicationMutation = { __typename?: 'Mutation', excludeRoomsFromOrderApplication: boolean | null };

export type ExcludeRoomsFromPublishApplicationMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: ExcludeRoomsFromPublishApplicationInput;
}>;


export type ExcludeRoomsFromPublishApplicationMutation = { __typename?: 'Mutation', excludeRoomsFromPublishApplication: boolean | null };

export type ForceUpdateExternalUserPasswordMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: ForceUpdatePasswordInput;
}>;


export type ForceUpdateExternalUserPasswordMutation = { __typename?: 'Mutation', forceUpdateExternalUserPassword: boolean | null };

export type ForceUpdateUserPasswordMutationVariables = Exact<{
  userId: Scalars['Int'];
  input: ForceUpdatePasswordInput;
}>;


export type ForceUpdateUserPasswordMutation = { __typename?: 'Mutation', forceUpdateUserPassword: boolean | null };

export type ForgetPasswordEmailMutationVariables = Exact<{
  input: ForgetPasswordInput;
}>;


export type ForgetPasswordEmailMutation = { __typename?: 'Mutation', forgetPassword: boolean | null };

export type IdPassLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type IdPassLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', session: { __typename?: 'Session', accessToken: string, refreshToken: string, accessTokenExpiresAt: string, refreshTokenExpiresAt: string, cognitoUsername: string } } | null };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean | null };

export type NotifyFinishedUploadContractorCsvMutationVariables = Exact<{
  params: ImportRoomUsersInput;
}>;


export type NotifyFinishedUploadContractorCsvMutation = { __typename?: 'Mutation', importRoomUsers: boolean | null };

export type NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables = Exact<{
  params: ImportOptoutInput;
}>;


export type NotifyFinishedUploadCustomerEmailOptOutCsvMutation = { __typename?: 'Mutation', importOptout: boolean | null };

export type RefreshAuthTokenMutationVariables = Exact<{
  input: RefreshAccessTokenInput;
}>;


export type RefreshAuthTokenMutation = { __typename?: 'Mutation', refreshAccessToken: { __typename?: 'AuthPayload', session: { __typename?: 'Session', accessToken: string, refreshToken: string, accessTokenExpiresAt: string, refreshTokenExpiresAt: string, cognitoUsername: string } } | null };

export type RegisterContractorMutationVariables = Exact<{
  params: RegisterRoomUserInput;
}>;


export type RegisterContractorMutation = { __typename?: 'Mutation', registerRoomUser: boolean | null };

export type RegisterSelectsMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: RegisterSelectsInput;
}>;


export type RegisterSelectsMutation = { __typename?: 'Mutation', registerSelects: boolean | null };

export type ReorderCommonContentAssetsMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  params: ReorderCommonAssetInput;
}>;


export type ReorderCommonContentAssetsMutation = { __typename?: 'Mutation', reorderCommonAssets: boolean | null };

export type ReorderCommonContentPagesMutationVariables = Exact<{
  params: ReorderCommonPageInput;
}>;


export type ReorderCommonContentPagesMutation = { __typename?: 'Mutation', reorderCommonPages: boolean | null };

export type SendSelectEmailMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: SendSelectEmailsInput;
}>;


export type SendSelectEmailMutation = { __typename?: 'Mutation', sendSelectEmails: boolean | null };

export type UpdateAllowedIpMutationVariables = Exact<{
  id: Scalars['Int'];
  input: AllowedIpInput;
}>;


export type UpdateAllowedIpMutation = { __typename?: 'Mutation', updateAllowedIp: boolean | null };

export type UpdateApplicationStepConfirmationMutationVariables = Exact<{
  input: UpdateApplicationStepConfirmationInput;
}>;


export type UpdateApplicationStepConfirmationMutation = { __typename?: 'Mutation', updateApplicationStepConfirmation: boolean | null };

export type UpdateCommonContentAssetMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  commonAssetId: Scalars['Int'];
  params: CommonAssetInput;
}>;


export type UpdateCommonContentAssetMutation = { __typename?: 'Mutation', updateCommonAsset: boolean | null };

export type UpdateCommonContentPageMutationVariables = Exact<{
  commonPageId: Scalars['Int'];
  params: CommonPageInput;
}>;


export type UpdateCommonContentPageMutation = { __typename?: 'Mutation', updateCommonPage: boolean | null };

export type UpdateCompanyAuthMethodMutationVariables = Exact<{
  companyId: Scalars['Int'];
  params: UpdateCompanyAuthMethodInput;
}>;


export type UpdateCompanyAuthMethodMutation = { __typename?: 'Mutation', updateCompanyAuthMethod: boolean | null };

export type UpdateCompanyRoleMutationVariables = Exact<{
  roleId: Scalars['Int'];
  params: CompanyRoleInput;
}>;


export type UpdateCompanyRoleMutation = { __typename?: 'Mutation', updateCompanyRole: boolean | null };

export type UpdateRoomUserConfirmationCodeMutationVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
  params: UpdateRoomUserConfirmationCodeInput;
}>;


export type UpdateRoomUserConfirmationCodeMutation = { __typename?: 'Mutation', updateRoomUserConfirmationCode: boolean | null };

export type UpdateExternalUserNameMutationVariables = Exact<{
  userId: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateExternalUserNameMutation = { __typename?: 'Mutation', updateExternalUserName: boolean | null };

export type UpdateInitialPasswordMutationVariables = Exact<{
  input: UpdateInitPasswordInput;
}>;


export type UpdateInitialPasswordMutation = { __typename?: 'Mutation', updateInitPassword: boolean | null };

export type UpdateInternalUserNameMutationVariables = Exact<{
  userId: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateInternalUserNameMutation = { __typename?: 'Mutation', updateInternalUserName: boolean | null };

export type UpdateIpRestrictionMutationVariables = Exact<{
  input: UpdateIpRestrictionInput;
}>;


export type UpdateIpRestrictionMutation = { __typename?: 'Mutation', updateIpRestriction: boolean | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean | null };

export type UpdateProfileNameMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type UpdateProfileNameMutation = { __typename?: 'Mutation', updateProfileName: boolean | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['String'];
  input: ProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: string | null };

export type UpdateProjectShowCommonPageMutationVariables = Exact<{
  projectId: Scalars['String'];
  params: ProjectShowCommonPageInput;
}>;


export type UpdateProjectShowCommonPageMutation = { __typename?: 'Mutation', updateProjectShowCommonPage: boolean | null };

export type UpdateRoomMutationVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
  input: RoomInput;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: boolean | null };

export type UpdateSamlIdpMutationVariables = Exact<{
  companyId: Scalars['Int'];
  identityProviderId: Scalars['Int'];
  params: SamlIdpInput;
}>;


export type UpdateSamlIdpMutation = { __typename?: 'Mutation', updateSAMLIdp: boolean | null };

export type UpdateUserCompanyRolesMutationVariables = Exact<{
  userId: Scalars['Int'];
  params: UpdateCompanyRolesInput;
}>;


export type UpdateUserCompanyRolesMutation = { __typename?: 'Mutation', updateUserCompanyRoles: boolean | null };

export type UpdateUserKeywordsMutationVariables = Exact<{
  userId: Scalars['Int'];
  params: UpdateUserKeywordsInput;
}>;


export type UpdateUserKeywordsMutation = { __typename?: 'Mutation', updateUserKeywords: boolean | null };

export type UpdateWorksRoleMutationVariables = Exact<{
  input: UpdateWorksRoleInput;
}>;


export type UpdateWorksRoleMutation = { __typename?: 'Mutation', updateWorksRole: boolean | null };

export type CheckLoginSettingMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckLoginSettingMutation = { __typename?: 'Mutation', checkLoginSetting: { __typename?: 'CheckLoginSettingPayload', isIDPassEnabled: boolean, isSAMLEnabled: boolean, isSuperAdmin: boolean, idpAuthURL: string | null } };

export type CheckUserCancelDetailUsageQueryVariables = Exact<{
  userCancelDetailId: Scalars['Int'];
}>;


export type CheckUserCancelDetailUsageQuery = { __typename?: 'Query', userCancelDetailUsageCheck: { __typename?: 'UserCancelDetailUsageCheckResponse', usageDetails: Array<{ __typename?: 'UserCancelDetailUsageDetail', listingName: string, usedIn: Array<UserCancelDetailUsedIn> }> } };

export type CheckUserStageDetailUsageQueryVariables = Exact<{
  userStageDetailId: Scalars['Int'];
}>;


export type CheckUserStageDetailUsageQuery = { __typename?: 'Query', userStageDetailUsageCheck: { __typename?: 'UserStageDetailUsageCheckResponse', usageDetails: Array<{ __typename?: 'UserStageDetailUsageDetail', listingName: string, usedIn: Array<UserStageDetailUsedIn> }> } };

export type GetAllRoomSelectRegistrationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAllRoomSelectRegistrationsQuery = { __typename?: 'Query', allRoomSelectRegistrations: { __typename?: 'RoomSelectRegistrationsResponse', rooms: Array<{ __typename?: 'RoomSelect', id: number, selects: Array<{ __typename?: 'SelectRegistration', id: number, name: string, priority: number, selectMasterId: number, registeredSelectOption: { __typename?: 'RegisteredSelectOption', id: number, name: string, isPaid: boolean, child: { __typename?: 'RegisteredSelectOptionChild', id: number, name: string, isPaid: boolean } | null } | null }> }> } };

export type GetAllowedIpsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllowedIpsQuery = { __typename?: 'Query', allowedIps: { __typename?: 'AllowedIpsResponse', isIpRestricted: boolean, allowedIps: Array<{ __typename?: 'AllowedIp', id: number, ip: string, description: string }> | null } };

export type GetApplicationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetApplicationsQuery = { __typename?: 'Query', applications: { __typename?: 'ApplicationsResponse', applications: Array<{ __typename?: 'Application', id: number, projectId: string, creatorId: number, title: string, status: string, notifiedUserEmails: Array<string>, workflowId: number, comment: string | null, roomIds: Array<number>, canceledRoomIds: Array<number>, isWaitingYourConfirmation: boolean, createdAt: string, applicationSteps: Array<{ __typename?: 'ApplicationStep', id: number, label: string, stepNumber: number, multiApproverCondition: string | null, status: string, dueDate: string, applicationStepConfirmations: Array<{ __typename?: 'ApplicationStepConfirmation', id: number, confirmerId: number, status: string, comment: string | null, confirmedAt: string | null, isProxy: boolean }> }> }> } };

export type GetCachedRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetCachedRoomsQuery = { __typename?: 'Query', cachedRooms: { __typename?: 'RoomsResponse', rooms: Array<{ __typename?: 'Room', id: number, name: string, priority: number, floor: string, wingId: number, wingName: string, roomTypeId: number | null, roomTypeName: string | null, isSelectEnabled: boolean, memo: string | null, selectMasterIds: Array<number>, registrationDueDatetime: string, registrationStatus: SelectRegistrationStatus, publishApplicationStatus: ApplicationStatus, isLocked: boolean, isEnableOrderApplication: boolean, isEnableProxySelectRegistration: boolean, isEnableRoomUserRegistration: boolean, isEnableRoomUserDestroy: boolean, isEnableUpdateConfirmationCode: boolean, isEnableSelectEmailInvitation: boolean, isEnablePublishApplication: boolean, isEnableChangeToUnselectable: boolean, isEnableSelectEmailAgreementRequest: boolean, isEnableCancelSelectAgreement: boolean, isEnableCancelPublishApplication: boolean, isEnableCancelOrderApplication: boolean, isEnableExcludeRoomsFromPublishApplication: boolean, isEnableExcludeRoomsFromOrderApplication: boolean, orderApplicationCanceledAt: string | null, orderApplicationCancelComment: string | null, orderApplicationStatus: ApplicationStatus, adminMemo: string | null, confirmationCode: string | null, source: RoomSourceType, user: { __typename?: 'RoomUser', id: number, name: string, email: string, selectEmailSentTimes: number, agreementRequestEmailSentTimes: number, lastSelectEmailSentAt: string | null, lastAgreementRequestEmailSentAt: string | null, identification: { __typename?: 'Identification', status: IdentificationStatus, code: string | null } } | null }> } };

export type GetCommonPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetCommonPageQuery = { __typename?: 'Query', commonPage: { __typename?: 'CommonPageResponse', id: number, name: string, priority: number, annotation: string | null, meta: { __typename?: 'PageMetaResponse', isPublic: boolean, displayConsumer: boolean, designFormat: string, icon: number }, assets: Array<{ __typename?: 'Asset', id: number, name: string, category: string, priority: number, fileSize: number, externalLink: string, meta: { __typename?: 'AssetMeta', fileName: string | null, uploadedAt: number, UploadedWorksUserBy: number }, data: { __typename?: 'AssetData', url: string, thumbUrl: string } }> } };

export type GetCommonPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommonPagesQuery = { __typename?: 'Query', commonPages: { __typename?: 'CommonPagesResponse', commonPages: Array<{ __typename?: 'CommonPageResponse', id: number, name: string, priority: number, annotation: string | null, meta: { __typename?: 'PageMetaResponse', isPublic: boolean, displayConsumer: boolean, designFormat: string, icon: number }, assets: Array<{ __typename?: 'Asset', id: number, name: string, category: string, priority: number, fileSize: number, externalLink: string, meta: { __typename?: 'AssetMeta', fileName: string | null, uploadedAt: number, UploadedWorksUserBy: number }, data: { __typename?: 'AssetData', url: string, thumbUrl: string } }> }> } };

export type GetCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyQuery = { __typename?: 'Query', company: { __typename?: 'CompanyResponse', id: number, name: string, isIDPassEnabled: boolean, isSAMLEnabled: boolean } };

export type CompanyRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyRolesQuery = { __typename?: 'Query', companyRoles: { __typename?: 'CompanyRolesResponse', roles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number>, users: Array<{ __typename?: 'UserIndex', id: number, name: string | null }> }> | null } };

export type GetCompassRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompassRolesQuery = { __typename?: 'Query', compassRoles: { __typename?: 'compassRolesResponse', compassRoles: Array<{ __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }> | null } };

export type GetCustomerProjectsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetCustomerProjectsQuery = { __typename?: 'Query', customerProjects: { __typename?: 'CustomerProjectsResponse', customerProjects: Array<{ __typename?: 'CustomerProject', id: string, title: string, projectCustomerName: string | null, createdAt: string, currentSignInAt: string | null, inviterName: string | null, isRoomIamUser: boolean, roomNames: Array<string | null> }> } };

export type GetDiffRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetDiffRoomsQuery = { __typename?: 'Query', diffRooms: { __typename?: 'DiffRoomsResponse', rooms: Array<{ __typename?: 'DiffRoom', type: DiffType, room: { __typename?: 'Room', id: number, name: string, priority: number, floor: string, wingId: number, wingName: string, roomTypeId: number | null, roomTypeName: string | null, isSelectEnabled: boolean, memo: string | null, selectMasterIds: Array<number>, registrationDueDatetime: string, registrationStatus: SelectRegistrationStatus, publishApplicationStatus: ApplicationStatus, isLocked: boolean, isEnableOrderApplication: boolean, isEnableProxySelectRegistration: boolean, isEnableRoomUserRegistration: boolean, isEnableRoomUserDestroy: boolean, isEnableUpdateConfirmationCode: boolean, isEnableSelectEmailInvitation: boolean, isEnablePublishApplication: boolean, isEnableChangeToUnselectable: boolean, isEnableSelectEmailAgreementRequest: boolean, isEnableCancelSelectAgreement: boolean, isEnableCancelPublishApplication: boolean, isEnableCancelOrderApplication: boolean, isEnableExcludeRoomsFromPublishApplication: boolean, isEnableExcludeRoomsFromOrderApplication: boolean, orderApplicationCanceledAt: string | null, orderApplicationCancelComment: string | null, orderApplicationStatus: ApplicationStatus, adminMemo: string | null, confirmationCode: string | null, source: RoomSourceType, user: { __typename?: 'RoomUser', id: number, name: string, email: string, selectEmailSentTimes: number, agreementRequestEmailSentTimes: number, lastSelectEmailSentAt: string | null, lastAgreementRequestEmailSentAt: string | null, identification: { __typename?: 'Identification', status: IdentificationStatus, code: string | null } } | null } }> } };

export type GetEmailDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailDomainsQuery = { __typename?: 'Query', emailDomains: { __typename?: 'EmailDomainsResponse', emailDomains: Array<{ __typename?: 'EmailDomain', id: number, allowedDomain: string } | null> } };

export type GetExternalUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetExternalUserQuery = { __typename?: 'Query', externalUser: { __typename?: 'ExternalUserResponse', user: { __typename?: 'ExternalUser', id: number, name: string | null, email: string, keywords: Array<string>, createdAt: string, updatedAt: string, projects: Array<{ __typename?: 'AssignedProject', id: string, title: string, adminUrl: string, presentationUrl: string, isDeleting: boolean, isWorksManaged: boolean, assignedAt: string, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number } }> | null } } };

export type GetExternalUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalUsersQuery = { __typename?: 'Query', externalUsers: { __typename?: 'ExternalUsersResponse', users: Array<{ __typename?: 'ExternalUserIndex', id: number, email: string, name: string | null, keywords: Array<string>, createdAt: string, projectCount: number }> | null, pagination: { __typename?: 'Pagination', current: number, previous: number, next: number, limitValue: number, pageCount: number, totalCount: number } } };

export type GetGroupingRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetGroupingRoomsQuery = { __typename?: 'Query', groupingRooms: { __typename?: 'GroupingRoomsResponse', rooms: Array<{ __typename?: 'GroupingRoom', id: number, groupingKey: string }> } };

export type GetLatestImportOptOutJobQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestImportOptOutJobQuery = { __typename?: 'Query', latestImportOptoutJob: { __typename?: 'ImportOptoutJobResponse', jobId: string, status: ImportJobStatus, rowCount: number, failedError: string | null, updatedAt: string, partFailedTotalCount: number | null, partFailedNormalErrorCount: number | null, partFailedAbnormalErrorCount: number | null, partFailedError: Array<{ __typename?: 'ImportOptoutJobPartFailedError', row: number, message: string }> | null } };

export type GetLatestImportRoomUsersJobQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestImportRoomUsersJobQuery = { __typename?: 'Query', latestImportRoomUsersJob: { __typename?: 'ImportRoomUsersJobResponse', jobId: string, status: ImportJobStatus, lineCount: number, updatedAt: string, errorMessage: string | null, errorReportS3Url: string | null, errorDetails: Array<{ __typename?: 'ImportRoomUsersJobErrorDetail', line: number, message: string }> | null } };

export type GetMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterDataQuery = { __typename?: 'Query', masterData: { __typename?: 'MasterDataResponse', worksRoles: Array<{ __typename?: 'WorksRole', id: number, name: string, displayName: string } | null> | null, companyPolicies: Array<{ __typename?: 'CompanyPolicy', id: number, name: string, displayName: string } | null> | null } };

export type GetMyReviewingConfirmationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyReviewingConfirmationsQuery = { __typename?: 'Query', myReviewingConfirmations: { __typename?: 'MyReviewingConfirmationsResponse', confirmations: Array<{ __typename?: 'MyReviewingConfirmation', id: number, applicationId: number, projectId: string, projectName: string, applicationWorkflowName: string, applicationType: ApplicationType, applicationTitle: string, applicationCreatorId: number, applicationCreatedAt: string, dueDate: string }> } };

export type GetOgpImageQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetOgpImageQuery = { __typename?: 'Query', ogpImage: { __typename?: 'OgpImageResponse', url: string } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'ProfileResponse', user: { __typename?: 'ProfileUser', id: number, name: string | null, email: string, roleId: number, isResetPassword: boolean, keywords: Array<string>, policies: Array<string> | null, createdAt: string, updatedAt: string, role: { __typename?: 'WorksRole', id: number, name: string, displayName: string }, projects: Array<{ __typename?: 'AssignedProject', id: string, title: string, adminUrl: string, presentationUrl: string, isDeleting: boolean, isWorksManaged: boolean, assignedAt: string, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number } }> | null, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> | null, companyPolicies: Array<{ __typename?: 'CompanyPolicy', id: number, name: string, displayName: string }> | null } } };

export type GetProjectQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'ProjectResponse', project: { __typename?: 'Project', id: string, title: string, code: string | null, zipcode: string | null, prefecture: string, city: string | null, address: string | null, structureCount: number | null, roomCount: number | null, planCount: number | null, averagePriceRange: number | null, purchaserCount: number | null, applicationCount: number | null, totalPvCount: number, totalSessionCount: number, email: string | null, emailDisplayName: string | null, adminUrl: string, presentationUrl: string, isWorksManaged: boolean, showCommonPage: boolean, isDeleting: boolean, createdAt: string, updatedAt: string, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number }, users: Array<{ __typename?: 'AssingedUser', id: number, name: string | null, email: string, isExternal: boolean, assignedAt: string, keywords: Array<string>, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> }> | null, mainContents: Array<{ __typename?: 'MainContent', id: number, name: string }> | null } } };

export type GetProjectStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectStatusesQuery = { __typename?: 'Query', projectStatuses: { __typename?: 'ProjectStatusesResponse', projectStatuses: Array<{ __typename?: 'ProjectStatus', name: string, displayName: string, priority: number }> } };

export type GetProjectSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectSummaryQuery = { __typename?: 'Query', projectSummary: { __typename?: 'ProjectSummaryResponse', projectCountHistories: Array<{ __typename?: 'ProjectCountHistory', month: string, activatedCount: number }> | null } };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectsResponse', projects: Array<{ __typename?: 'ProjectIndex', id: string, title: string, code: string | null, prefecture: string, structureCount: number | null, roomCount: number | null, planCount: number | null, averagePriceRange: number | null, purchaserCount: number | null, applicationCount: number | null, adminUrl: string, presentationUrl: string, isWorksManaged: boolean, isDeleting: boolean, createdAt: string, updatedAt: string, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number }, creator: { __typename?: 'Creator', id: number, name: string } }> | null, pagination: { __typename?: 'Pagination', current: number, previous: number, next: number, limitValue: number, pageCount: number, totalCount: number } } };

export type GetRoomSelectMastersQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
}>;


export type GetRoomSelectMastersQuery = { __typename?: 'Query', roomSelectMasters: { __typename?: 'RoomSelectMastersResponse', selectMasters: Array<{ __typename?: 'RoomSelectMaster', id: number, selectOptionMasterIds: Array<number> }> } };

export type GetRoomSelectRegistrationsQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetRoomSelectRegistrationsQuery = { __typename?: 'Query', roomSelectRegistrations: { __typename?: 'RoomSelectRegistrationsResponse', rooms: Array<{ __typename?: 'RoomSelect', id: number, selects: Array<{ __typename?: 'SelectRegistration', id: number, name: string, priority: number, selectMasterId: number, registeredSelectOption: { __typename?: 'RegisteredSelectOption', id: number, name: string, isPaid: boolean, child: { __typename?: 'RegisteredSelectOptionChild', id: number, name: string, isPaid: boolean } | null } | null }> }> } };

export type GetRoomTypesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetRoomTypesQuery = { __typename?: 'Query', roomTypes: { __typename?: 'RoomTypesResponse', roomTypes: Array<{ __typename?: 'RoomType', id: number, name: string, priority: number, worksRoomIds: Array<number> | null, compassRoomCount: number }> } };

export type GetRoomsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetRoomsQuery = { __typename?: 'Query', rooms: { __typename?: 'RoomsResponse', rooms: Array<{ __typename?: 'Room', id: number, name: string, priority: number, floor: string, wingId: number, wingName: string, roomTypeId: number | null, roomTypeName: string | null, isSelectEnabled: boolean, memo: string | null, selectMasterIds: Array<number>, registrationDueDatetime: string, registrationStatus: SelectRegistrationStatus, publishApplicationStatus: ApplicationStatus, isLocked: boolean, isEnableOrderApplication: boolean, isEnableProxySelectRegistration: boolean, isEnableRoomUserRegistration: boolean, isEnableRoomUserDestroy: boolean, isEnableUpdateConfirmationCode: boolean, isEnableSelectEmailInvitation: boolean, isEnablePublishApplication: boolean, isEnableChangeToUnselectable: boolean, isEnableSelectEmailAgreementRequest: boolean, isEnableCancelSelectAgreement: boolean, isEnableCancelPublishApplication: boolean, isEnableCancelOrderApplication: boolean, isEnableExcludeRoomsFromPublishApplication: boolean, isEnableExcludeRoomsFromOrderApplication: boolean, orderApplicationCanceledAt: string | null, orderApplicationCancelComment: string | null, orderApplicationStatus: ApplicationStatus, adminMemo: string | null, confirmationCode: string | null, user: { __typename?: 'RoomUser', id: number, name: string, email: string, selectEmailSentTimes: number, agreementRequestEmailSentTimes: number, lastSelectEmailSentAt: string | null, lastAgreementRequestEmailSentAt: string | null, identification: { __typename?: 'Identification', status: IdentificationStatus, code: string | null } } | null }> } };

export type SamlIdpQueryVariables = Exact<{ [key: string]: never; }>;


export type SamlIdpQuery = { __typename?: 'Query', samlIdp: { __typename?: 'SAMLIdpResponse', assertionConsumerServiceURL: string, serviceProviderURN: string, samlIdp: { __typename?: 'SAMLIdp', id: number, idpSignout: boolean, metadataFile: string | null, metadataFileName: string | null, metadataURL: string | null, attributeMapping: { __typename?: 'AttributeMapping', email: string, name: string | null, department: string | null } } | null } };

export type GetContractorHistoriesQueryVariables = Exact<{
  roomId: Scalars['Int'];
}>;


export type GetContractorHistoriesQuery = { __typename?: 'Query', selectContractorHistories: { __typename?: 'SelectContractorHistoriesResponse', histories: Array<{ __typename?: 'SelectContractorHistory', timestamp: string, action: string, actor: { __typename?: 'ContractorHistoryActor', id: number, name: string | null, type: ContractorHistoryActorType, companyRoleNames: Array<string> | null } | null }> } };

export type GetSelectMastersQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSelectMastersQuery = { __typename?: 'Query', selectMasters: { __typename?: 'SelectMastersResponse', selectMasters: Array<{ __typename?: 'SelectMaster', id: number, name: string, priority: number, displayName: string, description: string | null, modelRoomInfo: string | null, annotation: string | null, fileName: string | null, isPlanSelect: boolean, roomIds: Array<number>, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, assignments: { __typename?: 'SelectMasterAssignments', mainContents: Array<number> | null } | null, selectOptionMasters: Array<{ __typename?: 'SelectOptionMaster', id: number, name: string, annotation: string | null, isPaid: boolean, priority: number, fileName: string | null, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, children: Array<{ __typename?: 'SelectOptionMaster', id: number, name: string, annotation: string | null, isPaid: boolean, priority: number, fileName: string | null, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null }> | null }> }> | null } };

export type GetSelectRegistrationsQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
}>;


export type GetSelectRegistrationsQuery = { __typename?: 'Query', selectRegistrations: { __typename?: 'SelectRegistrationsResponse', selectRegistrations: Array<{ __typename?: 'SelectRegistration', id: number, name: string, priority: number, selectMasterId: number, registeredSelectOption: { __typename?: 'RegisteredSelectOption', id: number, name: string, isPaid: boolean, child: { __typename?: 'RegisteredSelectOptionChild', id: number, name: string, isPaid: boolean } | null } | null }> } };

export type GetSelectsQueryVariables = Exact<{
  projectId: Scalars['String'];
  roomId: Scalars['Int'];
}>;


export type GetSelectsQuery = { __typename?: 'Query', selects: { __typename?: 'SelectsResponse', selects: Array<{ __typename?: 'Select', id: number, priority: number, name: string, displayName: string, description: string, modelRoomInfo: string, annotation: string, selectMasterId: number, isPlanSelect: boolean, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, assignments: { __typename?: 'SelectMasterAssignments', mainContents: Array<number> | null } | null, selectOptions: Array<{ __typename?: 'SelectOption', id: number, name: string, annotation: string, isPaid: boolean, priority: number, isSelected: boolean, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null, children: Array<{ __typename?: 'SelectOption', id: number, name: string, annotation: string, isPaid: boolean, priority: number, isSelected: boolean, file: { __typename?: 'SelectMasterFile', url: string, thumb: { __typename?: 'SelectMasterFileThumb', url: string } } | null }> | null }> }> } };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'UserResponse', user: { __typename?: 'User', id: number, name: string | null, email: string, roleId: number, isResetPassword: boolean, keywords: Array<string>, createdAt: string, updatedAt: string, role: { __typename?: 'WorksRole', id: number, name: string, displayName: string }, projects: Array<{ __typename?: 'AssignedProject', id: string, title: string, adminUrl: string, presentationUrl: string, isDeleting: boolean, isWorksManaged: boolean, assignedAt: string, role: { __typename?: 'CompassRole', id: number, name: string, displayName: string, priority: number }, status: { __typename?: 'ProjectStatus', name: string, displayName: string, priority: number } }> | null, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> } } };

export type GetUserCancelDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCancelDetailsQuery = { __typename?: 'Query', userCancelDetails: { __typename?: 'UserCancelDetailsResponse', userCancelDetails: Array<{ __typename?: 'UserCancelDetail', id: number, name: string, priority: number }>, meta: { __typename?: 'Meta', updatedAt: string, createdAt: string, updatedBy: { __typename?: 'Editor', id: number, name: string }, createdBy: { __typename?: 'Editor', id: number, name: string } } } };

export type UserStageDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStageDetailsQuery = { __typename?: 'Query', userStageDetails: { __typename?: 'UserStageDetailsResponse', userStages: Array<{ __typename?: 'UserStage', id: number, stage: string, priority: number, userStageDetails: Array<{ __typename?: 'UserStageDetail', id: number, name: string, priority: number }> }>, meta: { __typename?: 'Meta', updatedAt: string, createdAt: string, updatedBy: { __typename?: 'Editor', id: number, name: string }, createdBy: { __typename?: 'Editor', id: number, name: string } } } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResponse', users: Array<{ __typename?: 'UserIndex', id: number, name: string | null, email: string, keywords: Array<string>, roleId: number, isResetPassword: boolean, projectCount: number, createdAt: string, role: { __typename?: 'WorksRole', id: number, name: string, displayName: string }, companyRoles: Array<{ __typename?: 'CompanyRole', id: number, name: string, policyIds: Array<number> }> }> | null } };

export type GetWingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetWingsQuery = { __typename?: 'Query', wings: { __typename?: 'WingsResponse', wings: Array<{ __typename?: 'WingDetail', id: number, name: string, roomCount: number, priority: number, roomTypes: Array<{ __typename?: 'RoomType', id: number, name: string, priority: number, worksRoomIds: Array<number> | null, compassRoomCount: number }> }> } };

export type GetWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowsQuery = { __typename?: 'Query', workflows: { __typename?: 'WorkflowsResponse', workflows: Array<{ __typename?: 'Workflow', id: number, name: string, type: string, notifiedUserEmailsAnnotation: string | null, workflowSteps: Array<{ __typename?: 'WorkflowStep', id: number, label: string, stepNumber: number, primaryRoleIds: Array<number>, secondaryRoleIds: Array<number>, isApproverAddable: boolean, multiApproverCondition: string | null }> }> } };


export const AddExternalUserDocument = gql`
    mutation addExternalUser($input: AddExternalUserInput!) {
  addExternalUser(params: $input)
}
    `;
export type AddExternalUserMutationFn = Apollo.MutationFunction<AddExternalUserMutation, AddExternalUserMutationVariables>;

/**
 * __useAddExternalUserMutation__
 *
 * To run a mutation, you first call `useAddExternalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExternalUserMutation, { data, loading, error }] = useAddExternalUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddExternalUserMutation(baseOptions?: Apollo.MutationHookOptions<AddExternalUserMutation, AddExternalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExternalUserMutation, AddExternalUserMutationVariables>(AddExternalUserDocument, options);
      }
export type AddExternalUserMutationHookResult = ReturnType<typeof useAddExternalUserMutation>;
export type AddExternalUserMutationResult = Apollo.MutationResult<AddExternalUserMutation>;
export type AddExternalUserMutationOptions = Apollo.BaseMutationOptions<AddExternalUserMutation, AddExternalUserMutationVariables>;
export const AddUserDocument = gql`
    mutation addUser($input: AddUserInput!) {
  addUser(params: $input)
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const AssignUserProjectsDocument = gql`
    mutation AssignUserProjects($userId: Int!, $input: AssignUserProjectsInput!) {
  assignUserProjects(userId: $userId, params: $input)
}
    `;
export type AssignUserProjectsMutationFn = Apollo.MutationFunction<AssignUserProjectsMutation, AssignUserProjectsMutationVariables>;

/**
 * __useAssignUserProjectsMutation__
 *
 * To run a mutation, you first call `useAssignUserProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUserProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUserProjectsMutation, { data, loading, error }] = useAssignUserProjectsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignUserProjectsMutation(baseOptions?: Apollo.MutationHookOptions<AssignUserProjectsMutation, AssignUserProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUserProjectsMutation, AssignUserProjectsMutationVariables>(AssignUserProjectsDocument, options);
      }
export type AssignUserProjectsMutationHookResult = ReturnType<typeof useAssignUserProjectsMutation>;
export type AssignUserProjectsMutationResult = Apollo.MutationResult<AssignUserProjectsMutation>;
export type AssignUserProjectsMutationOptions = Apollo.BaseMutationOptions<AssignUserProjectsMutation, AssignUserProjectsMutationVariables>;
export const AssignUsersProjectsDocument = gql`
    mutation AssignUsersProjects($input: AssignUsersProjectsInput!) {
  assignUsersProjects(params: $input)
}
    `;
export type AssignUsersProjectsMutationFn = Apollo.MutationFunction<AssignUsersProjectsMutation, AssignUsersProjectsMutationVariables>;

/**
 * __useAssignUsersProjectsMutation__
 *
 * To run a mutation, you first call `useAssignUsersProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUsersProjectsMutation, { data, loading, error }] = useAssignUsersProjectsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignUsersProjectsMutation(baseOptions?: Apollo.MutationHookOptions<AssignUsersProjectsMutation, AssignUsersProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignUsersProjectsMutation, AssignUsersProjectsMutationVariables>(AssignUsersProjectsDocument, options);
      }
export type AssignUsersProjectsMutationHookResult = ReturnType<typeof useAssignUsersProjectsMutation>;
export type AssignUsersProjectsMutationResult = Apollo.MutationResult<AssignUsersProjectsMutation>;
export type AssignUsersProjectsMutationOptions = Apollo.BaseMutationOptions<AssignUsersProjectsMutation, AssignUsersProjectsMutationVariables>;
export const BulkUpdateRoomsDocument = gql`
    mutation bulkUpdateRooms($projectId: String!, $params: BulkUpdateRoomsInput!) {
  bulkUpdateRooms(projectId: $projectId, params: $params)
}
    `;
export type BulkUpdateRoomsMutationFn = Apollo.MutationFunction<BulkUpdateRoomsMutation, BulkUpdateRoomsMutationVariables>;

/**
 * __useBulkUpdateRoomsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateRoomsMutation, { data, loading, error }] = useBulkUpdateRoomsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useBulkUpdateRoomsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateRoomsMutation, BulkUpdateRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateRoomsMutation, BulkUpdateRoomsMutationVariables>(BulkUpdateRoomsDocument, options);
      }
export type BulkUpdateRoomsMutationHookResult = ReturnType<typeof useBulkUpdateRoomsMutation>;
export type BulkUpdateRoomsMutationResult = Apollo.MutationResult<BulkUpdateRoomsMutation>;
export type BulkUpdateRoomsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateRoomsMutation, BulkUpdateRoomsMutationVariables>;
export const BulkUpdateSelectMastersDocument = gql`
    mutation bulkUpdateSelectMasters($projectId: String!, $params: BulkUpdateSelectMastersInput!) {
  bulkUpdateSelectMasters(projectId: $projectId, params: $params)
}
    `;
export type BulkUpdateSelectMastersMutationFn = Apollo.MutationFunction<BulkUpdateSelectMastersMutation, BulkUpdateSelectMastersMutationVariables>;

/**
 * __useBulkUpdateSelectMastersMutation__
 *
 * To run a mutation, you first call `useBulkUpdateSelectMastersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateSelectMastersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateSelectMastersMutation, { data, loading, error }] = useBulkUpdateSelectMastersMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useBulkUpdateSelectMastersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateSelectMastersMutation, BulkUpdateSelectMastersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateSelectMastersMutation, BulkUpdateSelectMastersMutationVariables>(BulkUpdateSelectMastersDocument, options);
      }
export type BulkUpdateSelectMastersMutationHookResult = ReturnType<typeof useBulkUpdateSelectMastersMutation>;
export type BulkUpdateSelectMastersMutationResult = Apollo.MutationResult<BulkUpdateSelectMastersMutation>;
export type BulkUpdateSelectMastersMutationOptions = Apollo.BaseMutationOptions<BulkUpdateSelectMastersMutation, BulkUpdateSelectMastersMutationVariables>;
export const BulkUpdateUserStageDetailsDocument = gql`
    mutation BulkUpdateUserStageDetails($params: BulkUpdateUserStageDetailsInput!) {
  bulkUpdateUserStageDetails(params: $params) {
    __typename
  }
}
    `;
export type BulkUpdateUserStageDetailsMutationFn = Apollo.MutationFunction<BulkUpdateUserStageDetailsMutation, BulkUpdateUserStageDetailsMutationVariables>;

/**
 * __useBulkUpdateUserStageDetailsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateUserStageDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateUserStageDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateUserStageDetailsMutation, { data, loading, error }] = useBulkUpdateUserStageDetailsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useBulkUpdateUserStageDetailsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateUserStageDetailsMutation, BulkUpdateUserStageDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateUserStageDetailsMutation, BulkUpdateUserStageDetailsMutationVariables>(BulkUpdateUserStageDetailsDocument, options);
      }
export type BulkUpdateUserStageDetailsMutationHookResult = ReturnType<typeof useBulkUpdateUserStageDetailsMutation>;
export type BulkUpdateUserStageDetailsMutationResult = Apollo.MutationResult<BulkUpdateUserStageDetailsMutation>;
export type BulkUpdateUserStageDetailsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateUserStageDetailsMutation, BulkUpdateUserStageDetailsMutationVariables>;
export const BulkUpdateWingsDocument = gql`
    mutation bulkUpdateWings($projectId: String!, $params: BulkUpdateWingsInput!) {
  bulkUpdateWings(projectId: $projectId, params: $params)
}
    `;
export type BulkUpdateWingsMutationFn = Apollo.MutationFunction<BulkUpdateWingsMutation, BulkUpdateWingsMutationVariables>;

/**
 * __useBulkUpdateWingsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateWingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateWingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateWingsMutation, { data, loading, error }] = useBulkUpdateWingsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useBulkUpdateWingsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateWingsMutation, BulkUpdateWingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateWingsMutation, BulkUpdateWingsMutationVariables>(BulkUpdateWingsDocument, options);
      }
export type BulkUpdateWingsMutationHookResult = ReturnType<typeof useBulkUpdateWingsMutation>;
export type BulkUpdateWingsMutationResult = Apollo.MutationResult<BulkUpdateWingsMutation>;
export type BulkUpdateWingsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateWingsMutation, BulkUpdateWingsMutationVariables>;
export const BulkUpdateUserCancelDetailsDocument = gql`
    mutation bulkUpdateUserCancelDetails($params: BulkUpdateUserCancelDetailsInput!) {
  bulkUpdateUserCancelDetails(params: $params) {
    __typename
  }
}
    `;
export type BulkUpdateUserCancelDetailsMutationFn = Apollo.MutationFunction<BulkUpdateUserCancelDetailsMutation, BulkUpdateUserCancelDetailsMutationVariables>;

/**
 * __useBulkUpdateUserCancelDetailsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateUserCancelDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateUserCancelDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateUserCancelDetailsMutation, { data, loading, error }] = useBulkUpdateUserCancelDetailsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useBulkUpdateUserCancelDetailsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateUserCancelDetailsMutation, BulkUpdateUserCancelDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateUserCancelDetailsMutation, BulkUpdateUserCancelDetailsMutationVariables>(BulkUpdateUserCancelDetailsDocument, options);
      }
export type BulkUpdateUserCancelDetailsMutationHookResult = ReturnType<typeof useBulkUpdateUserCancelDetailsMutation>;
export type BulkUpdateUserCancelDetailsMutationResult = Apollo.MutationResult<BulkUpdateUserCancelDetailsMutation>;
export type BulkUpdateUserCancelDetailsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateUserCancelDetailsMutation, BulkUpdateUserCancelDetailsMutationVariables>;
export const CancelApplicationDocument = gql`
    mutation cancelApplication($params: CancelApplicationInput!) {
  cancelApplication(params: $params)
}
    `;
export type CancelApplicationMutationFn = Apollo.MutationFunction<CancelApplicationMutation, CancelApplicationMutationVariables>;

/**
 * __useCancelApplicationMutation__
 *
 * To run a mutation, you first call `useCancelApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelApplicationMutation, { data, loading, error }] = useCancelApplicationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCancelApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CancelApplicationMutation, CancelApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelApplicationMutation, CancelApplicationMutationVariables>(CancelApplicationDocument, options);
      }
export type CancelApplicationMutationHookResult = ReturnType<typeof useCancelApplicationMutation>;
export type CancelApplicationMutationResult = Apollo.MutationResult<CancelApplicationMutation>;
export type CancelApplicationMutationOptions = Apollo.BaseMutationOptions<CancelApplicationMutation, CancelApplicationMutationVariables>;
export const CancelSelectAgreementDocument = gql`
    mutation cancelSelectAgreement($projectId: String!, $params: CancelSelectAgreementInput!) {
  cancelSelectAgreement(projectId: $projectId, params: $params)
}
    `;
export type CancelSelectAgreementMutationFn = Apollo.MutationFunction<CancelSelectAgreementMutation, CancelSelectAgreementMutationVariables>;

/**
 * __useCancelSelectAgreementMutation__
 *
 * To run a mutation, you first call `useCancelSelectAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSelectAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSelectAgreementMutation, { data, loading, error }] = useCancelSelectAgreementMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCancelSelectAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CancelSelectAgreementMutation, CancelSelectAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSelectAgreementMutation, CancelSelectAgreementMutationVariables>(CancelSelectAgreementDocument, options);
      }
export type CancelSelectAgreementMutationHookResult = ReturnType<typeof useCancelSelectAgreementMutation>;
export type CancelSelectAgreementMutationResult = Apollo.MutationResult<CancelSelectAgreementMutation>;
export type CancelSelectAgreementMutationOptions = Apollo.BaseMutationOptions<CancelSelectAgreementMutation, CancelSelectAgreementMutationVariables>;
export const CopySelectMasterDocument = gql`
    mutation copySelectMaster($projectId: String!, $selectMasterId: Int!) {
  copySelectMaster(projectId: $projectId, selectMasterId: $selectMasterId)
}
    `;
export type CopySelectMasterMutationFn = Apollo.MutationFunction<CopySelectMasterMutation, CopySelectMasterMutationVariables>;

/**
 * __useCopySelectMasterMutation__
 *
 * To run a mutation, you first call `useCopySelectMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopySelectMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copySelectMasterMutation, { data, loading, error }] = useCopySelectMasterMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      selectMasterId: // value for 'selectMasterId'
 *   },
 * });
 */
export function useCopySelectMasterMutation(baseOptions?: Apollo.MutationHookOptions<CopySelectMasterMutation, CopySelectMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopySelectMasterMutation, CopySelectMasterMutationVariables>(CopySelectMasterDocument, options);
      }
export type CopySelectMasterMutationHookResult = ReturnType<typeof useCopySelectMasterMutation>;
export type CopySelectMasterMutationResult = Apollo.MutationResult<CopySelectMasterMutation>;
export type CopySelectMasterMutationOptions = Apollo.BaseMutationOptions<CopySelectMasterMutation, CopySelectMasterMutationVariables>;
export const CreateAllowedIpDocument = gql`
    mutation createAllowedIp($input: AllowedIpInput!) {
  createAllowedIp(params: $input)
}
    `;
export type CreateAllowedIpMutationFn = Apollo.MutationFunction<CreateAllowedIpMutation, CreateAllowedIpMutationVariables>;

/**
 * __useCreateAllowedIpMutation__
 *
 * To run a mutation, you first call `useCreateAllowedIpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllowedIpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllowedIpMutation, { data, loading, error }] = useCreateAllowedIpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAllowedIpMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllowedIpMutation, CreateAllowedIpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllowedIpMutation, CreateAllowedIpMutationVariables>(CreateAllowedIpDocument, options);
      }
export type CreateAllowedIpMutationHookResult = ReturnType<typeof useCreateAllowedIpMutation>;
export type CreateAllowedIpMutationResult = Apollo.MutationResult<CreateAllowedIpMutation>;
export type CreateAllowedIpMutationOptions = Apollo.BaseMutationOptions<CreateAllowedIpMutation, CreateAllowedIpMutationVariables>;
export const CreateApplicationDocument = gql`
    mutation createApplication($input: ApplicationInput!) {
  createApplication(params: $input) {
    appliedRoomIds
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const CreateCommonContentAssetDocument = gql`
    mutation CreateCommonContentAsset($commonPageId: Int!, $params: CommonAssetInput!) {
  createCommonAsset(commonPageId: $commonPageId, params: $params)
}
    `;
export type CreateCommonContentAssetMutationFn = Apollo.MutationFunction<CreateCommonContentAssetMutation, CreateCommonContentAssetMutationVariables>;

/**
 * __useCreateCommonContentAssetMutation__
 *
 * To run a mutation, you first call `useCreateCommonContentAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommonContentAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommonContentAssetMutation, { data, loading, error }] = useCreateCommonContentAssetMutation({
 *   variables: {
 *      commonPageId: // value for 'commonPageId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateCommonContentAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommonContentAssetMutation, CreateCommonContentAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommonContentAssetMutation, CreateCommonContentAssetMutationVariables>(CreateCommonContentAssetDocument, options);
      }
export type CreateCommonContentAssetMutationHookResult = ReturnType<typeof useCreateCommonContentAssetMutation>;
export type CreateCommonContentAssetMutationResult = Apollo.MutationResult<CreateCommonContentAssetMutation>;
export type CreateCommonContentAssetMutationOptions = Apollo.BaseMutationOptions<CreateCommonContentAssetMutation, CreateCommonContentAssetMutationVariables>;
export const CreateCommonContentPageDocument = gql`
    mutation CreateCommonContentPage($params: CommonPageInput!) {
  createCommonPage(params: $params)
}
    `;
export type CreateCommonContentPageMutationFn = Apollo.MutationFunction<CreateCommonContentPageMutation, CreateCommonContentPageMutationVariables>;

/**
 * __useCreateCommonContentPageMutation__
 *
 * To run a mutation, you first call `useCreateCommonContentPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommonContentPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommonContentPageMutation, { data, loading, error }] = useCreateCommonContentPageMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateCommonContentPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommonContentPageMutation, CreateCommonContentPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommonContentPageMutation, CreateCommonContentPageMutationVariables>(CreateCommonContentPageDocument, options);
      }
export type CreateCommonContentPageMutationHookResult = ReturnType<typeof useCreateCommonContentPageMutation>;
export type CreateCommonContentPageMutationResult = Apollo.MutationResult<CreateCommonContentPageMutation>;
export type CreateCommonContentPageMutationOptions = Apollo.BaseMutationOptions<CreateCommonContentPageMutation, CreateCommonContentPageMutationVariables>;
export const CreateCompanyRoleDocument = gql`
    mutation CreateCompanyRole($params: CompanyRoleInput!) {
  createCompanyRole(params: $params)
}
    `;
export type CreateCompanyRoleMutationFn = Apollo.MutationFunction<CreateCompanyRoleMutation, CreateCompanyRoleMutationVariables>;

/**
 * __useCreateCompanyRoleMutation__
 *
 * To run a mutation, you first call `useCreateCompanyRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyRoleMutation, { data, loading, error }] = useCreateCompanyRoleMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateCompanyRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyRoleMutation, CreateCompanyRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyRoleMutation, CreateCompanyRoleMutationVariables>(CreateCompanyRoleDocument, options);
      }
export type CreateCompanyRoleMutationHookResult = ReturnType<typeof useCreateCompanyRoleMutation>;
export type CreateCompanyRoleMutationResult = Apollo.MutationResult<CreateCompanyRoleMutation>;
export type CreateCompanyRoleMutationOptions = Apollo.BaseMutationOptions<CreateCompanyRoleMutation, CreateCompanyRoleMutationVariables>;
export const CreateCustomerEmailOptOutCsvPresignedUrlDocument = gql`
    mutation createCustomerEmailOptOutCsvPresignedUrl {
  presignedURLOptoutImport {
    presignedURL
    jobId
    s3URL
  }
}
    `;
export type CreateCustomerEmailOptOutCsvPresignedUrlMutationFn = Apollo.MutationFunction<CreateCustomerEmailOptOutCsvPresignedUrlMutation, CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables>;

/**
 * __useCreateCustomerEmailOptOutCsvPresignedUrlMutation__
 *
 * To run a mutation, you first call `useCreateCustomerEmailOptOutCsvPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerEmailOptOutCsvPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerEmailOptOutCsvPresignedUrlMutation, { data, loading, error }] = useCreateCustomerEmailOptOutCsvPresignedUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCustomerEmailOptOutCsvPresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerEmailOptOutCsvPresignedUrlMutation, CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerEmailOptOutCsvPresignedUrlMutation, CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables>(CreateCustomerEmailOptOutCsvPresignedUrlDocument, options);
      }
export type CreateCustomerEmailOptOutCsvPresignedUrlMutationHookResult = ReturnType<typeof useCreateCustomerEmailOptOutCsvPresignedUrlMutation>;
export type CreateCustomerEmailOptOutCsvPresignedUrlMutationResult = Apollo.MutationResult<CreateCustomerEmailOptOutCsvPresignedUrlMutation>;
export type CreateCustomerEmailOptOutCsvPresignedUrlMutationOptions = Apollo.BaseMutationOptions<CreateCustomerEmailOptOutCsvPresignedUrlMutation, CreateCustomerEmailOptOutCsvPresignedUrlMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($input: ProjectInput!) {
  createProject(params: $input)
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateRoomUsersCsvPresignedUrlDocument = gql`
    mutation createRoomUsersCsvPresignedUrl {
  presignedURLRoomUsersImport {
    presignedURL
    jobId
    s3URL
  }
}
    `;
export type CreateRoomUsersCsvPresignedUrlMutationFn = Apollo.MutationFunction<CreateRoomUsersCsvPresignedUrlMutation, CreateRoomUsersCsvPresignedUrlMutationVariables>;

/**
 * __useCreateRoomUsersCsvPresignedUrlMutation__
 *
 * To run a mutation, you first call `useCreateRoomUsersCsvPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomUsersCsvPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomUsersCsvPresignedUrlMutation, { data, loading, error }] = useCreateRoomUsersCsvPresignedUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateRoomUsersCsvPresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomUsersCsvPresignedUrlMutation, CreateRoomUsersCsvPresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomUsersCsvPresignedUrlMutation, CreateRoomUsersCsvPresignedUrlMutationVariables>(CreateRoomUsersCsvPresignedUrlDocument, options);
      }
export type CreateRoomUsersCsvPresignedUrlMutationHookResult = ReturnType<typeof useCreateRoomUsersCsvPresignedUrlMutation>;
export type CreateRoomUsersCsvPresignedUrlMutationResult = Apollo.MutationResult<CreateRoomUsersCsvPresignedUrlMutation>;
export type CreateRoomUsersCsvPresignedUrlMutationOptions = Apollo.BaseMutationOptions<CreateRoomUsersCsvPresignedUrlMutation, CreateRoomUsersCsvPresignedUrlMutationVariables>;
export const CreateRoomsCsvDocument = gql`
    mutation createRoomsCSV($projectId: String!, $params: CreateRoomsCSVInput!) {
  createRoomsCSV(projectId: $projectId, params: $params) {
    rooms {
      wingName
      floor
      roomName
      roomTypeName
      selectDisabled
      result
      message
    }
    errorMessage
  }
}
    `;
export type CreateRoomsCsvMutationFn = Apollo.MutationFunction<CreateRoomsCsvMutation, CreateRoomsCsvMutationVariables>;

/**
 * __useCreateRoomsCsvMutation__
 *
 * To run a mutation, you first call `useCreateRoomsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomsCsvMutation, { data, loading, error }] = useCreateRoomsCsvMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateRoomsCsvMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomsCsvMutation, CreateRoomsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomsCsvMutation, CreateRoomsCsvMutationVariables>(CreateRoomsCsvDocument, options);
      }
export type CreateRoomsCsvMutationHookResult = ReturnType<typeof useCreateRoomsCsvMutation>;
export type CreateRoomsCsvMutationResult = Apollo.MutationResult<CreateRoomsCsvMutation>;
export type CreateRoomsCsvMutationOptions = Apollo.BaseMutationOptions<CreateRoomsCsvMutation, CreateRoomsCsvMutationVariables>;
export const CreateSamlIdpDocument = gql`
    mutation createSAMLIdp($companyId: Int!, $params: SAMLIdpInput!) {
  createSAMLIdp(companyId: $companyId, params: $params)
}
    `;
export type CreateSamlIdpMutationFn = Apollo.MutationFunction<CreateSamlIdpMutation, CreateSamlIdpMutationVariables>;

/**
 * __useCreateSamlIdpMutation__
 *
 * To run a mutation, you first call `useCreateSamlIdpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamlIdpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamlIdpMutation, { data, loading, error }] = useCreateSamlIdpMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateSamlIdpMutation(baseOptions?: Apollo.MutationHookOptions<CreateSamlIdpMutation, CreateSamlIdpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSamlIdpMutation, CreateSamlIdpMutationVariables>(CreateSamlIdpDocument, options);
      }
export type CreateSamlIdpMutationHookResult = ReturnType<typeof useCreateSamlIdpMutation>;
export type CreateSamlIdpMutationResult = Apollo.MutationResult<CreateSamlIdpMutation>;
export type CreateSamlIdpMutationOptions = Apollo.BaseMutationOptions<CreateSamlIdpMutation, CreateSamlIdpMutationVariables>;
export const CreateSelectMasterDocument = gql`
    mutation CreateSelectMaster($projectId: String!, $params: SelectMasterInput!) {
  createSelectMaster(projectId: $projectId, params: $params)
}
    `;
export type CreateSelectMasterMutationFn = Apollo.MutationFunction<CreateSelectMasterMutation, CreateSelectMasterMutationVariables>;

/**
 * __useCreateSelectMasterMutation__
 *
 * To run a mutation, you first call `useCreateSelectMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelectMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelectMasterMutation, { data, loading, error }] = useCreateSelectMasterMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateSelectMasterMutation(baseOptions?: Apollo.MutationHookOptions<CreateSelectMasterMutation, CreateSelectMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSelectMasterMutation, CreateSelectMasterMutationVariables>(CreateSelectMasterDocument, options);
      }
export type CreateSelectMasterMutationHookResult = ReturnType<typeof useCreateSelectMasterMutation>;
export type CreateSelectMasterMutationResult = Apollo.MutationResult<CreateSelectMasterMutation>;
export type CreateSelectMasterMutationOptions = Apollo.BaseMutationOptions<CreateSelectMasterMutation, CreateSelectMasterMutationVariables>;
export const CreateWorkflowDocument = gql`
    mutation createWorkflow($params: WorkflowInput!) {
  createWorkflow(params: $params)
}
    `;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<CreateWorkflowMutation, CreateWorkflowMutationVariables>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
      }
export type CreateWorkflowMutationHookResult = ReturnType<typeof useCreateWorkflowMutation>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const DeleteAllowedIpDocument = gql`
    mutation deleteAllowedIp($input: Int!) {
  deleteAllowedIp(allowedIpId: $input)
}
    `;
export type DeleteAllowedIpMutationFn = Apollo.MutationFunction<DeleteAllowedIpMutation, DeleteAllowedIpMutationVariables>;

/**
 * __useDeleteAllowedIpMutation__
 *
 * To run a mutation, you first call `useDeleteAllowedIpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllowedIpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllowedIpMutation, { data, loading, error }] = useDeleteAllowedIpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllowedIpMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllowedIpMutation, DeleteAllowedIpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllowedIpMutation, DeleteAllowedIpMutationVariables>(DeleteAllowedIpDocument, options);
      }
export type DeleteAllowedIpMutationHookResult = ReturnType<typeof useDeleteAllowedIpMutation>;
export type DeleteAllowedIpMutationResult = Apollo.MutationResult<DeleteAllowedIpMutation>;
export type DeleteAllowedIpMutationOptions = Apollo.BaseMutationOptions<DeleteAllowedIpMutation, DeleteAllowedIpMutationVariables>;
export const DeleteCommonContentAssetDocument = gql`
    mutation DeleteCommonContentAsset($commonPageId: Int!, $commonAssetId: Int!) {
  deleteCommonAsset(commonPageId: $commonPageId, commonAssetId: $commonAssetId)
}
    `;
export type DeleteCommonContentAssetMutationFn = Apollo.MutationFunction<DeleteCommonContentAssetMutation, DeleteCommonContentAssetMutationVariables>;

/**
 * __useDeleteCommonContentAssetMutation__
 *
 * To run a mutation, you first call `useDeleteCommonContentAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommonContentAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommonContentAssetMutation, { data, loading, error }] = useDeleteCommonContentAssetMutation({
 *   variables: {
 *      commonPageId: // value for 'commonPageId'
 *      commonAssetId: // value for 'commonAssetId'
 *   },
 * });
 */
export function useDeleteCommonContentAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommonContentAssetMutation, DeleteCommonContentAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommonContentAssetMutation, DeleteCommonContentAssetMutationVariables>(DeleteCommonContentAssetDocument, options);
      }
export type DeleteCommonContentAssetMutationHookResult = ReturnType<typeof useDeleteCommonContentAssetMutation>;
export type DeleteCommonContentAssetMutationResult = Apollo.MutationResult<DeleteCommonContentAssetMutation>;
export type DeleteCommonContentAssetMutationOptions = Apollo.BaseMutationOptions<DeleteCommonContentAssetMutation, DeleteCommonContentAssetMutationVariables>;
export const DeleteCommonContentPageDocument = gql`
    mutation DeleteCommonContentPage($CommonPageId: Int!) {
  deleteCommonPage(commonPageId: $CommonPageId)
}
    `;
export type DeleteCommonContentPageMutationFn = Apollo.MutationFunction<DeleteCommonContentPageMutation, DeleteCommonContentPageMutationVariables>;

/**
 * __useDeleteCommonContentPageMutation__
 *
 * To run a mutation, you first call `useDeleteCommonContentPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommonContentPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommonContentPageMutation, { data, loading, error }] = useDeleteCommonContentPageMutation({
 *   variables: {
 *      CommonPageId: // value for 'CommonPageId'
 *   },
 * });
 */
export function useDeleteCommonContentPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommonContentPageMutation, DeleteCommonContentPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommonContentPageMutation, DeleteCommonContentPageMutationVariables>(DeleteCommonContentPageDocument, options);
      }
export type DeleteCommonContentPageMutationHookResult = ReturnType<typeof useDeleteCommonContentPageMutation>;
export type DeleteCommonContentPageMutationResult = Apollo.MutationResult<DeleteCommonContentPageMutation>;
export type DeleteCommonContentPageMutationOptions = Apollo.BaseMutationOptions<DeleteCommonContentPageMutation, DeleteCommonContentPageMutationVariables>;
export const DeleteCompanyRoleDocument = gql`
    mutation deleteCompanyRole($input: Int!) {
  deleteCompanyRole(roleId: $input)
}
    `;
export type DeleteCompanyRoleMutationFn = Apollo.MutationFunction<DeleteCompanyRoleMutation, DeleteCompanyRoleMutationVariables>;

/**
 * __useDeleteCompanyRoleMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyRoleMutation, { data, loading, error }] = useDeleteCompanyRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyRoleMutation, DeleteCompanyRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyRoleMutation, DeleteCompanyRoleMutationVariables>(DeleteCompanyRoleDocument, options);
      }
export type DeleteCompanyRoleMutationHookResult = ReturnType<typeof useDeleteCompanyRoleMutation>;
export type DeleteCompanyRoleMutationResult = Apollo.MutationResult<DeleteCompanyRoleMutation>;
export type DeleteCompanyRoleMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyRoleMutation, DeleteCompanyRoleMutationVariables>;
export const DestroyRoomUserDocument = gql`
    mutation destroyRoomUser($iamUserId: Int!, $roomId: Int!) {
  destroyRoomUser(iamUserId: $iamUserId, roomId: $roomId)
}
    `;
export type DestroyRoomUserMutationFn = Apollo.MutationFunction<DestroyRoomUserMutation, DestroyRoomUserMutationVariables>;

/**
 * __useDestroyRoomUserMutation__
 *
 * To run a mutation, you first call `useDestroyRoomUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyRoomUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyRoomUserMutation, { data, loading, error }] = useDestroyRoomUserMutation({
 *   variables: {
 *      iamUserId: // value for 'iamUserId'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useDestroyRoomUserMutation(baseOptions?: Apollo.MutationHookOptions<DestroyRoomUserMutation, DestroyRoomUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyRoomUserMutation, DestroyRoomUserMutationVariables>(DestroyRoomUserDocument, options);
      }
export type DestroyRoomUserMutationHookResult = ReturnType<typeof useDestroyRoomUserMutation>;
export type DestroyRoomUserMutationResult = Apollo.MutationResult<DestroyRoomUserMutation>;
export type DestroyRoomUserMutationOptions = Apollo.BaseMutationOptions<DestroyRoomUserMutation, DestroyRoomUserMutationVariables>;
export const DeleteCustomerDocument = gql`
    mutation deleteCustomer($email: String!) {
  deleteCustomer(email: $email)
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation deleteProject($projectId: String!) {
  deleteProject(projectId: $projectId)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteSamlIdpDocument = gql`
    mutation deleteSAMLIdp($companyId: Int!, $identityProviderId: Int!) {
  deleteSAMLIdp(companyId: $companyId, identityProviderId: $identityProviderId)
}
    `;
export type DeleteSamlIdpMutationFn = Apollo.MutationFunction<DeleteSamlIdpMutation, DeleteSamlIdpMutationVariables>;

/**
 * __useDeleteSamlIdpMutation__
 *
 * To run a mutation, you first call `useDeleteSamlIdpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSamlIdpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSamlIdpMutation, { data, loading, error }] = useDeleteSamlIdpMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      identityProviderId: // value for 'identityProviderId'
 *   },
 * });
 */
export function useDeleteSamlIdpMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSamlIdpMutation, DeleteSamlIdpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSamlIdpMutation, DeleteSamlIdpMutationVariables>(DeleteSamlIdpDocument, options);
      }
export type DeleteSamlIdpMutationHookResult = ReturnType<typeof useDeleteSamlIdpMutation>;
export type DeleteSamlIdpMutationResult = Apollo.MutationResult<DeleteSamlIdpMutation>;
export type DeleteSamlIdpMutationOptions = Apollo.BaseMutationOptions<DeleteSamlIdpMutation, DeleteSamlIdpMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($input: Int!) {
  deleteUser(userId: $input)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ExchangeAuthCodeWithAccessTokenDocument = gql`
    mutation exchangeAuthCodeWithAccessToken($code: String!) {
  exchangeAuthCodeWithAccessToken(code: $code) {
    session {
      accessToken
      refreshToken
      accessTokenExpiresAt
      refreshTokenExpiresAt
      cognitoUsername
    }
  }
}
    `;
export type ExchangeAuthCodeWithAccessTokenMutationFn = Apollo.MutationFunction<ExchangeAuthCodeWithAccessTokenMutation, ExchangeAuthCodeWithAccessTokenMutationVariables>;

/**
 * __useExchangeAuthCodeWithAccessTokenMutation__
 *
 * To run a mutation, you first call `useExchangeAuthCodeWithAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeAuthCodeWithAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeAuthCodeWithAccessTokenMutation, { data, loading, error }] = useExchangeAuthCodeWithAccessTokenMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useExchangeAuthCodeWithAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeAuthCodeWithAccessTokenMutation, ExchangeAuthCodeWithAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeAuthCodeWithAccessTokenMutation, ExchangeAuthCodeWithAccessTokenMutationVariables>(ExchangeAuthCodeWithAccessTokenDocument, options);
      }
export type ExchangeAuthCodeWithAccessTokenMutationHookResult = ReturnType<typeof useExchangeAuthCodeWithAccessTokenMutation>;
export type ExchangeAuthCodeWithAccessTokenMutationResult = Apollo.MutationResult<ExchangeAuthCodeWithAccessTokenMutation>;
export type ExchangeAuthCodeWithAccessTokenMutationOptions = Apollo.BaseMutationOptions<ExchangeAuthCodeWithAccessTokenMutation, ExchangeAuthCodeWithAccessTokenMutationVariables>;
export const ExcludeRoomsFromOrderApplicationDocument = gql`
    mutation excludeRoomsFromOrderApplication($projectId: String!, $params: ExcludeRoomsFromOrderApplicationInput!) {
  excludeRoomsFromOrderApplication(projectId: $projectId, params: $params)
}
    `;
export type ExcludeRoomsFromOrderApplicationMutationFn = Apollo.MutationFunction<ExcludeRoomsFromOrderApplicationMutation, ExcludeRoomsFromOrderApplicationMutationVariables>;

/**
 * __useExcludeRoomsFromOrderApplicationMutation__
 *
 * To run a mutation, you first call `useExcludeRoomsFromOrderApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeRoomsFromOrderApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeRoomsFromOrderApplicationMutation, { data, loading, error }] = useExcludeRoomsFromOrderApplicationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useExcludeRoomsFromOrderApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ExcludeRoomsFromOrderApplicationMutation, ExcludeRoomsFromOrderApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcludeRoomsFromOrderApplicationMutation, ExcludeRoomsFromOrderApplicationMutationVariables>(ExcludeRoomsFromOrderApplicationDocument, options);
      }
export type ExcludeRoomsFromOrderApplicationMutationHookResult = ReturnType<typeof useExcludeRoomsFromOrderApplicationMutation>;
export type ExcludeRoomsFromOrderApplicationMutationResult = Apollo.MutationResult<ExcludeRoomsFromOrderApplicationMutation>;
export type ExcludeRoomsFromOrderApplicationMutationOptions = Apollo.BaseMutationOptions<ExcludeRoomsFromOrderApplicationMutation, ExcludeRoomsFromOrderApplicationMutationVariables>;
export const ExcludeRoomsFromPublishApplicationDocument = gql`
    mutation excludeRoomsFromPublishApplication($projectId: String!, $params: ExcludeRoomsFromPublishApplicationInput!) {
  excludeRoomsFromPublishApplication(projectId: $projectId, params: $params)
}
    `;
export type ExcludeRoomsFromPublishApplicationMutationFn = Apollo.MutationFunction<ExcludeRoomsFromPublishApplicationMutation, ExcludeRoomsFromPublishApplicationMutationVariables>;

/**
 * __useExcludeRoomsFromPublishApplicationMutation__
 *
 * To run a mutation, you first call `useExcludeRoomsFromPublishApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeRoomsFromPublishApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeRoomsFromPublishApplicationMutation, { data, loading, error }] = useExcludeRoomsFromPublishApplicationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useExcludeRoomsFromPublishApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ExcludeRoomsFromPublishApplicationMutation, ExcludeRoomsFromPublishApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcludeRoomsFromPublishApplicationMutation, ExcludeRoomsFromPublishApplicationMutationVariables>(ExcludeRoomsFromPublishApplicationDocument, options);
      }
export type ExcludeRoomsFromPublishApplicationMutationHookResult = ReturnType<typeof useExcludeRoomsFromPublishApplicationMutation>;
export type ExcludeRoomsFromPublishApplicationMutationResult = Apollo.MutationResult<ExcludeRoomsFromPublishApplicationMutation>;
export type ExcludeRoomsFromPublishApplicationMutationOptions = Apollo.BaseMutationOptions<ExcludeRoomsFromPublishApplicationMutation, ExcludeRoomsFromPublishApplicationMutationVariables>;
export const ForceUpdateExternalUserPasswordDocument = gql`
    mutation forceUpdateExternalUserPassword($userId: Int!, $input: ForceUpdatePasswordInput!) {
  forceUpdateExternalUserPassword(userId: $userId, params: $input)
}
    `;
export type ForceUpdateExternalUserPasswordMutationFn = Apollo.MutationFunction<ForceUpdateExternalUserPasswordMutation, ForceUpdateExternalUserPasswordMutationVariables>;

/**
 * __useForceUpdateExternalUserPasswordMutation__
 *
 * To run a mutation, you first call `useForceUpdateExternalUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceUpdateExternalUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceUpdateExternalUserPasswordMutation, { data, loading, error }] = useForceUpdateExternalUserPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForceUpdateExternalUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForceUpdateExternalUserPasswordMutation, ForceUpdateExternalUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceUpdateExternalUserPasswordMutation, ForceUpdateExternalUserPasswordMutationVariables>(ForceUpdateExternalUserPasswordDocument, options);
      }
export type ForceUpdateExternalUserPasswordMutationHookResult = ReturnType<typeof useForceUpdateExternalUserPasswordMutation>;
export type ForceUpdateExternalUserPasswordMutationResult = Apollo.MutationResult<ForceUpdateExternalUserPasswordMutation>;
export type ForceUpdateExternalUserPasswordMutationOptions = Apollo.BaseMutationOptions<ForceUpdateExternalUserPasswordMutation, ForceUpdateExternalUserPasswordMutationVariables>;
export const ForceUpdateUserPasswordDocument = gql`
    mutation forceUpdateUserPassword($userId: Int!, $input: ForceUpdatePasswordInput!) {
  forceUpdateUserPassword(userId: $userId, params: $input)
}
    `;
export type ForceUpdateUserPasswordMutationFn = Apollo.MutationFunction<ForceUpdateUserPasswordMutation, ForceUpdateUserPasswordMutationVariables>;

/**
 * __useForceUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useForceUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceUpdateUserPasswordMutation, { data, loading, error }] = useForceUpdateUserPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForceUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForceUpdateUserPasswordMutation, ForceUpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceUpdateUserPasswordMutation, ForceUpdateUserPasswordMutationVariables>(ForceUpdateUserPasswordDocument, options);
      }
export type ForceUpdateUserPasswordMutationHookResult = ReturnType<typeof useForceUpdateUserPasswordMutation>;
export type ForceUpdateUserPasswordMutationResult = Apollo.MutationResult<ForceUpdateUserPasswordMutation>;
export type ForceUpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<ForceUpdateUserPasswordMutation, ForceUpdateUserPasswordMutationVariables>;
export const ForgetPasswordEmailDocument = gql`
    mutation forgetPasswordEmail($input: ForgetPasswordInput!) {
  forgetPassword(params: $input)
}
    `;
export type ForgetPasswordEmailMutationFn = Apollo.MutationFunction<ForgetPasswordEmailMutation, ForgetPasswordEmailMutationVariables>;

/**
 * __useForgetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useForgetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgetPasswordEmailMutation, { data, loading, error }] = useForgetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<ForgetPasswordEmailMutation, ForgetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgetPasswordEmailMutation, ForgetPasswordEmailMutationVariables>(ForgetPasswordEmailDocument, options);
      }
export type ForgetPasswordEmailMutationHookResult = ReturnType<typeof useForgetPasswordEmailMutation>;
export type ForgetPasswordEmailMutationResult = Apollo.MutationResult<ForgetPasswordEmailMutation>;
export type ForgetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<ForgetPasswordEmailMutation, ForgetPasswordEmailMutationVariables>;
export const IdPassLoginDocument = gql`
    mutation idPassLogin($input: LoginInput!) {
  login(params: $input) {
    session {
      accessToken
      refreshToken
      accessTokenExpiresAt
      refreshTokenExpiresAt
      cognitoUsername
    }
  }
}
    `;
export type IdPassLoginMutationFn = Apollo.MutationFunction<IdPassLoginMutation, IdPassLoginMutationVariables>;

/**
 * __useIdPassLoginMutation__
 *
 * To run a mutation, you first call `useIdPassLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdPassLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idPassLoginMutation, { data, loading, error }] = useIdPassLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIdPassLoginMutation(baseOptions?: Apollo.MutationHookOptions<IdPassLoginMutation, IdPassLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdPassLoginMutation, IdPassLoginMutationVariables>(IdPassLoginDocument, options);
      }
export type IdPassLoginMutationHookResult = ReturnType<typeof useIdPassLoginMutation>;
export type IdPassLoginMutationResult = Apollo.MutationResult<IdPassLoginMutation>;
export type IdPassLoginMutationOptions = Apollo.BaseMutationOptions<IdPassLoginMutation, IdPassLoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout($input: LogoutInput!) {
  logout(params: $input)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const NotifyFinishedUploadContractorCsvDocument = gql`
    mutation notifyFinishedUploadContractorCsv($params: ImportRoomUsersInput!) {
  importRoomUsers(params: $params)
}
    `;
export type NotifyFinishedUploadContractorCsvMutationFn = Apollo.MutationFunction<NotifyFinishedUploadContractorCsvMutation, NotifyFinishedUploadContractorCsvMutationVariables>;

/**
 * __useNotifyFinishedUploadContractorCsvMutation__
 *
 * To run a mutation, you first call `useNotifyFinishedUploadContractorCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyFinishedUploadContractorCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyFinishedUploadContractorCsvMutation, { data, loading, error }] = useNotifyFinishedUploadContractorCsvMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useNotifyFinishedUploadContractorCsvMutation(baseOptions?: Apollo.MutationHookOptions<NotifyFinishedUploadContractorCsvMutation, NotifyFinishedUploadContractorCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyFinishedUploadContractorCsvMutation, NotifyFinishedUploadContractorCsvMutationVariables>(NotifyFinishedUploadContractorCsvDocument, options);
      }
export type NotifyFinishedUploadContractorCsvMutationHookResult = ReturnType<typeof useNotifyFinishedUploadContractorCsvMutation>;
export type NotifyFinishedUploadContractorCsvMutationResult = Apollo.MutationResult<NotifyFinishedUploadContractorCsvMutation>;
export type NotifyFinishedUploadContractorCsvMutationOptions = Apollo.BaseMutationOptions<NotifyFinishedUploadContractorCsvMutation, NotifyFinishedUploadContractorCsvMutationVariables>;
export const NotifyFinishedUploadCustomerEmailOptOutCsvDocument = gql`
    mutation notifyFinishedUploadCustomerEmailOptOutCsv($params: ImportOptoutInput!) {
  importOptout(params: $params)
}
    `;
export type NotifyFinishedUploadCustomerEmailOptOutCsvMutationFn = Apollo.MutationFunction<NotifyFinishedUploadCustomerEmailOptOutCsvMutation, NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables>;

/**
 * __useNotifyFinishedUploadCustomerEmailOptOutCsvMutation__
 *
 * To run a mutation, you first call `useNotifyFinishedUploadCustomerEmailOptOutCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyFinishedUploadCustomerEmailOptOutCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyFinishedUploadCustomerEmailOptOutCsvMutation, { data, loading, error }] = useNotifyFinishedUploadCustomerEmailOptOutCsvMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useNotifyFinishedUploadCustomerEmailOptOutCsvMutation(baseOptions?: Apollo.MutationHookOptions<NotifyFinishedUploadCustomerEmailOptOutCsvMutation, NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyFinishedUploadCustomerEmailOptOutCsvMutation, NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables>(NotifyFinishedUploadCustomerEmailOptOutCsvDocument, options);
      }
export type NotifyFinishedUploadCustomerEmailOptOutCsvMutationHookResult = ReturnType<typeof useNotifyFinishedUploadCustomerEmailOptOutCsvMutation>;
export type NotifyFinishedUploadCustomerEmailOptOutCsvMutationResult = Apollo.MutationResult<NotifyFinishedUploadCustomerEmailOptOutCsvMutation>;
export type NotifyFinishedUploadCustomerEmailOptOutCsvMutationOptions = Apollo.BaseMutationOptions<NotifyFinishedUploadCustomerEmailOptOutCsvMutation, NotifyFinishedUploadCustomerEmailOptOutCsvMutationVariables>;
export const RefreshAuthTokenDocument = gql`
    mutation refreshAuthToken($input: RefreshAccessTokenInput!) {
  refreshAccessToken(params: $input) {
    session {
      accessToken
      refreshToken
      accessTokenExpiresAt
      refreshTokenExpiresAt
      cognitoUsername
    }
  }
}
    `;
export type RefreshAuthTokenMutationFn = Apollo.MutationFunction<RefreshAuthTokenMutation, RefreshAuthTokenMutationVariables>;

/**
 * __useRefreshAuthTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthTokenMutation, { data, loading, error }] = useRefreshAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAuthTokenMutation, RefreshAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAuthTokenMutation, RefreshAuthTokenMutationVariables>(RefreshAuthTokenDocument, options);
      }
export type RefreshAuthTokenMutationHookResult = ReturnType<typeof useRefreshAuthTokenMutation>;
export type RefreshAuthTokenMutationResult = Apollo.MutationResult<RefreshAuthTokenMutation>;
export type RefreshAuthTokenMutationOptions = Apollo.BaseMutationOptions<RefreshAuthTokenMutation, RefreshAuthTokenMutationVariables>;
export const RegisterContractorDocument = gql`
    mutation registerContractor($params: RegisterRoomUserInput!) {
  registerRoomUser(params: $params)
}
    `;
export type RegisterContractorMutationFn = Apollo.MutationFunction<RegisterContractorMutation, RegisterContractorMutationVariables>;

/**
 * __useRegisterContractorMutation__
 *
 * To run a mutation, you first call `useRegisterContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerContractorMutation, { data, loading, error }] = useRegisterContractorMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useRegisterContractorMutation(baseOptions?: Apollo.MutationHookOptions<RegisterContractorMutation, RegisterContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterContractorMutation, RegisterContractorMutationVariables>(RegisterContractorDocument, options);
      }
export type RegisterContractorMutationHookResult = ReturnType<typeof useRegisterContractorMutation>;
export type RegisterContractorMutationResult = Apollo.MutationResult<RegisterContractorMutation>;
export type RegisterContractorMutationOptions = Apollo.BaseMutationOptions<RegisterContractorMutation, RegisterContractorMutationVariables>;
export const RegisterSelectsDocument = gql`
    mutation registerSelects($projectId: String!, $input: RegisterSelectsInput!) {
  registerSelects(projectId: $projectId, params: $input)
}
    `;
export type RegisterSelectsMutationFn = Apollo.MutationFunction<RegisterSelectsMutation, RegisterSelectsMutationVariables>;

/**
 * __useRegisterSelectsMutation__
 *
 * To run a mutation, you first call `useRegisterSelectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterSelectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerSelectsMutation, { data, loading, error }] = useRegisterSelectsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterSelectsMutation(baseOptions?: Apollo.MutationHookOptions<RegisterSelectsMutation, RegisterSelectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterSelectsMutation, RegisterSelectsMutationVariables>(RegisterSelectsDocument, options);
      }
export type RegisterSelectsMutationHookResult = ReturnType<typeof useRegisterSelectsMutation>;
export type RegisterSelectsMutationResult = Apollo.MutationResult<RegisterSelectsMutation>;
export type RegisterSelectsMutationOptions = Apollo.BaseMutationOptions<RegisterSelectsMutation, RegisterSelectsMutationVariables>;
export const ReorderCommonContentAssetsDocument = gql`
    mutation ReorderCommonContentAssets($commonPageId: Int!, $params: ReorderCommonAssetInput!) {
  reorderCommonAssets(commonPageId: $commonPageId, params: $params)
}
    `;
export type ReorderCommonContentAssetsMutationFn = Apollo.MutationFunction<ReorderCommonContentAssetsMutation, ReorderCommonContentAssetsMutationVariables>;

/**
 * __useReorderCommonContentAssetsMutation__
 *
 * To run a mutation, you first call `useReorderCommonContentAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCommonContentAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCommonContentAssetsMutation, { data, loading, error }] = useReorderCommonContentAssetsMutation({
 *   variables: {
 *      commonPageId: // value for 'commonPageId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useReorderCommonContentAssetsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCommonContentAssetsMutation, ReorderCommonContentAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCommonContentAssetsMutation, ReorderCommonContentAssetsMutationVariables>(ReorderCommonContentAssetsDocument, options);
      }
export type ReorderCommonContentAssetsMutationHookResult = ReturnType<typeof useReorderCommonContentAssetsMutation>;
export type ReorderCommonContentAssetsMutationResult = Apollo.MutationResult<ReorderCommonContentAssetsMutation>;
export type ReorderCommonContentAssetsMutationOptions = Apollo.BaseMutationOptions<ReorderCommonContentAssetsMutation, ReorderCommonContentAssetsMutationVariables>;
export const ReorderCommonContentPagesDocument = gql`
    mutation ReorderCommonContentPages($params: ReorderCommonPageInput!) {
  reorderCommonPages(params: $params)
}
    `;
export type ReorderCommonContentPagesMutationFn = Apollo.MutationFunction<ReorderCommonContentPagesMutation, ReorderCommonContentPagesMutationVariables>;

/**
 * __useReorderCommonContentPagesMutation__
 *
 * To run a mutation, you first call `useReorderCommonContentPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCommonContentPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCommonContentPagesMutation, { data, loading, error }] = useReorderCommonContentPagesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useReorderCommonContentPagesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCommonContentPagesMutation, ReorderCommonContentPagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCommonContentPagesMutation, ReorderCommonContentPagesMutationVariables>(ReorderCommonContentPagesDocument, options);
      }
export type ReorderCommonContentPagesMutationHookResult = ReturnType<typeof useReorderCommonContentPagesMutation>;
export type ReorderCommonContentPagesMutationResult = Apollo.MutationResult<ReorderCommonContentPagesMutation>;
export type ReorderCommonContentPagesMutationOptions = Apollo.BaseMutationOptions<ReorderCommonContentPagesMutation, ReorderCommonContentPagesMutationVariables>;
export const SendSelectEmailDocument = gql`
    mutation sendSelectEmail($projectId: String!, $input: sendSelectEmailsInput!) {
  sendSelectEmails(projectId: $projectId, params: $input)
}
    `;
export type SendSelectEmailMutationFn = Apollo.MutationFunction<SendSelectEmailMutation, SendSelectEmailMutationVariables>;

/**
 * __useSendSelectEmailMutation__
 *
 * To run a mutation, you first call `useSendSelectEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSelectEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSelectEmailMutation, { data, loading, error }] = useSendSelectEmailMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSelectEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendSelectEmailMutation, SendSelectEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSelectEmailMutation, SendSelectEmailMutationVariables>(SendSelectEmailDocument, options);
      }
export type SendSelectEmailMutationHookResult = ReturnType<typeof useSendSelectEmailMutation>;
export type SendSelectEmailMutationResult = Apollo.MutationResult<SendSelectEmailMutation>;
export type SendSelectEmailMutationOptions = Apollo.BaseMutationOptions<SendSelectEmailMutation, SendSelectEmailMutationVariables>;
export const UpdateAllowedIpDocument = gql`
    mutation updateAllowedIp($id: Int!, $input: AllowedIpInput!) {
  updateAllowedIp(allowedIpId: $id, params: $input)
}
    `;
export type UpdateAllowedIpMutationFn = Apollo.MutationFunction<UpdateAllowedIpMutation, UpdateAllowedIpMutationVariables>;

/**
 * __useUpdateAllowedIpMutation__
 *
 * To run a mutation, you first call `useUpdateAllowedIpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowedIpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowedIpMutation, { data, loading, error }] = useUpdateAllowedIpMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllowedIpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllowedIpMutation, UpdateAllowedIpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllowedIpMutation, UpdateAllowedIpMutationVariables>(UpdateAllowedIpDocument, options);
      }
export type UpdateAllowedIpMutationHookResult = ReturnType<typeof useUpdateAllowedIpMutation>;
export type UpdateAllowedIpMutationResult = Apollo.MutationResult<UpdateAllowedIpMutation>;
export type UpdateAllowedIpMutationOptions = Apollo.BaseMutationOptions<UpdateAllowedIpMutation, UpdateAllowedIpMutationVariables>;
export const UpdateApplicationStepConfirmationDocument = gql`
    mutation updateApplicationStepConfirmation($input: UpdateApplicationStepConfirmationInput!) {
  updateApplicationStepConfirmation(params: $input)
}
    `;
export type UpdateApplicationStepConfirmationMutationFn = Apollo.MutationFunction<UpdateApplicationStepConfirmationMutation, UpdateApplicationStepConfirmationMutationVariables>;

/**
 * __useUpdateApplicationStepConfirmationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationStepConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationStepConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationStepConfirmationMutation, { data, loading, error }] = useUpdateApplicationStepConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationStepConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationStepConfirmationMutation, UpdateApplicationStepConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationStepConfirmationMutation, UpdateApplicationStepConfirmationMutationVariables>(UpdateApplicationStepConfirmationDocument, options);
      }
export type UpdateApplicationStepConfirmationMutationHookResult = ReturnType<typeof useUpdateApplicationStepConfirmationMutation>;
export type UpdateApplicationStepConfirmationMutationResult = Apollo.MutationResult<UpdateApplicationStepConfirmationMutation>;
export type UpdateApplicationStepConfirmationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationStepConfirmationMutation, UpdateApplicationStepConfirmationMutationVariables>;
export const UpdateCommonContentAssetDocument = gql`
    mutation UpdateCommonContentAsset($commonPageId: Int!, $commonAssetId: Int!, $params: CommonAssetInput!) {
  updateCommonAsset(
    commonPageId: $commonPageId
    commonAssetId: $commonAssetId
    params: $params
  )
}
    `;
export type UpdateCommonContentAssetMutationFn = Apollo.MutationFunction<UpdateCommonContentAssetMutation, UpdateCommonContentAssetMutationVariables>;

/**
 * __useUpdateCommonContentAssetMutation__
 *
 * To run a mutation, you first call `useUpdateCommonContentAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommonContentAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommonContentAssetMutation, { data, loading, error }] = useUpdateCommonContentAssetMutation({
 *   variables: {
 *      commonPageId: // value for 'commonPageId'
 *      commonAssetId: // value for 'commonAssetId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCommonContentAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommonContentAssetMutation, UpdateCommonContentAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommonContentAssetMutation, UpdateCommonContentAssetMutationVariables>(UpdateCommonContentAssetDocument, options);
      }
export type UpdateCommonContentAssetMutationHookResult = ReturnType<typeof useUpdateCommonContentAssetMutation>;
export type UpdateCommonContentAssetMutationResult = Apollo.MutationResult<UpdateCommonContentAssetMutation>;
export type UpdateCommonContentAssetMutationOptions = Apollo.BaseMutationOptions<UpdateCommonContentAssetMutation, UpdateCommonContentAssetMutationVariables>;
export const UpdateCommonContentPageDocument = gql`
    mutation UpdateCommonContentPage($commonPageId: Int!, $params: CommonPageInput!) {
  updateCommonPage(commonPageId: $commonPageId, params: $params)
}
    `;
export type UpdateCommonContentPageMutationFn = Apollo.MutationFunction<UpdateCommonContentPageMutation, UpdateCommonContentPageMutationVariables>;

/**
 * __useUpdateCommonContentPageMutation__
 *
 * To run a mutation, you first call `useUpdateCommonContentPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommonContentPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommonContentPageMutation, { data, loading, error }] = useUpdateCommonContentPageMutation({
 *   variables: {
 *      commonPageId: // value for 'commonPageId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCommonContentPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommonContentPageMutation, UpdateCommonContentPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommonContentPageMutation, UpdateCommonContentPageMutationVariables>(UpdateCommonContentPageDocument, options);
      }
export type UpdateCommonContentPageMutationHookResult = ReturnType<typeof useUpdateCommonContentPageMutation>;
export type UpdateCommonContentPageMutationResult = Apollo.MutationResult<UpdateCommonContentPageMutation>;
export type UpdateCommonContentPageMutationOptions = Apollo.BaseMutationOptions<UpdateCommonContentPageMutation, UpdateCommonContentPageMutationVariables>;
export const UpdateCompanyAuthMethodDocument = gql`
    mutation updateCompanyAuthMethod($companyId: Int!, $params: UpdateCompanyAuthMethodInput!) {
  updateCompanyAuthMethod(companyId: $companyId, params: $params)
}
    `;
export type UpdateCompanyAuthMethodMutationFn = Apollo.MutationFunction<UpdateCompanyAuthMethodMutation, UpdateCompanyAuthMethodMutationVariables>;

/**
 * __useUpdateCompanyAuthMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAuthMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAuthMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAuthMethodMutation, { data, loading, error }] = useUpdateCompanyAuthMethodMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCompanyAuthMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyAuthMethodMutation, UpdateCompanyAuthMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyAuthMethodMutation, UpdateCompanyAuthMethodMutationVariables>(UpdateCompanyAuthMethodDocument, options);
      }
export type UpdateCompanyAuthMethodMutationHookResult = ReturnType<typeof useUpdateCompanyAuthMethodMutation>;
export type UpdateCompanyAuthMethodMutationResult = Apollo.MutationResult<UpdateCompanyAuthMethodMutation>;
export type UpdateCompanyAuthMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyAuthMethodMutation, UpdateCompanyAuthMethodMutationVariables>;
export const UpdateCompanyRoleDocument = gql`
    mutation UpdateCompanyRole($roleId: Int!, $params: CompanyRoleInput!) {
  updateCompanyRole(roleId: $roleId, params: $params)
}
    `;
export type UpdateCompanyRoleMutationFn = Apollo.MutationFunction<UpdateCompanyRoleMutation, UpdateCompanyRoleMutationVariables>;

/**
 * __useUpdateCompanyRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyRoleMutation, { data, loading, error }] = useUpdateCompanyRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCompanyRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyRoleMutation, UpdateCompanyRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyRoleMutation, UpdateCompanyRoleMutationVariables>(UpdateCompanyRoleDocument, options);
      }
export type UpdateCompanyRoleMutationHookResult = ReturnType<typeof useUpdateCompanyRoleMutation>;
export type UpdateCompanyRoleMutationResult = Apollo.MutationResult<UpdateCompanyRoleMutation>;
export type UpdateCompanyRoleMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyRoleMutation, UpdateCompanyRoleMutationVariables>;
export const UpdateRoomUserConfirmationCodeDocument = gql`
    mutation updateRoomUserConfirmationCode($projectId: String!, $roomId: Int!, $params: UpdateRoomUserConfirmationCodeInput!) {
  updateRoomUserConfirmationCode(
    projectId: $projectId
    roomId: $roomId
    params: $params
  )
}
    `;
export type UpdateRoomUserConfirmationCodeMutationFn = Apollo.MutationFunction<UpdateRoomUserConfirmationCodeMutation, UpdateRoomUserConfirmationCodeMutationVariables>;

/**
 * __useUpdateRoomUserConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUpdateRoomUserConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomUserConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomUserConfirmationCodeMutation, { data, loading, error }] = useUpdateRoomUserConfirmationCodeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roomId: // value for 'roomId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateRoomUserConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomUserConfirmationCodeMutation, UpdateRoomUserConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomUserConfirmationCodeMutation, UpdateRoomUserConfirmationCodeMutationVariables>(UpdateRoomUserConfirmationCodeDocument, options);
      }
export type UpdateRoomUserConfirmationCodeMutationHookResult = ReturnType<typeof useUpdateRoomUserConfirmationCodeMutation>;
export type UpdateRoomUserConfirmationCodeMutationResult = Apollo.MutationResult<UpdateRoomUserConfirmationCodeMutation>;
export type UpdateRoomUserConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UpdateRoomUserConfirmationCodeMutation, UpdateRoomUserConfirmationCodeMutationVariables>;
export const UpdateExternalUserNameDocument = gql`
    mutation UpdateExternalUserName($userId: Int!, $name: String!) {
  updateExternalUserName(userId: $userId, name: $name)
}
    `;
export type UpdateExternalUserNameMutationFn = Apollo.MutationFunction<UpdateExternalUserNameMutation, UpdateExternalUserNameMutationVariables>;

/**
 * __useUpdateExternalUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateExternalUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalUserNameMutation, { data, loading, error }] = useUpdateExternalUserNameMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateExternalUserNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalUserNameMutation, UpdateExternalUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalUserNameMutation, UpdateExternalUserNameMutationVariables>(UpdateExternalUserNameDocument, options);
      }
export type UpdateExternalUserNameMutationHookResult = ReturnType<typeof useUpdateExternalUserNameMutation>;
export type UpdateExternalUserNameMutationResult = Apollo.MutationResult<UpdateExternalUserNameMutation>;
export type UpdateExternalUserNameMutationOptions = Apollo.BaseMutationOptions<UpdateExternalUserNameMutation, UpdateExternalUserNameMutationVariables>;
export const UpdateInitialPasswordDocument = gql`
    mutation updateInitialPassword($input: UpdateInitPasswordInput!) {
  updateInitPassword(params: $input)
}
    `;
export type UpdateInitialPasswordMutationFn = Apollo.MutationFunction<UpdateInitialPasswordMutation, UpdateInitialPasswordMutationVariables>;

/**
 * __useUpdateInitialPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateInitialPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInitialPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInitialPasswordMutation, { data, loading, error }] = useUpdateInitialPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInitialPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInitialPasswordMutation, UpdateInitialPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInitialPasswordMutation, UpdateInitialPasswordMutationVariables>(UpdateInitialPasswordDocument, options);
      }
export type UpdateInitialPasswordMutationHookResult = ReturnType<typeof useUpdateInitialPasswordMutation>;
export type UpdateInitialPasswordMutationResult = Apollo.MutationResult<UpdateInitialPasswordMutation>;
export type UpdateInitialPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateInitialPasswordMutation, UpdateInitialPasswordMutationVariables>;
export const UpdateInternalUserNameDocument = gql`
    mutation UpdateInternalUserName($userId: Int!, $name: String!) {
  updateInternalUserName(userId: $userId, name: $name)
}
    `;
export type UpdateInternalUserNameMutationFn = Apollo.MutationFunction<UpdateInternalUserNameMutation, UpdateInternalUserNameMutationVariables>;

/**
 * __useUpdateInternalUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateInternalUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalUserNameMutation, { data, loading, error }] = useUpdateInternalUserNameMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateInternalUserNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalUserNameMutation, UpdateInternalUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalUserNameMutation, UpdateInternalUserNameMutationVariables>(UpdateInternalUserNameDocument, options);
      }
export type UpdateInternalUserNameMutationHookResult = ReturnType<typeof useUpdateInternalUserNameMutation>;
export type UpdateInternalUserNameMutationResult = Apollo.MutationResult<UpdateInternalUserNameMutation>;
export type UpdateInternalUserNameMutationOptions = Apollo.BaseMutationOptions<UpdateInternalUserNameMutation, UpdateInternalUserNameMutationVariables>;
export const UpdateIpRestrictionDocument = gql`
    mutation updateIpRestriction($input: UpdateIpRestrictionInput!) {
  updateIpRestriction(params: $input)
}
    `;
export type UpdateIpRestrictionMutationFn = Apollo.MutationFunction<UpdateIpRestrictionMutation, UpdateIpRestrictionMutationVariables>;

/**
 * __useUpdateIpRestrictionMutation__
 *
 * To run a mutation, you first call `useUpdateIpRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIpRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIpRestrictionMutation, { data, loading, error }] = useUpdateIpRestrictionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIpRestrictionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIpRestrictionMutation, UpdateIpRestrictionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIpRestrictionMutation, UpdateIpRestrictionMutationVariables>(UpdateIpRestrictionDocument, options);
      }
export type UpdateIpRestrictionMutationHookResult = ReturnType<typeof useUpdateIpRestrictionMutation>;
export type UpdateIpRestrictionMutationResult = Apollo.MutationResult<UpdateIpRestrictionMutation>;
export type UpdateIpRestrictionMutationOptions = Apollo.BaseMutationOptions<UpdateIpRestrictionMutation, UpdateIpRestrictionMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordInput!) {
  updatePassword(params: $input)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateProfileNameDocument = gql`
    mutation updateProfileName($input: String!) {
  updateProfileName(name: $input)
}
    `;
export type UpdateProfileNameMutationFn = Apollo.MutationFunction<UpdateProfileNameMutation, UpdateProfileNameMutationVariables>;

/**
 * __useUpdateProfileNameMutation__
 *
 * To run a mutation, you first call `useUpdateProfileNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileNameMutation, { data, loading, error }] = useUpdateProfileNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileNameMutation, UpdateProfileNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileNameMutation, UpdateProfileNameMutationVariables>(UpdateProfileNameDocument, options);
      }
export type UpdateProfileNameMutationHookResult = ReturnType<typeof useUpdateProfileNameMutation>;
export type UpdateProfileNameMutationResult = Apollo.MutationResult<UpdateProfileNameMutation>;
export type UpdateProfileNameMutationOptions = Apollo.BaseMutationOptions<UpdateProfileNameMutation, UpdateProfileNameMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation updateProject($id: String!, $input: ProjectInput!) {
  updateProject(projectId: $id, params: $input)
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectShowCommonPageDocument = gql`
    mutation updateProjectShowCommonPage($projectId: String!, $params: ProjectShowCommonPageInput!) {
  updateProjectShowCommonPage(projectId: $projectId, params: $params)
}
    `;
export type UpdateProjectShowCommonPageMutationFn = Apollo.MutationFunction<UpdateProjectShowCommonPageMutation, UpdateProjectShowCommonPageMutationVariables>;

/**
 * __useUpdateProjectShowCommonPageMutation__
 *
 * To run a mutation, you first call `useUpdateProjectShowCommonPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectShowCommonPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectShowCommonPageMutation, { data, loading, error }] = useUpdateProjectShowCommonPageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateProjectShowCommonPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectShowCommonPageMutation, UpdateProjectShowCommonPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectShowCommonPageMutation, UpdateProjectShowCommonPageMutationVariables>(UpdateProjectShowCommonPageDocument, options);
      }
export type UpdateProjectShowCommonPageMutationHookResult = ReturnType<typeof useUpdateProjectShowCommonPageMutation>;
export type UpdateProjectShowCommonPageMutationResult = Apollo.MutationResult<UpdateProjectShowCommonPageMutation>;
export type UpdateProjectShowCommonPageMutationOptions = Apollo.BaseMutationOptions<UpdateProjectShowCommonPageMutation, UpdateProjectShowCommonPageMutationVariables>;
export const UpdateRoomDocument = gql`
    mutation updateRoom($projectId: String!, $roomId: Int!, $input: RoomInput!) {
  updateRoom(projectId: $projectId, roomId: $roomId, params: $input)
}
    `;
export type UpdateRoomMutationFn = Apollo.MutationFunction<UpdateRoomMutation, UpdateRoomMutationVariables>;

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roomId: // value for 'roomId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomMutation, UpdateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument, options);
      }
export type UpdateRoomMutationHookResult = ReturnType<typeof useUpdateRoomMutation>;
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>;
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const UpdateSamlIdpDocument = gql`
    mutation updateSAMLIdp($companyId: Int!, $identityProviderId: Int!, $params: SAMLIdpInput!) {
  updateSAMLIdp(
    companyId: $companyId
    identityProviderId: $identityProviderId
    params: $params
  )
}
    `;
export type UpdateSamlIdpMutationFn = Apollo.MutationFunction<UpdateSamlIdpMutation, UpdateSamlIdpMutationVariables>;

/**
 * __useUpdateSamlIdpMutation__
 *
 * To run a mutation, you first call `useUpdateSamlIdpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSamlIdpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSamlIdpMutation, { data, loading, error }] = useUpdateSamlIdpMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      identityProviderId: // value for 'identityProviderId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateSamlIdpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSamlIdpMutation, UpdateSamlIdpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSamlIdpMutation, UpdateSamlIdpMutationVariables>(UpdateSamlIdpDocument, options);
      }
export type UpdateSamlIdpMutationHookResult = ReturnType<typeof useUpdateSamlIdpMutation>;
export type UpdateSamlIdpMutationResult = Apollo.MutationResult<UpdateSamlIdpMutation>;
export type UpdateSamlIdpMutationOptions = Apollo.BaseMutationOptions<UpdateSamlIdpMutation, UpdateSamlIdpMutationVariables>;
export const UpdateUserCompanyRolesDocument = gql`
    mutation UpdateUserCompanyRoles($userId: Int!, $params: UpdateCompanyRolesInput!) {
  updateUserCompanyRoles(userId: $userId, params: $params)
}
    `;
export type UpdateUserCompanyRolesMutationFn = Apollo.MutationFunction<UpdateUserCompanyRolesMutation, UpdateUserCompanyRolesMutationVariables>;

/**
 * __useUpdateUserCompanyRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserCompanyRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCompanyRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCompanyRolesMutation, { data, loading, error }] = useUpdateUserCompanyRolesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateUserCompanyRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCompanyRolesMutation, UpdateUserCompanyRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCompanyRolesMutation, UpdateUserCompanyRolesMutationVariables>(UpdateUserCompanyRolesDocument, options);
      }
export type UpdateUserCompanyRolesMutationHookResult = ReturnType<typeof useUpdateUserCompanyRolesMutation>;
export type UpdateUserCompanyRolesMutationResult = Apollo.MutationResult<UpdateUserCompanyRolesMutation>;
export type UpdateUserCompanyRolesMutationOptions = Apollo.BaseMutationOptions<UpdateUserCompanyRolesMutation, UpdateUserCompanyRolesMutationVariables>;
export const UpdateUserKeywordsDocument = gql`
    mutation UpdateUserKeywords($userId: Int!, $params: UpdateUserKeywordsInput!) {
  updateUserKeywords(userId: $userId, params: $params)
}
    `;
export type UpdateUserKeywordsMutationFn = Apollo.MutationFunction<UpdateUserKeywordsMutation, UpdateUserKeywordsMutationVariables>;

/**
 * __useUpdateUserKeywordsMutation__
 *
 * To run a mutation, you first call `useUpdateUserKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserKeywordsMutation, { data, loading, error }] = useUpdateUserKeywordsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateUserKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserKeywordsMutation, UpdateUserKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserKeywordsMutation, UpdateUserKeywordsMutationVariables>(UpdateUserKeywordsDocument, options);
      }
export type UpdateUserKeywordsMutationHookResult = ReturnType<typeof useUpdateUserKeywordsMutation>;
export type UpdateUserKeywordsMutationResult = Apollo.MutationResult<UpdateUserKeywordsMutation>;
export type UpdateUserKeywordsMutationOptions = Apollo.BaseMutationOptions<UpdateUserKeywordsMutation, UpdateUserKeywordsMutationVariables>;
export const UpdateWorksRoleDocument = gql`
    mutation updateWorksRole($input: UpdateWorksRoleInput!) {
  updateWorksRole(params: $input)
}
    `;
export type UpdateWorksRoleMutationFn = Apollo.MutationFunction<UpdateWorksRoleMutation, UpdateWorksRoleMutationVariables>;

/**
 * __useUpdateWorksRoleMutation__
 *
 * To run a mutation, you first call `useUpdateWorksRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorksRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorksRoleMutation, { data, loading, error }] = useUpdateWorksRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorksRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorksRoleMutation, UpdateWorksRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorksRoleMutation, UpdateWorksRoleMutationVariables>(UpdateWorksRoleDocument, options);
      }
export type UpdateWorksRoleMutationHookResult = ReturnType<typeof useUpdateWorksRoleMutation>;
export type UpdateWorksRoleMutationResult = Apollo.MutationResult<UpdateWorksRoleMutation>;
export type UpdateWorksRoleMutationOptions = Apollo.BaseMutationOptions<UpdateWorksRoleMutation, UpdateWorksRoleMutationVariables>;
export const CheckLoginSettingDocument = gql`
    mutation checkLoginSetting($email: String!) {
  checkLoginSetting(email: $email) {
    isIDPassEnabled
    isSAMLEnabled
    isSuperAdmin
    idpAuthURL
  }
}
    `;
export type CheckLoginSettingMutationFn = Apollo.MutationFunction<CheckLoginSettingMutation, CheckLoginSettingMutationVariables>;

/**
 * __useCheckLoginSettingMutation__
 *
 * To run a mutation, you first call `useCheckLoginSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckLoginSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkLoginSettingMutation, { data, loading, error }] = useCheckLoginSettingMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckLoginSettingMutation(baseOptions?: Apollo.MutationHookOptions<CheckLoginSettingMutation, CheckLoginSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckLoginSettingMutation, CheckLoginSettingMutationVariables>(CheckLoginSettingDocument, options);
      }
export type CheckLoginSettingMutationHookResult = ReturnType<typeof useCheckLoginSettingMutation>;
export type CheckLoginSettingMutationResult = Apollo.MutationResult<CheckLoginSettingMutation>;
export type CheckLoginSettingMutationOptions = Apollo.BaseMutationOptions<CheckLoginSettingMutation, CheckLoginSettingMutationVariables>;
export const CheckUserCancelDetailUsageDocument = gql`
    query checkUserCancelDetailUsage($userCancelDetailId: Int!) {
  userCancelDetailUsageCheck(userCancelDetailId: $userCancelDetailId) {
    usageDetails {
      listingName
      usedIn
    }
  }
}
    `;

/**
 * __useCheckUserCancelDetailUsageQuery__
 *
 * To run a query within a React component, call `useCheckUserCancelDetailUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserCancelDetailUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserCancelDetailUsageQuery({
 *   variables: {
 *      userCancelDetailId: // value for 'userCancelDetailId'
 *   },
 * });
 */
export function useCheckUserCancelDetailUsageQuery(baseOptions: Apollo.QueryHookOptions<CheckUserCancelDetailUsageQuery, CheckUserCancelDetailUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserCancelDetailUsageQuery, CheckUserCancelDetailUsageQueryVariables>(CheckUserCancelDetailUsageDocument, options);
      }
export function useCheckUserCancelDetailUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserCancelDetailUsageQuery, CheckUserCancelDetailUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserCancelDetailUsageQuery, CheckUserCancelDetailUsageQueryVariables>(CheckUserCancelDetailUsageDocument, options);
        }
export type CheckUserCancelDetailUsageQueryHookResult = ReturnType<typeof useCheckUserCancelDetailUsageQuery>;
export type CheckUserCancelDetailUsageLazyQueryHookResult = ReturnType<typeof useCheckUserCancelDetailUsageLazyQuery>;
export type CheckUserCancelDetailUsageQueryResult = Apollo.QueryResult<CheckUserCancelDetailUsageQuery, CheckUserCancelDetailUsageQueryVariables>;
export const CheckUserStageDetailUsageDocument = gql`
    query checkUserStageDetailUsage($userStageDetailId: Int!) {
  userStageDetailUsageCheck(userStageDetailId: $userStageDetailId) {
    usageDetails {
      listingName
      usedIn
    }
  }
}
    `;

/**
 * __useCheckUserStageDetailUsageQuery__
 *
 * To run a query within a React component, call `useCheckUserStageDetailUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserStageDetailUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserStageDetailUsageQuery({
 *   variables: {
 *      userStageDetailId: // value for 'userStageDetailId'
 *   },
 * });
 */
export function useCheckUserStageDetailUsageQuery(baseOptions: Apollo.QueryHookOptions<CheckUserStageDetailUsageQuery, CheckUserStageDetailUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserStageDetailUsageQuery, CheckUserStageDetailUsageQueryVariables>(CheckUserStageDetailUsageDocument, options);
      }
export function useCheckUserStageDetailUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserStageDetailUsageQuery, CheckUserStageDetailUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserStageDetailUsageQuery, CheckUserStageDetailUsageQueryVariables>(CheckUserStageDetailUsageDocument, options);
        }
export type CheckUserStageDetailUsageQueryHookResult = ReturnType<typeof useCheckUserStageDetailUsageQuery>;
export type CheckUserStageDetailUsageLazyQueryHookResult = ReturnType<typeof useCheckUserStageDetailUsageLazyQuery>;
export type CheckUserStageDetailUsageQueryResult = Apollo.QueryResult<CheckUserStageDetailUsageQuery, CheckUserStageDetailUsageQueryVariables>;
export const GetAllRoomSelectRegistrationsDocument = gql`
    query getAllRoomSelectRegistrations($projectId: String!) {
  allRoomSelectRegistrations(projectId: $projectId) {
    rooms {
      id
      selects {
        id
        name
        priority
        selectMasterId
        registeredSelectOption {
          id
          name
          isPaid
          child {
            id
            name
            isPaid
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllRoomSelectRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetAllRoomSelectRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRoomSelectRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRoomSelectRegistrationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllRoomSelectRegistrationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllRoomSelectRegistrationsQuery, GetAllRoomSelectRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRoomSelectRegistrationsQuery, GetAllRoomSelectRegistrationsQueryVariables>(GetAllRoomSelectRegistrationsDocument, options);
      }
export function useGetAllRoomSelectRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRoomSelectRegistrationsQuery, GetAllRoomSelectRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRoomSelectRegistrationsQuery, GetAllRoomSelectRegistrationsQueryVariables>(GetAllRoomSelectRegistrationsDocument, options);
        }
export type GetAllRoomSelectRegistrationsQueryHookResult = ReturnType<typeof useGetAllRoomSelectRegistrationsQuery>;
export type GetAllRoomSelectRegistrationsLazyQueryHookResult = ReturnType<typeof useGetAllRoomSelectRegistrationsLazyQuery>;
export type GetAllRoomSelectRegistrationsQueryResult = Apollo.QueryResult<GetAllRoomSelectRegistrationsQuery, GetAllRoomSelectRegistrationsQueryVariables>;
export const GetAllowedIpsDocument = gql`
    query getAllowedIps {
  allowedIps {
    isIpRestricted
    allowedIps {
      id
      ip
      description
    }
  }
}
    `;

/**
 * __useGetAllowedIpsQuery__
 *
 * To run a query within a React component, call `useGetAllowedIpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedIpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedIpsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllowedIpsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllowedIpsQuery, GetAllowedIpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowedIpsQuery, GetAllowedIpsQueryVariables>(GetAllowedIpsDocument, options);
      }
export function useGetAllowedIpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowedIpsQuery, GetAllowedIpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowedIpsQuery, GetAllowedIpsQueryVariables>(GetAllowedIpsDocument, options);
        }
export type GetAllowedIpsQueryHookResult = ReturnType<typeof useGetAllowedIpsQuery>;
export type GetAllowedIpsLazyQueryHookResult = ReturnType<typeof useGetAllowedIpsLazyQuery>;
export type GetAllowedIpsQueryResult = Apollo.QueryResult<GetAllowedIpsQuery, GetAllowedIpsQueryVariables>;
export const GetApplicationsDocument = gql`
    query getApplications($projectId: String!) {
  applications(projectId: $projectId) {
    applications {
      id
      projectId
      creatorId
      title
      status
      notifiedUserEmails
      workflowId
      applicationSteps {
        id
        label
        stepNumber
        multiApproverCondition
        status
        dueDate
        applicationStepConfirmations {
          id
          confirmerId
          status
          comment
          confirmedAt
          isProxy
        }
      }
      comment
      roomIds
      canceledRoomIds
      isWaitingYourConfirmation
      createdAt
    }
  }
}
    `;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
      }
export function useGetApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
        }
export type GetApplicationsQueryHookResult = ReturnType<typeof useGetApplicationsQuery>;
export type GetApplicationsLazyQueryHookResult = ReturnType<typeof useGetApplicationsLazyQuery>;
export type GetApplicationsQueryResult = Apollo.QueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export const GetCachedRoomsDocument = gql`
    query getCachedRooms($projectId: String!) {
  cachedRooms(projectId: $projectId) {
    rooms {
      id
      name
      priority
      floor
      wingId
      wingName
      roomTypeId
      roomTypeName
      isSelectEnabled
      memo
      selectMasterIds
      registrationDueDatetime
      registrationStatus
      publishApplicationStatus
      isLocked
      isEnableOrderApplication
      isEnableProxySelectRegistration
      isEnableRoomUserRegistration
      isEnableRoomUserDestroy
      isEnableUpdateConfirmationCode
      isEnableSelectEmailInvitation
      isEnablePublishApplication
      isEnableChangeToUnselectable
      isEnableSelectEmailAgreementRequest
      isEnableCancelSelectAgreement
      isEnableCancelPublishApplication
      isEnableCancelOrderApplication
      isEnableExcludeRoomsFromPublishApplication
      isEnableExcludeRoomsFromOrderApplication
      orderApplicationCanceledAt
      orderApplicationCancelComment
      user {
        id
        name
        email
        identification {
          status
          code
        }
        selectEmailSentTimes
        agreementRequestEmailSentTimes
        lastSelectEmailSentAt
        lastAgreementRequestEmailSentAt
      }
      orderApplicationStatus
      adminMemo
      confirmationCode
      source
    }
  }
}
    `;

/**
 * __useGetCachedRoomsQuery__
 *
 * To run a query within a React component, call `useGetCachedRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCachedRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCachedRoomsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCachedRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetCachedRoomsQuery, GetCachedRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCachedRoomsQuery, GetCachedRoomsQueryVariables>(GetCachedRoomsDocument, options);
      }
export function useGetCachedRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCachedRoomsQuery, GetCachedRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCachedRoomsQuery, GetCachedRoomsQueryVariables>(GetCachedRoomsDocument, options);
        }
export type GetCachedRoomsQueryHookResult = ReturnType<typeof useGetCachedRoomsQuery>;
export type GetCachedRoomsLazyQueryHookResult = ReturnType<typeof useGetCachedRoomsLazyQuery>;
export type GetCachedRoomsQueryResult = Apollo.QueryResult<GetCachedRoomsQuery, GetCachedRoomsQueryVariables>;
export const GetCommonPageDocument = gql`
    query getCommonPage($id: Int!) {
  commonPage(id: $id) {
    id
    name
    priority
    annotation
    meta {
      isPublic
      displayConsumer
      designFormat
      icon
    }
    assets {
      id
      name
      category
      priority
      fileSize
      externalLink
      meta {
        fileName
        uploadedAt
        UploadedWorksUserBy
      }
      data {
        url
        thumbUrl
      }
    }
  }
}
    `;

/**
 * __useGetCommonPageQuery__
 *
 * To run a query within a React component, call `useGetCommonPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommonPageQuery(baseOptions: Apollo.QueryHookOptions<GetCommonPageQuery, GetCommonPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonPageQuery, GetCommonPageQueryVariables>(GetCommonPageDocument, options);
      }
export function useGetCommonPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonPageQuery, GetCommonPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonPageQuery, GetCommonPageQueryVariables>(GetCommonPageDocument, options);
        }
export type GetCommonPageQueryHookResult = ReturnType<typeof useGetCommonPageQuery>;
export type GetCommonPageLazyQueryHookResult = ReturnType<typeof useGetCommonPageLazyQuery>;
export type GetCommonPageQueryResult = Apollo.QueryResult<GetCommonPageQuery, GetCommonPageQueryVariables>;
export const GetCommonPagesDocument = gql`
    query getCommonPages {
  commonPages {
    commonPages {
      id
      name
      priority
      annotation
      meta {
        isPublic
        displayConsumer
        designFormat
        icon
      }
      assets {
        id
        name
        category
        priority
        fileSize
        externalLink
        meta {
          fileName
          uploadedAt
          UploadedWorksUserBy
        }
        data {
          url
          thumbUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommonPagesQuery__
 *
 * To run a query within a React component, call `useGetCommonPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommonPagesQuery(baseOptions?: Apollo.QueryHookOptions<GetCommonPagesQuery, GetCommonPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonPagesQuery, GetCommonPagesQueryVariables>(GetCommonPagesDocument, options);
      }
export function useGetCommonPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonPagesQuery, GetCommonPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonPagesQuery, GetCommonPagesQueryVariables>(GetCommonPagesDocument, options);
        }
export type GetCommonPagesQueryHookResult = ReturnType<typeof useGetCommonPagesQuery>;
export type GetCommonPagesLazyQueryHookResult = ReturnType<typeof useGetCommonPagesLazyQuery>;
export type GetCommonPagesQueryResult = Apollo.QueryResult<GetCommonPagesQuery, GetCommonPagesQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany {
  company {
    id
    name
    isIDPassEnabled
    isSAMLEnabled
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const CompanyRolesDocument = gql`
    query companyRoles {
  companyRoles {
    roles {
      id
      name
      policyIds
      users {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCompanyRolesQuery__
 *
 * To run a query within a React component, call `useCompanyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyRolesQuery(baseOptions?: Apollo.QueryHookOptions<CompanyRolesQuery, CompanyRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyRolesQuery, CompanyRolesQueryVariables>(CompanyRolesDocument, options);
      }
export function useCompanyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyRolesQuery, CompanyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyRolesQuery, CompanyRolesQueryVariables>(CompanyRolesDocument, options);
        }
export type CompanyRolesQueryHookResult = ReturnType<typeof useCompanyRolesQuery>;
export type CompanyRolesLazyQueryHookResult = ReturnType<typeof useCompanyRolesLazyQuery>;
export type CompanyRolesQueryResult = Apollo.QueryResult<CompanyRolesQuery, CompanyRolesQueryVariables>;
export const GetCompassRolesDocument = gql`
    query getCompassRoles {
  compassRoles {
    compassRoles {
      id
      name
      displayName
      priority
    }
  }
}
    `;

/**
 * __useGetCompassRolesQuery__
 *
 * To run a query within a React component, call `useGetCompassRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompassRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompassRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompassRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompassRolesQuery, GetCompassRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompassRolesQuery, GetCompassRolesQueryVariables>(GetCompassRolesDocument, options);
      }
export function useGetCompassRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompassRolesQuery, GetCompassRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompassRolesQuery, GetCompassRolesQueryVariables>(GetCompassRolesDocument, options);
        }
export type GetCompassRolesQueryHookResult = ReturnType<typeof useGetCompassRolesQuery>;
export type GetCompassRolesLazyQueryHookResult = ReturnType<typeof useGetCompassRolesLazyQuery>;
export type GetCompassRolesQueryResult = Apollo.QueryResult<GetCompassRolesQuery, GetCompassRolesQueryVariables>;
export const GetCustomerProjectsDocument = gql`
    query getCustomerProjects($email: String!) {
  customerProjects(email: $email) {
    customerProjects {
      id
      title
      projectCustomerName
      createdAt
      currentSignInAt
      inviterName
      isRoomIamUser
      roomNames
    }
  }
}
    `;

/**
 * __useGetCustomerProjectsQuery__
 *
 * To run a query within a React component, call `useGetCustomerProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProjectsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetCustomerProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerProjectsQuery, GetCustomerProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerProjectsQuery, GetCustomerProjectsQueryVariables>(GetCustomerProjectsDocument, options);
      }
export function useGetCustomerProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerProjectsQuery, GetCustomerProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerProjectsQuery, GetCustomerProjectsQueryVariables>(GetCustomerProjectsDocument, options);
        }
export type GetCustomerProjectsQueryHookResult = ReturnType<typeof useGetCustomerProjectsQuery>;
export type GetCustomerProjectsLazyQueryHookResult = ReturnType<typeof useGetCustomerProjectsLazyQuery>;
export type GetCustomerProjectsQueryResult = Apollo.QueryResult<GetCustomerProjectsQuery, GetCustomerProjectsQueryVariables>;
export const GetDiffRoomsDocument = gql`
    query getDiffRooms($projectId: String!) {
  diffRooms(projectId: $projectId) {
    rooms {
      room {
        id
        name
        priority
        floor
        wingId
        wingName
        roomTypeId
        roomTypeName
        isSelectEnabled
        memo
        selectMasterIds
        registrationDueDatetime
        registrationStatus
        publishApplicationStatus
        isLocked
        isEnableOrderApplication
        isEnableProxySelectRegistration
        isEnableRoomUserRegistration
        isEnableRoomUserDestroy
        isEnableUpdateConfirmationCode
        isEnableSelectEmailInvitation
        isEnablePublishApplication
        isEnableChangeToUnselectable
        isEnableSelectEmailAgreementRequest
        isEnableCancelSelectAgreement
        isEnableCancelPublishApplication
        isEnableCancelOrderApplication
        isEnableExcludeRoomsFromPublishApplication
        isEnableExcludeRoomsFromOrderApplication
        orderApplicationCanceledAt
        orderApplicationCancelComment
        user {
          id
          name
          email
          identification {
            status
            code
          }
          selectEmailSentTimes
          agreementRequestEmailSentTimes
          lastSelectEmailSentAt
          lastAgreementRequestEmailSentAt
        }
        orderApplicationStatus
        adminMemo
        confirmationCode
        source
      }
      type
    }
  }
}
    `;

/**
 * __useGetDiffRoomsQuery__
 *
 * To run a query within a React component, call `useGetDiffRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiffRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiffRoomsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDiffRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetDiffRoomsQuery, GetDiffRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiffRoomsQuery, GetDiffRoomsQueryVariables>(GetDiffRoomsDocument, options);
      }
export function useGetDiffRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiffRoomsQuery, GetDiffRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiffRoomsQuery, GetDiffRoomsQueryVariables>(GetDiffRoomsDocument, options);
        }
export type GetDiffRoomsQueryHookResult = ReturnType<typeof useGetDiffRoomsQuery>;
export type GetDiffRoomsLazyQueryHookResult = ReturnType<typeof useGetDiffRoomsLazyQuery>;
export type GetDiffRoomsQueryResult = Apollo.QueryResult<GetDiffRoomsQuery, GetDiffRoomsQueryVariables>;
export const GetEmailDomainsDocument = gql`
    query getEmailDomains {
  emailDomains {
    emailDomains {
      id
      allowedDomain
    }
  }
}
    `;

/**
 * __useGetEmailDomainsQuery__
 *
 * To run a query within a React component, call `useGetEmailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>(GetEmailDomainsDocument, options);
      }
export function useGetEmailDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>(GetEmailDomainsDocument, options);
        }
export type GetEmailDomainsQueryHookResult = ReturnType<typeof useGetEmailDomainsQuery>;
export type GetEmailDomainsLazyQueryHookResult = ReturnType<typeof useGetEmailDomainsLazyQuery>;
export type GetEmailDomainsQueryResult = Apollo.QueryResult<GetEmailDomainsQuery, GetEmailDomainsQueryVariables>;
export const GetExternalUserDocument = gql`
    query getExternalUser($userId: Int!) {
  externalUser(id: $userId) {
    user {
      id
      name
      email
      projects {
        id
        title
        adminUrl
        presentationUrl
        role {
          id
          name
          displayName
          priority
        }
        status {
          name
          displayName
          priority
        }
        isDeleting
        isWorksManaged
        assignedAt
      }
      keywords
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetExternalUserQuery__
 *
 * To run a query within a React component, call `useGetExternalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetExternalUserQuery(baseOptions: Apollo.QueryHookOptions<GetExternalUserQuery, GetExternalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalUserQuery, GetExternalUserQueryVariables>(GetExternalUserDocument, options);
      }
export function useGetExternalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalUserQuery, GetExternalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalUserQuery, GetExternalUserQueryVariables>(GetExternalUserDocument, options);
        }
export type GetExternalUserQueryHookResult = ReturnType<typeof useGetExternalUserQuery>;
export type GetExternalUserLazyQueryHookResult = ReturnType<typeof useGetExternalUserLazyQuery>;
export type GetExternalUserQueryResult = Apollo.QueryResult<GetExternalUserQuery, GetExternalUserQueryVariables>;
export const GetExternalUsersDocument = gql`
    query getExternalUsers {
  externalUsers {
    users {
      id
      email
      name
      keywords
      createdAt
      projectCount
    }
    pagination {
      current
      previous
      next
      limitValue
      pageCount
      totalCount
    }
  }
}
    `;

/**
 * __useGetExternalUsersQuery__
 *
 * To run a query within a React component, call `useGetExternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalUsersQuery, GetExternalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalUsersQuery, GetExternalUsersQueryVariables>(GetExternalUsersDocument, options);
      }
export function useGetExternalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalUsersQuery, GetExternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalUsersQuery, GetExternalUsersQueryVariables>(GetExternalUsersDocument, options);
        }
export type GetExternalUsersQueryHookResult = ReturnType<typeof useGetExternalUsersQuery>;
export type GetExternalUsersLazyQueryHookResult = ReturnType<typeof useGetExternalUsersLazyQuery>;
export type GetExternalUsersQueryResult = Apollo.QueryResult<GetExternalUsersQuery, GetExternalUsersQueryVariables>;
export const GetGroupingRoomsDocument = gql`
    query getGroupingRooms($projectId: String!) {
  groupingRooms(projectId: $projectId) {
    rooms {
      id
      groupingKey
    }
  }
}
    `;

/**
 * __useGetGroupingRoomsQuery__
 *
 * To run a query within a React component, call `useGetGroupingRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupingRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupingRoomsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetGroupingRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupingRoomsQuery, GetGroupingRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupingRoomsQuery, GetGroupingRoomsQueryVariables>(GetGroupingRoomsDocument, options);
      }
export function useGetGroupingRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupingRoomsQuery, GetGroupingRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupingRoomsQuery, GetGroupingRoomsQueryVariables>(GetGroupingRoomsDocument, options);
        }
export type GetGroupingRoomsQueryHookResult = ReturnType<typeof useGetGroupingRoomsQuery>;
export type GetGroupingRoomsLazyQueryHookResult = ReturnType<typeof useGetGroupingRoomsLazyQuery>;
export type GetGroupingRoomsQueryResult = Apollo.QueryResult<GetGroupingRoomsQuery, GetGroupingRoomsQueryVariables>;
export const GetLatestImportOptOutJobDocument = gql`
    query getLatestImportOptOutJob {
  latestImportOptoutJob {
    jobId
    status
    rowCount
    failedError
    partFailedError {
      row
      message
    }
    updatedAt
    partFailedTotalCount
    partFailedNormalErrorCount
    partFailedAbnormalErrorCount
  }
}
    `;

/**
 * __useGetLatestImportOptOutJobQuery__
 *
 * To run a query within a React component, call `useGetLatestImportOptOutJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestImportOptOutJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestImportOptOutJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestImportOptOutJobQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestImportOptOutJobQuery, GetLatestImportOptOutJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestImportOptOutJobQuery, GetLatestImportOptOutJobQueryVariables>(GetLatestImportOptOutJobDocument, options);
      }
export function useGetLatestImportOptOutJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestImportOptOutJobQuery, GetLatestImportOptOutJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestImportOptOutJobQuery, GetLatestImportOptOutJobQueryVariables>(GetLatestImportOptOutJobDocument, options);
        }
export type GetLatestImportOptOutJobQueryHookResult = ReturnType<typeof useGetLatestImportOptOutJobQuery>;
export type GetLatestImportOptOutJobLazyQueryHookResult = ReturnType<typeof useGetLatestImportOptOutJobLazyQuery>;
export type GetLatestImportOptOutJobQueryResult = Apollo.QueryResult<GetLatestImportOptOutJobQuery, GetLatestImportOptOutJobQueryVariables>;
export const GetLatestImportRoomUsersJobDocument = gql`
    query getLatestImportRoomUsersJob {
  latestImportRoomUsersJob {
    jobId
    status
    lineCount
    updatedAt
    errorMessage
    errorDetails {
      line
      message
    }
    errorReportS3Url
  }
}
    `;

/**
 * __useGetLatestImportRoomUsersJobQuery__
 *
 * To run a query within a React component, call `useGetLatestImportRoomUsersJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestImportRoomUsersJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestImportRoomUsersJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestImportRoomUsersJobQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestImportRoomUsersJobQuery, GetLatestImportRoomUsersJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestImportRoomUsersJobQuery, GetLatestImportRoomUsersJobQueryVariables>(GetLatestImportRoomUsersJobDocument, options);
      }
export function useGetLatestImportRoomUsersJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestImportRoomUsersJobQuery, GetLatestImportRoomUsersJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestImportRoomUsersJobQuery, GetLatestImportRoomUsersJobQueryVariables>(GetLatestImportRoomUsersJobDocument, options);
        }
export type GetLatestImportRoomUsersJobQueryHookResult = ReturnType<typeof useGetLatestImportRoomUsersJobQuery>;
export type GetLatestImportRoomUsersJobLazyQueryHookResult = ReturnType<typeof useGetLatestImportRoomUsersJobLazyQuery>;
export type GetLatestImportRoomUsersJobQueryResult = Apollo.QueryResult<GetLatestImportRoomUsersJobQuery, GetLatestImportRoomUsersJobQueryVariables>;
export const GetMasterDataDocument = gql`
    query getMasterData {
  masterData {
    worksRoles {
      id
      name
      displayName
    }
    companyPolicies {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useGetMasterDataQuery__
 *
 * To run a query within a React component, call `useGetMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMasterDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterDataQuery, GetMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterDataQuery, GetMasterDataQueryVariables>(GetMasterDataDocument, options);
      }
export function useGetMasterDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterDataQuery, GetMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterDataQuery, GetMasterDataQueryVariables>(GetMasterDataDocument, options);
        }
export type GetMasterDataQueryHookResult = ReturnType<typeof useGetMasterDataQuery>;
export type GetMasterDataLazyQueryHookResult = ReturnType<typeof useGetMasterDataLazyQuery>;
export type GetMasterDataQueryResult = Apollo.QueryResult<GetMasterDataQuery, GetMasterDataQueryVariables>;
export const GetMyReviewingConfirmationsDocument = gql`
    query getMyReviewingConfirmations {
  myReviewingConfirmations {
    confirmations {
      id
      applicationId
      projectId
      projectName
      applicationWorkflowName
      applicationType
      applicationTitle
      applicationCreatorId
      applicationCreatedAt
      dueDate
    }
  }
}
    `;

/**
 * __useGetMyReviewingConfirmationsQuery__
 *
 * To run a query within a React component, call `useGetMyReviewingConfirmationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyReviewingConfirmationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyReviewingConfirmationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyReviewingConfirmationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyReviewingConfirmationsQuery, GetMyReviewingConfirmationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyReviewingConfirmationsQuery, GetMyReviewingConfirmationsQueryVariables>(GetMyReviewingConfirmationsDocument, options);
      }
export function useGetMyReviewingConfirmationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyReviewingConfirmationsQuery, GetMyReviewingConfirmationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyReviewingConfirmationsQuery, GetMyReviewingConfirmationsQueryVariables>(GetMyReviewingConfirmationsDocument, options);
        }
export type GetMyReviewingConfirmationsQueryHookResult = ReturnType<typeof useGetMyReviewingConfirmationsQuery>;
export type GetMyReviewingConfirmationsLazyQueryHookResult = ReturnType<typeof useGetMyReviewingConfirmationsLazyQuery>;
export type GetMyReviewingConfirmationsQueryResult = Apollo.QueryResult<GetMyReviewingConfirmationsQuery, GetMyReviewingConfirmationsQueryVariables>;
export const GetOgpImageDocument = gql`
    query getOgpImage($url: String!) {
  ogpImage(url: $url) {
    url
  }
}
    `;

/**
 * __useGetOgpImageQuery__
 *
 * To run a query within a React component, call `useGetOgpImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOgpImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOgpImageQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetOgpImageQuery(baseOptions: Apollo.QueryHookOptions<GetOgpImageQuery, GetOgpImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOgpImageQuery, GetOgpImageQueryVariables>(GetOgpImageDocument, options);
      }
export function useGetOgpImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOgpImageQuery, GetOgpImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOgpImageQuery, GetOgpImageQueryVariables>(GetOgpImageDocument, options);
        }
export type GetOgpImageQueryHookResult = ReturnType<typeof useGetOgpImageQuery>;
export type GetOgpImageLazyQueryHookResult = ReturnType<typeof useGetOgpImageLazyQuery>;
export type GetOgpImageQueryResult = Apollo.QueryResult<GetOgpImageQuery, GetOgpImageQueryVariables>;
export const ProfileDocument = gql`
    query profile {
  profile {
    user {
      id
      name
      email
      roleId
      role {
        id
        name
        displayName
      }
      projects {
        id
        title
        adminUrl
        presentationUrl
        role {
          id
          name
          displayName
          priority
        }
        status {
          name
          displayName
          priority
        }
        isDeleting
        isWorksManaged
        assignedAt
      }
      isResetPassword
      keywords
      policies
      companyRoles {
        id
        name
        policyIds
      }
      companyPolicies {
        id
        name
        displayName
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const GetProjectDocument = gql`
    query getProject($input: String!) {
  project(id: $input) {
    project {
      id
      title
      code
      status {
        name
        displayName
        priority
      }
      zipcode
      prefecture
      city
      address
      structureCount
      roomCount
      planCount
      averagePriceRange
      purchaserCount
      applicationCount
      totalPvCount
      totalSessionCount
      email
      emailDisplayName
      users {
        id
        name
        email
        role {
          id
          name
          displayName
          priority
        }
        isExternal
        assignedAt
        keywords
        companyRoles {
          id
          name
          policyIds
        }
      }
      mainContents {
        id
        name
      }
      adminUrl
      presentationUrl
      isWorksManaged
      showCommonPage
      isDeleting
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectStatusesDocument = gql`
    query getProjectStatuses {
  projectStatuses {
    projectStatuses {
      name
      displayName
      priority
    }
  }
}
    `;

/**
 * __useGetProjectStatusesQuery__
 *
 * To run a query within a React component, call `useGetProjectStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectStatusesQuery, GetProjectStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectStatusesQuery, GetProjectStatusesQueryVariables>(GetProjectStatusesDocument, options);
      }
export function useGetProjectStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectStatusesQuery, GetProjectStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectStatusesQuery, GetProjectStatusesQueryVariables>(GetProjectStatusesDocument, options);
        }
export type GetProjectStatusesQueryHookResult = ReturnType<typeof useGetProjectStatusesQuery>;
export type GetProjectStatusesLazyQueryHookResult = ReturnType<typeof useGetProjectStatusesLazyQuery>;
export type GetProjectStatusesQueryResult = Apollo.QueryResult<GetProjectStatusesQuery, GetProjectStatusesQueryVariables>;
export const GetProjectSummaryDocument = gql`
    query getProjectSummary {
  projectSummary {
    projectCountHistories {
      month
      activatedCount
    }
  }
}
    `;

/**
 * __useGetProjectSummaryQuery__
 *
 * To run a query within a React component, call `useGetProjectSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectSummaryQuery, GetProjectSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSummaryQuery, GetProjectSummaryQueryVariables>(GetProjectSummaryDocument, options);
      }
export function useGetProjectSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSummaryQuery, GetProjectSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSummaryQuery, GetProjectSummaryQueryVariables>(GetProjectSummaryDocument, options);
        }
export type GetProjectSummaryQueryHookResult = ReturnType<typeof useGetProjectSummaryQuery>;
export type GetProjectSummaryLazyQueryHookResult = ReturnType<typeof useGetProjectSummaryLazyQuery>;
export type GetProjectSummaryQueryResult = Apollo.QueryResult<GetProjectSummaryQuery, GetProjectSummaryQueryVariables>;
export const GetProjectsDocument = gql`
    query getProjects {
  projects {
    projects {
      id
      title
      code
      status {
        name
        displayName
        priority
      }
      prefecture
      creator {
        id
        name
      }
      structureCount
      roomCount
      planCount
      averagePriceRange
      purchaserCount
      applicationCount
      adminUrl
      presentationUrl
      isWorksManaged
      isDeleting
      createdAt
      updatedAt
    }
    pagination {
      current
      previous
      next
      limitValue
      pageCount
      totalCount
    }
  }
}
    `;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetRoomSelectMastersDocument = gql`
    query getRoomSelectMasters($projectId: String!, $roomId: Int!) {
  roomSelectMasters(projectId: $projectId, roomId: $roomId) {
    selectMasters {
      id
      selectOptionMasterIds
    }
  }
}
    `;

/**
 * __useGetRoomSelectMastersQuery__
 *
 * To run a query within a React component, call `useGetRoomSelectMastersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomSelectMastersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomSelectMastersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetRoomSelectMastersQuery(baseOptions: Apollo.QueryHookOptions<GetRoomSelectMastersQuery, GetRoomSelectMastersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomSelectMastersQuery, GetRoomSelectMastersQueryVariables>(GetRoomSelectMastersDocument, options);
      }
export function useGetRoomSelectMastersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomSelectMastersQuery, GetRoomSelectMastersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomSelectMastersQuery, GetRoomSelectMastersQueryVariables>(GetRoomSelectMastersDocument, options);
        }
export type GetRoomSelectMastersQueryHookResult = ReturnType<typeof useGetRoomSelectMastersQuery>;
export type GetRoomSelectMastersLazyQueryHookResult = ReturnType<typeof useGetRoomSelectMastersLazyQuery>;
export type GetRoomSelectMastersQueryResult = Apollo.QueryResult<GetRoomSelectMastersQuery, GetRoomSelectMastersQueryVariables>;
export const GetRoomSelectRegistrationsDocument = gql`
    query getRoomSelectRegistrations($projectId: String!, $roomIds: [Int!]!) {
  roomSelectRegistrations(projectId: $projectId, roomIds: $roomIds) {
    rooms {
      id
      selects {
        id
        name
        priority
        selectMasterId
        registeredSelectOption {
          id
          name
          isPaid
          child {
            id
            name
            isPaid
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRoomSelectRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetRoomSelectRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomSelectRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomSelectRegistrationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roomIds: // value for 'roomIds'
 *   },
 * });
 */
export function useGetRoomSelectRegistrationsQuery(baseOptions: Apollo.QueryHookOptions<GetRoomSelectRegistrationsQuery, GetRoomSelectRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomSelectRegistrationsQuery, GetRoomSelectRegistrationsQueryVariables>(GetRoomSelectRegistrationsDocument, options);
      }
export function useGetRoomSelectRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomSelectRegistrationsQuery, GetRoomSelectRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomSelectRegistrationsQuery, GetRoomSelectRegistrationsQueryVariables>(GetRoomSelectRegistrationsDocument, options);
        }
export type GetRoomSelectRegistrationsQueryHookResult = ReturnType<typeof useGetRoomSelectRegistrationsQuery>;
export type GetRoomSelectRegistrationsLazyQueryHookResult = ReturnType<typeof useGetRoomSelectRegistrationsLazyQuery>;
export type GetRoomSelectRegistrationsQueryResult = Apollo.QueryResult<GetRoomSelectRegistrationsQuery, GetRoomSelectRegistrationsQueryVariables>;
export const GetRoomTypesDocument = gql`
    query getRoomTypes($projectId: String!) {
  roomTypes(projectId: $projectId) {
    roomTypes {
      id
      name
      priority
      worksRoomIds
      compassRoomCount
    }
  }
}
    `;

/**
 * __useGetRoomTypesQuery__
 *
 * To run a query within a React component, call `useGetRoomTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomTypesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRoomTypesQuery(baseOptions: Apollo.QueryHookOptions<GetRoomTypesQuery, GetRoomTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomTypesQuery, GetRoomTypesQueryVariables>(GetRoomTypesDocument, options);
      }
export function useGetRoomTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomTypesQuery, GetRoomTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomTypesQuery, GetRoomTypesQueryVariables>(GetRoomTypesDocument, options);
        }
export type GetRoomTypesQueryHookResult = ReturnType<typeof useGetRoomTypesQuery>;
export type GetRoomTypesLazyQueryHookResult = ReturnType<typeof useGetRoomTypesLazyQuery>;
export type GetRoomTypesQueryResult = Apollo.QueryResult<GetRoomTypesQuery, GetRoomTypesQueryVariables>;
export const GetRoomsDocument = gql`
    query getRooms($projectId: String!) {
  rooms(projectId: $projectId) {
    rooms {
      id
      name
      priority
      floor
      wingId
      wingName
      roomTypeId
      roomTypeName
      isSelectEnabled
      memo
      selectMasterIds
      registrationDueDatetime
      registrationStatus
      publishApplicationStatus
      isLocked
      isEnableOrderApplication
      isEnableProxySelectRegistration
      isEnableRoomUserRegistration
      isEnableRoomUserDestroy
      isEnableUpdateConfirmationCode
      isEnableSelectEmailInvitation
      isEnablePublishApplication
      isEnableChangeToUnselectable
      isEnableSelectEmailAgreementRequest
      isEnableCancelSelectAgreement
      isEnableCancelPublishApplication
      isEnableCancelOrderApplication
      isEnableExcludeRoomsFromPublishApplication
      isEnableExcludeRoomsFromOrderApplication
      orderApplicationCanceledAt
      orderApplicationCancelComment
      user {
        id
        name
        email
        identification {
          status
          code
        }
        selectEmailSentTimes
        agreementRequestEmailSentTimes
        lastSelectEmailSentAt
        lastAgreementRequestEmailSentAt
      }
      orderApplicationStatus
      adminMemo
      confirmationCode
    }
  }
}
    `;

/**
 * __useGetRoomsQuery__
 *
 * To run a query within a React component, call `useGetRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetRoomsQuery, GetRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomsQuery, GetRoomsQueryVariables>(GetRoomsDocument, options);
      }
export function useGetRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomsQuery, GetRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomsQuery, GetRoomsQueryVariables>(GetRoomsDocument, options);
        }
export type GetRoomsQueryHookResult = ReturnType<typeof useGetRoomsQuery>;
export type GetRoomsLazyQueryHookResult = ReturnType<typeof useGetRoomsLazyQuery>;
export type GetRoomsQueryResult = Apollo.QueryResult<GetRoomsQuery, GetRoomsQueryVariables>;
export const SamlIdpDocument = gql`
    query samlIdp {
  samlIdp {
    samlIdp {
      id
      idpSignout
      metadataFile
      metadataFileName
      metadataURL
      attributeMapping {
        email
        name
        department
      }
    }
    assertionConsumerServiceURL
    serviceProviderURN
  }
}
    `;

/**
 * __useSamlIdpQuery__
 *
 * To run a query within a React component, call `useSamlIdpQuery` and pass it any options that fit your needs.
 * When your component renders, `useSamlIdpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSamlIdpQuery({
 *   variables: {
 *   },
 * });
 */
export function useSamlIdpQuery(baseOptions?: Apollo.QueryHookOptions<SamlIdpQuery, SamlIdpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SamlIdpQuery, SamlIdpQueryVariables>(SamlIdpDocument, options);
      }
export function useSamlIdpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SamlIdpQuery, SamlIdpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SamlIdpQuery, SamlIdpQueryVariables>(SamlIdpDocument, options);
        }
export type SamlIdpQueryHookResult = ReturnType<typeof useSamlIdpQuery>;
export type SamlIdpLazyQueryHookResult = ReturnType<typeof useSamlIdpLazyQuery>;
export type SamlIdpQueryResult = Apollo.QueryResult<SamlIdpQuery, SamlIdpQueryVariables>;
export const GetContractorHistoriesDocument = gql`
    query getContractorHistories($roomId: Int!) {
  selectContractorHistories(roomId: $roomId) {
    histories {
      timestamp
      actor {
        id
        name
        type
        companyRoleNames
      }
      action
    }
  }
}
    `;

/**
 * __useGetContractorHistoriesQuery__
 *
 * To run a query within a React component, call `useGetContractorHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorHistoriesQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetContractorHistoriesQuery(baseOptions: Apollo.QueryHookOptions<GetContractorHistoriesQuery, GetContractorHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractorHistoriesQuery, GetContractorHistoriesQueryVariables>(GetContractorHistoriesDocument, options);
      }
export function useGetContractorHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractorHistoriesQuery, GetContractorHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractorHistoriesQuery, GetContractorHistoriesQueryVariables>(GetContractorHistoriesDocument, options);
        }
export type GetContractorHistoriesQueryHookResult = ReturnType<typeof useGetContractorHistoriesQuery>;
export type GetContractorHistoriesLazyQueryHookResult = ReturnType<typeof useGetContractorHistoriesLazyQuery>;
export type GetContractorHistoriesQueryResult = Apollo.QueryResult<GetContractorHistoriesQuery, GetContractorHistoriesQueryVariables>;
export const GetSelectMastersDocument = gql`
    query getSelectMasters($projectId: String!) {
  selectMasters(projectId: $projectId) {
    selectMasters {
      id
      name
      priority
      displayName
      description
      modelRoomInfo
      annotation
      file {
        url
        thumb {
          url
        }
      }
      fileName
      assignments {
        mainContents
      }
      isPlanSelect
      selectOptionMasters {
        id
        name
        annotation
        isPaid
        priority
        file {
          url
          thumb {
            url
          }
        }
        fileName
        children {
          id
          name
          annotation
          isPaid
          priority
          file {
            url
            thumb {
              url
            }
          }
          fileName
        }
      }
      roomIds
    }
  }
}
    `;

/**
 * __useGetSelectMastersQuery__
 *
 * To run a query within a React component, call `useGetSelectMastersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectMastersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectMastersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSelectMastersQuery(baseOptions: Apollo.QueryHookOptions<GetSelectMastersQuery, GetSelectMastersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectMastersQuery, GetSelectMastersQueryVariables>(GetSelectMastersDocument, options);
      }
export function useGetSelectMastersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectMastersQuery, GetSelectMastersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectMastersQuery, GetSelectMastersQueryVariables>(GetSelectMastersDocument, options);
        }
export type GetSelectMastersQueryHookResult = ReturnType<typeof useGetSelectMastersQuery>;
export type GetSelectMastersLazyQueryHookResult = ReturnType<typeof useGetSelectMastersLazyQuery>;
export type GetSelectMastersQueryResult = Apollo.QueryResult<GetSelectMastersQuery, GetSelectMastersQueryVariables>;
export const GetSelectRegistrationsDocument = gql`
    query getSelectRegistrations($projectId: String!, $roomId: Int!) {
  selectRegistrations(projectId: $projectId, roomId: $roomId) {
    selectRegistrations {
      id
      name
      priority
      selectMasterId
      registeredSelectOption {
        id
        name
        isPaid
        child {
          id
          name
          isPaid
        }
      }
    }
  }
}
    `;

/**
 * __useGetSelectRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetSelectRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectRegistrationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetSelectRegistrationsQuery(baseOptions: Apollo.QueryHookOptions<GetSelectRegistrationsQuery, GetSelectRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectRegistrationsQuery, GetSelectRegistrationsQueryVariables>(GetSelectRegistrationsDocument, options);
      }
export function useGetSelectRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectRegistrationsQuery, GetSelectRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectRegistrationsQuery, GetSelectRegistrationsQueryVariables>(GetSelectRegistrationsDocument, options);
        }
export type GetSelectRegistrationsQueryHookResult = ReturnType<typeof useGetSelectRegistrationsQuery>;
export type GetSelectRegistrationsLazyQueryHookResult = ReturnType<typeof useGetSelectRegistrationsLazyQuery>;
export type GetSelectRegistrationsQueryResult = Apollo.QueryResult<GetSelectRegistrationsQuery, GetSelectRegistrationsQueryVariables>;
export const GetSelectsDocument = gql`
    query getSelects($projectId: String!, $roomId: Int!) {
  selects(projectId: $projectId, roomId: $roomId) {
    selects {
      id
      priority
      name
      displayName
      description
      modelRoomInfo
      annotation
      selectMasterId
      file {
        url
        thumb {
          url
        }
      }
      assignments {
        mainContents
      }
      isPlanSelect
      selectOptions {
        id
        name
        annotation
        isPaid
        priority
        isSelected
        file {
          url
          thumb {
            url
          }
        }
        children {
          id
          name
          annotation
          isPaid
          priority
          isSelected
          file {
            url
            thumb {
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSelectsQuery__
 *
 * To run a query within a React component, call `useGetSelectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetSelectsQuery(baseOptions: Apollo.QueryHookOptions<GetSelectsQuery, GetSelectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectsQuery, GetSelectsQueryVariables>(GetSelectsDocument, options);
      }
export function useGetSelectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectsQuery, GetSelectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectsQuery, GetSelectsQueryVariables>(GetSelectsDocument, options);
        }
export type GetSelectsQueryHookResult = ReturnType<typeof useGetSelectsQuery>;
export type GetSelectsLazyQueryHookResult = ReturnType<typeof useGetSelectsLazyQuery>;
export type GetSelectsQueryResult = Apollo.QueryResult<GetSelectsQuery, GetSelectsQueryVariables>;
export const GetUserDocument = gql`
    query getUser($userId: Int!) {
  user(id: $userId) {
    user {
      id
      name
      email
      roleId
      role {
        id
        name
        displayName
      }
      projects {
        id
        title
        adminUrl
        presentationUrl
        role {
          id
          name
          displayName
          priority
        }
        status {
          name
          displayName
          priority
        }
        isDeleting
        isWorksManaged
        assignedAt
      }
      isResetPassword
      keywords
      companyRoles {
        id
        name
        policyIds
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserCancelDetailsDocument = gql`
    query getUserCancelDetails {
  userCancelDetails {
    userCancelDetails {
      id
      name
      priority
    }
    meta {
      updatedAt
      updatedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserCancelDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserCancelDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCancelDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCancelDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCancelDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCancelDetailsQuery, GetUserCancelDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCancelDetailsQuery, GetUserCancelDetailsQueryVariables>(GetUserCancelDetailsDocument, options);
      }
export function useGetUserCancelDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCancelDetailsQuery, GetUserCancelDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCancelDetailsQuery, GetUserCancelDetailsQueryVariables>(GetUserCancelDetailsDocument, options);
        }
export type GetUserCancelDetailsQueryHookResult = ReturnType<typeof useGetUserCancelDetailsQuery>;
export type GetUserCancelDetailsLazyQueryHookResult = ReturnType<typeof useGetUserCancelDetailsLazyQuery>;
export type GetUserCancelDetailsQueryResult = Apollo.QueryResult<GetUserCancelDetailsQuery, GetUserCancelDetailsQueryVariables>;
export const UserStageDetailsDocument = gql`
    query userStageDetails {
  userStageDetails {
    userStages {
      id
      stage
      priority
      userStageDetails {
        id
        name
        priority
      }
    }
    meta {
      updatedAt
      updatedBy {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserStageDetailsQuery__
 *
 * To run a query within a React component, call `useUserStageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStageDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStageDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserStageDetailsQuery, UserStageDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStageDetailsQuery, UserStageDetailsQueryVariables>(UserStageDetailsDocument, options);
      }
export function useUserStageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStageDetailsQuery, UserStageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStageDetailsQuery, UserStageDetailsQueryVariables>(UserStageDetailsDocument, options);
        }
export type UserStageDetailsQueryHookResult = ReturnType<typeof useUserStageDetailsQuery>;
export type UserStageDetailsLazyQueryHookResult = ReturnType<typeof useUserStageDetailsLazyQuery>;
export type UserStageDetailsQueryResult = Apollo.QueryResult<UserStageDetailsQuery, UserStageDetailsQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    users {
      id
      name
      email
      keywords
      roleId
      role {
        id
        name
        displayName
      }
      companyRoles {
        id
        name
        policyIds
      }
      isResetPassword
      projectCount
      createdAt
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetWingsDocument = gql`
    query getWings($projectId: String!) {
  wings(projectId: $projectId) {
    wings {
      id
      name
      roomCount
      priority
      roomTypes {
        id
        name
        priority
        worksRoomIds
        compassRoomCount
      }
    }
  }
}
    `;

/**
 * __useGetWingsQuery__
 *
 * To run a query within a React component, call `useGetWingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetWingsQuery(baseOptions: Apollo.QueryHookOptions<GetWingsQuery, GetWingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWingsQuery, GetWingsQueryVariables>(GetWingsDocument, options);
      }
export function useGetWingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWingsQuery, GetWingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWingsQuery, GetWingsQueryVariables>(GetWingsDocument, options);
        }
export type GetWingsQueryHookResult = ReturnType<typeof useGetWingsQuery>;
export type GetWingsLazyQueryHookResult = ReturnType<typeof useGetWingsLazyQuery>;
export type GetWingsQueryResult = Apollo.QueryResult<GetWingsQuery, GetWingsQueryVariables>;
export const GetWorkflowsDocument = gql`
    query getWorkflows {
  workflows {
    workflows {
      id
      name
      type
      notifiedUserEmailsAnnotation
      workflowSteps {
        id
        label
        stepNumber
        primaryRoleIds
        secondaryRoleIds
        isApproverAddable
        multiApproverCondition
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
      }
export function useGetWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
        }
export type GetWorkflowsQueryHookResult = ReturnType<typeof useGetWorkflowsQuery>;
export type GetWorkflowsLazyQueryHookResult = ReturnType<typeof useGetWorkflowsLazyQuery>;
export type GetWorkflowsQueryResult = Apollo.QueryResult<GetWorkflowsQuery, GetWorkflowsQueryVariables>;